import { TabBookingAbstract } from './tabBookingAbstract'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'
import * as CargoOfRoleType from '@/class/cargo/model/parameters/CargoOfRoleType'
import * as OverseaAgentGrade from '@/class/cargo/model/parameters/OverseaAgentGrade'
import * as ContainerLoadType from '@/class/cargo/model/parameters/ContainerLoadType'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'
import { User } from '@/class/model/sys/User'
import { Office } from '@/class/model/sys/Office'
import { WarehouseIn } from '@/class/model/booking/WarehouseIn'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { SopEmailReceiver } from '@/class/model/booking/SopEmailReceiver'
import { TruckingInfo } from '@/class/model/booking/TruckingInfo'
import { WarehouseInfo } from '@/class/model/booking/WarehouseInfo'
import { SopPushConfig } from '@/class/model/sys/SopPushConfig'
import { OverseaAgent } from '@/class/model/sys/OverseaAgent'
import { CreditInfo } from '@/class/model/sys/CreditInfo'
import { Company } from '@/class/model/mdm/Company'
import { Customer } from '@/class/model/mdm/Customer'
import { ClosingAccount } from '@/class/model/act/ClosingAccount'
import { canCreateByCreditInfoDetail } from '@/api/partner/creditInfo'
import { ErrorTip } from '@/utils/class/ErrorTip'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getObjectByCache, getSpecificBasicData } from '@/utils/basicDataCache'
import * as ChargeMeasure from '@/class/cargo/model/parameters/ChargeMeasure'
import ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import StrUtils from '@/utils/StrUtils'
import { dateCompare, dateCompareYMD, ensureExecuteSuccess, mergeArray, multiply } from '@/utils/commonUtil'
import { ContainerUtil } from '@/class/cargo/model/utils/ContainerUtil'
import DateUtils from '@/utils/dateUtils'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { sortByMultiField } from '@/utils'
import { SeaCargoDoc } from '@/class/model/booking/SeaCargoDoc'
import * as BookingTerm from '@/class/cargo/model/parameters/BookingTerm'
import { SeaEQ } from '@/class/model/booking/SeaEQ'
import { AutoContaninerFactory } from '@/class/cargo/model/utils/AutoContaninerFactory'
import { DataPushCompareUtils } from '@/class/cargo/model/utils/DataPushCompareUtils'
import { SEUtils } from '@/class/cargo/model/utils/SEUtils'
import { findBusinessDocument } from '@/api/seaExport/businessDocument'
import { getUserPortByCode } from '@/api/userPort'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import * as BillType from '@/class/cargo/model/parameters/BillType'
import * as ReleaseState from '@/class/cargo/model/parameters/ReleaseState'
import $store from '@/store'
import {
  getBackUpWarehouseCompany,
  getWarehouseDetail,
  wTQueryPageHandler,
  wTSendHandler
} from '@/api/company'
import { getToken } from '@/utils/auth'
import LocalStorageUtils from '@/utils/localStorageUtils'
import { BackUpWarehouseInfo } from '@/class/model/booking/BackUpWarehouseInfo'
import { Job } from '@/class/model/booking/Job'
import { selectWarehouseNoExist } from '@/api/booking/job'
import ColumnUtils from '@/utils/ColumnUtils'
// import { getLoading } from '@/utils/utilBaseElement'
// import { xhqUpdateBillInfo } from '@/api/seaExport/seaCargoDoc'
// import { CFM_BILL_STATE_NEW } from '@/class/cargo/model/parameters/XhqBillCfmState'
// import { SeaImportJob } from '@/class/model/booking/SeaImportJob'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import { CreditInfoUtil } from '@/class/cargo/model/utils/CreditInfoUtil'
import moment from 'moment'
import { BRING_OUT_LOGIC_CALL_SOURCE_OCR, CHARGE_SOURCE_SPLIT } from '@/class/cargo/model/parameters/SystemConstants'
// import { PortDataCompareUtils } from '@/class/cargo/model/utils/PortDataCompareUtils'
import { cache } from '@/utils/cacheManager'
// import { FCL_CARGO_TYPE } from '@/class/cargo/model/parameters/ContainerLoadType'
import { shouldSyncDocHsCodeFromJob } from './seaHsCodeMode'
import { shouldPreserveCopiedCarryingCmp, shouldPreserveCopiedWarehouseCmp } from '../seaBookingCopyConfig'

export class TabBookingFCLPM extends TabBookingAbstract {
  /**
   * @param {Object} view 视图
   */
  constructor(view) {
    super(view)
    this.addrPM = null // 提单地址
    this.chargeWeightCalculationMode = 0 // 录入费用计费数量取值类型
    this.trustFromEditSales = false // 交叉委托编辑销售
    this.isSpecifiedSalesBusiness = false // 是否启用合作伙伴对应的服务人员设置(多销售模式)
    this.customerLockInCargoSource = false // 根据客户锁定揽货类型
    this.sEUseDischargingPort5Code = false // 装箱单是否使用卸港5字码
    this.refSelDesignationAgent = false // 选择目的港代理时是否自动刷新指定货代理
    // this.hblNoConfig = Config.configMap['SEHblNoPattern'] // 海运HBL单号生成规则
    this.billChargeFlag = false // 费用是否做过账单
    this.mblDoc = null // MBL CargoDoc
    this.isClearDestinationAgent = false
    this.dischargingPortIsDirty = true
    this.visibleFreightTerm = false // 是否显示主单运输条款
    this.isWithinCloseAccountDate = false // 关账控制
    this.isCrossTenant = false // 是否跨tenant委托
    this.isShowAcPaymentPlaceBL = false // 是否显示主单付款地点
    this.prompt1TitleWindow = null // 抄录
    this.hsCodeSearchWindow = null // 抄录HsCode
    this.customerContactWindow = null // 联系人信息
    this.selectSurchargeTermsWindow = null // 付费条款
    this.sycSCN = false // 是否同步收发通代码到基本页签
    this.wtOpenConfig = false // 是否开启沃联之家功能
    this.wtPageUrl = '' // 沃联之家页面地址
    this.sopWindow = null
    this.sopConfigOpen = false // SOP总开关
    this.salesUser = null // 当前销售
    this.creditOpen = false // 是否开启信控
    this.branchOfficeCheck = false
    this.salesOfficeCheck = false // 是否按照分公司控制 (1:开启分公司过滤 0:关闭分公司过滤)
    this.destinationAgentArray = [] // 目的港代理下拉框数据源
    this.designationAgentArray = [] // 指定货代理下拉框数据源
    this.loadingAgentIdArray = [] // 起运港代理下拉框数据源
    this.bookingAgentArray = [] // 订舱代理下拉框数据源
    this.formInitialValue = {} // 表单的初始值（用于判断表单字段是否被修改）
    this.syncSignDateBl = 0 // 签发日期实际同步取值(0:ETD;1:ATD)
  }
  get lclslaveEnabled() {
    return this.view.lclslaveEnabled
  }
  set lclslaveEnabled(lclslaveEnabled) {
    this.view.lclslaveEnabled = lclslaveEnabled
  }
  get salesOfficeCheck() {
    return this.view.salesOfficeCheck
  }
  set salesOfficeCheck(salesOfficeCheck) {
    this.view.salesOfficeCheck = salesOfficeCheck
  }
  get branchOfficeCheck() {
    return this.view.branchOfficeCheck
  }
  set branchOfficeCheck(branchOfficeCheck) {
    this.view.branchOfficeCheck = branchOfficeCheck
  }
  get creditOpen() {
    return this.view.creditOpen
  }
  set creditOpen(creditOpen) {
    this.view.creditOpen = creditOpen
  }
  get sopConfigOpen() {
    return this.view.sopConfigOpen
  }
  set sopConfigOpen(sopConfigOpen) {
    this.view.sopConfigOpen = sopConfigOpen
  }
  get job() {
    return this.view.form
  }
  set job(job) {
    this.view.form = job
  }
  init() {
    this.trustFromEditSales = Number(this.config.get('TrustFromEditSales')) === 1
    this.chargeWeightCalculationMode = ChargeUtils.getChargeWeightValueType(true)
    this.isSpecifiedSalesBusiness = Number(this.config.get('IsSpecifiedSalesBusiness')) === 1
    this.customerLockInCargoSource = Number(this.config.get('CustomerLockInCargoSource')) === 1
    this.sEUseDischargingPort5Code = Number(this.config.get('SEUseDischargingPort5Code')) === 1
    this.refSelDesignationAgent = Number(this.config.get('refSelDesignationAgent')) === 1
    this.canChangeSalesOfJob = Number(this.config.get('canChangeSalesOfJob')) === 1
    this.isJoinCarrierBookingAgent = Number(this.config.get('CarrierBookingAgentJoin')) === 1
    this.isJoinPortDestinationAgent = Number(this.config.get('PortDestinationAgentJoin')) === 1
    this.sycSCN = parseInt(this.config.get('synchronousShipperCodeAndConsigneeCodeAndNotifyCode')) === 1
    this.wtOpenConfig = parseInt(this.config.get('wtOpenConfig')) === 1
    this.wtPageUrl = this.config.get('wtPagePostUrl')
    this.useUserPort = parseInt(this.config.get('useUserPort')) === 1
    this.syncSignDateBl = Number(this.config.get('syncSignDateBl'))
    this.ownerCompanyId = 0
    getSpecificBasicData(basicCacheKeys.basic_data_CutomJobType).then(data => {
      this.cutomJobTypeList = data
    })
    getSpecificBasicData(basicCacheKeys.basic_data_Packing).then(data => {
      this.packingList = data
    })
    JobUtils.getTransportationModeAll(this.view.form).then(res => {
      this.view.transportationModeInfos = res
    })
    // 起运港代理下拉框赋值
    Company.getCmpIdxByLocal({ branchId: this.context.office.officeId }).then(res => {
      this.loadingAgentIdArray = res
    })
  }
  changeJob() {
    if (this.job.uuid) {
      this.loadForBookingResultHandler()
      this.loadPushHistoryLogsHandler()
    } else {
      this.loadForBookingResultHandler()
    }
    this.formInitialValue = { ...this.job }
  }
  async fillView() {
    const job = this.job
    if (!job.uuid) {
      await this.paymentTermMBL_Change(job.paymentTermMBL)
      await this.loadOverseaAgentDetail()
      if (this.view.isCopy) {
        const notMatchAgainSelect = LocalStorageUtilsNew.getConfiguration('NOT_MATCH_AGAIN_SELECT_' + job.lob)
        JobUtils.doNotMatchAgainSelect(job, notMatchAgainSelect, { onlySales: true })
      }
      this.carrierAgentSyncLoading()
      this.seaEqDateCl()
      // this.loadUserPort(job.dischargingPortCode)
      if (!this.view.isXhqSync) {
        JobUtils.matchUserPortConfig(this.view, job)
        JobUtils.matchRegionWarehouseMappingConfig(job, warehouseId => this.warehouseCmpChangeHandler({ value: warehouseId }), false, null, this.context.modifiedData, true)
      }
      this.checkNewJobCreditInfo()
    } else {
      JobUtils.matchUserPortConfig(this.view, job, false, null, { keepOriginValue: true })
    }
    // 同步 开航日期的周期 - sailingDay
    // this.view.etdChange(job.etd)
    this.warehouseNoeditableCl()
    this.loadCompanyMultiSales()
    this.viewOtherChanged()
    this.loadOverseaAgentChanged()
    this.loadOverseaOpChanged()
    this.loadSalesDptOffceChanged()
    this.loadCompanyOffice()
    this.loadOverseaPortDestinationAgent()
    this.lclslaveEnabledCl()
    this.checkVesselLine()
    this.checkWarehouseNoExist()
    this.checkWithinClosingAccountDate()
    this.checkIsCrossTenant()
    this.ETDEditChange()
    this.sopConfig()
    this.wTQueryPageHandler()
    if (!job.uuid) {
      if (this.view.isCopy) {
        // 复制业务时校验新业务岗位角色在当前分公司是否有对应的岗位权限
        if (job.csr > 0) {
          this.view.$nextTick(() => {
            this.view.$refs.csr.executeAfterLoad(data => {
              if (JobUtils.checkUserRolePrivilege(data, job.csr)) {
                job.csr = 0
                job.csrDepartment = 0
              }
            })
          })
        }
        if (job.dc > 0) {
          this.view.$nextTick(() => {
            this.view.$refs.dc.executeAfterLoad(data => {
              if (JobUtils.checkUserRolePrivilege(data, job.dc)) {
                job.dc = 0
                job.dcDepartment = 0
              }
            })
          })
        }
        // 复制时带海外客服逻辑 海外客服校验是否有效，有效则直接带入，否则判断参数【overseaAgentUsersConfig】是否为0,0则查询海外客服权限的用户，带入第一条
        if (job.overseaOp && !this.view.isHC) {
          this.view.overseaAgentUsersList = []
          await this.getOverseaAgentUserByConfig()
          const overseaUser = this.view.overseaAgentUsersList.find(p => p.userId === job.overseaOp)
          if (!(overseaUser && overseaUser.active)) {
            const overseaAgentUsersConfig = parseInt(this.config.get('overseaAgentUsersConfig'))
            if (overseaAgentUsersConfig === 0) {
              const cmpIdx = job.cargoSource === CargoSource.NC_CARGO_SOURCE.code ? job.designationAgent : job.destinationAgent
              if (cmpIdx > 0) {
                const cmp = this.companyList.find(p => p.cmpIdx === cmpIdx)
                if (cmp) {
                  const overseaAgentDetail = await new Company(cmp).getOverseaAgentDetail()
                  this.loadDestinationAgentDetaiHandler(overseaAgentDetail)
                }
              }
            } else {
              job.overseaOp = 0
              job.overseaOpDepartment = 0
            }
          }
        }
        await this.setPlannerChange()
      } else if (this.view.action === 'add') { // CARGO-35380 CLONE - 航线负责人不会自动跳出（有备注）
        if (!job.planner) {
          await this.setPlannerChange()
        }
      }
    }
    this.loadWarehouseRegion(false)
    this.loadBackUpWarehouseCompany()
  }
  checkCredit() {
    this.view.showWarningImageA = false
    this.view.showWarningImageB = false
    this.view.showWarningImageC = false
    if (this.view.creditOpen) {
      const job = this.job
      // 委托单位
      if (job && job.customerId > 0) {
        this.checkCreditByCompany(job.customerId, 1)
      }
      // 指定货代理
      if (job && job.designationAgent > 0) {
        this.checkCreditByCompany(job.designationAgent, 2)
      }
      // 目的港代理
      if (job && job.destinationAgent > 0) {
        this.checkCreditByCompany(job.destinationAgent, 3)
      }
    }
  }
  /**
   * 判断海外客服是否有效
   */
  isActiveOverSeaOp() {
    const job = this.job
    let flag = false
    if (job && job.overseaOp) {
      const user = this.userList.find(p => p.userId === job.overseaOp)
      if (user && user.active) {
        flag = true
      }
    }
    return flag
  }
  checkValueMatch() {
    const seaport = getObjectByCache(basicCacheKeys.basic_data_Seaport, 'code', this.job.destinationPortCode)
    if (!seaport) {
      this.job.destinationPortCode = ''
    }
  }
  async fillModel() {
    const isInsidePacking = parseInt(this.config.get('seaInsidePacking'))
    const billOfLadingSynMode = parseInt(this.config.get('BillOfLadingSynMode'))
    const seaCargoMark = parseInt(this.config.get('seaCargoMark'))
    const seaCargoEnglishName = parseInt(this.config.get('seaCargoEnglishName'))
    const syncCustomerShippingInfoBothBolAndBasicTab = parseInt(cache.config.get('SyncCustomerShippingInfoBothBolAndBasicTab')) === 1 || (parseInt(cache.config.get('SyncCustomerShippingInfoBothBolAndBasicTab')) === 2 &&
        (this.view.action === 'add' || this.view.action === 'copy'))
    // 是否太平
    const isTp = String(cache.config.get('ToExoSystem')) === 'TP'
    // 唛头最大字符数
    const sEMarkMaxChars = parseInt(this.config.get('SEMarkMaxChars'))
    // 英文品名最大字符数
    const sEEnglishDescriptionOfGoodsMaxchars = parseInt(this.config.get('SEEnglishDescriptionOfGoodsMaxchars'))
    // 收发通最大换行数
    const sEShipperConsigneNotifyMaxchars = parseInt(this.config.get('SEShipperConsigneNotifyMaxchars'))
    const job = this.job
    const oldJob = this.formInitialValue
    oldJob.mark = oldJob.mark ? oldJob.mark.trim() : oldJob.mark
    job.mark = job.mark ? job.mark.trim() : job.mark
    oldJob.cargoEnglishName = oldJob.cargoEnglishName ? oldJob.cargoEnglishName.trim() : oldJob.cargoEnglishName
    job.cargoEnglishName = job.cargoEnglishName ? job.cargoEnglishName.trim() : job.cargoEnglishName
    if (job.shipperId && !job.shippeerCode) {
      const cmp = this.companyList.find(p => p.cmpIdx === job.shipperId)
      if (cmp) {
        job.shipperCode = cmp.shortName
      }
    }
    if (job.consigneeId && !job.consigneeCode) {
      const cmp = this.companyList.find(p => p.cmpIdx === job.consigneeId)
      if (cmp) {
        job.consigneeCode = cmp.shortName
      }
    }
    if (job.notifyId && !job.notifyCode) {
      const cmp = this.companyList.find(p => p.cmpIdx === job.notifyId)
      if (cmp) {
        job.notifyCode = cmp.shortName
      }
    }
    // 同步HBL相关信息
    const hblDoc = await new SeaExportJob(job).getCargoDocByDocType(CargoDocConsts.HBL, true)
    if (hblDoc) {
      // hblDoc.paymentPlaceBL = job.paymentPlaceHBL
      if (this.view.isEdit) {
        if (billOfLadingSynMode === 1 || billOfLadingSynMode === 2) {
          hblDoc.packing = job.packing
          const packing = this.packingList.find(p => p.code === this.job.packing)
          const packingName = packing ? packing.name : this.job.packing
          hblDoc.packingName = packingName
        }
      }
      const hblDoc2 = new SeaExportJob(job).getCargoDoc(CargoDocConsts.HBL2)
      if (hblDoc2) {
        hblDoc2.paymentPlaceBL = hblDoc.paymentPlaceBL
      }
      const oldMark = hblDoc.mark
      const oldCargoEnglishName = hblDoc.cargoEnglishName
      if (hblDoc.state !== 2) {
        if (!hblDoc.uuid || !hblDoc.mark || ([1, 2].indexOf(seaCargoMark) > -1 && job.mark !== oldJob.mark)) { hblDoc.mark = job.mark }
        if (!hblDoc.uuid || !hblDoc.cargoEnglishName || [1, 2].indexOf(seaCargoEnglishName) > -1 && job.cargoEnglishName !== oldJob.cargoEnglishName) {
          hblDoc.cargoEnglishName = job.cargoEnglishName
        }
      }
      // CARGO-9437 复制业务，能把提单页签的品名和唛头都复制下来
      // CARGO-19277 H5：复制的新业务，在基本页签修改数据，不会同步到HBL页签中
      const isCopyHbl = LocalStorageUtils.getConfiguration('COPY_HBL_' + job.lob)
      if (job.signHBL && this.view.isCopy && isCopyHbl) {
        if (!this.view.markChange) {
          hblDoc.mark = oldMark
        }
        if (!this.view.cargoEnglishNameChange) {
          hblDoc.cargoEnglishName = oldCargoEnglishName
        }
      }
      if (job.jobState === -1) {
        hblDoc.mark = ''
        hblDoc.cargoEnglishName = ''
      }
      if (!hblDoc.uuid || !hblDoc.cargoManifestName) { hblDoc.cargoManifestName = job.cargoEnglishName }
      if (!hblDoc.uuid || !hblDoc.quantitySum || billOfLadingSynMode === 1 || billOfLadingSynMode === 2) {
        const packing = this.packingList.find(p => p.code === this.job.packing)
        hblDoc.quantitySum = StrUtils.jsdx(job.quantityActual, packing ? packing.name : this.job.packing)
      }
      if (isInsidePacking === 1) {
        hblDoc.insidePacking = job.insidePacking
      }
      hblDoc.containerSum = ContainerUtil.getSeaeqNumberStr(job)
      if (!hblDoc.uuid) {
        if (job.jobState !== -1 && this.view.action !== 'copy') { // 订舱预审不同步收发通
          new SeaExportJob(job).copySCNotifyToDoc(new SeaCargoDoc(hblDoc))
        }
        // if (job.containerLoadType !== 'BB') {
        //   hblDoc.container = SeaExportUtils.getContainerDesc(job, false)
        // } else {
        //   hblDoc.container = SeaExportUtils.getContainerDesc(job, hblDoc.printParam3)
        // }
        if (!hblDoc.freightTermHBL && job.freightTermHBL) {
          hblDoc.freightTermHBL = job.freightTermHBL
        }
      } else {
        if (!job.mblOnly && job.jobState !== -1) {
          CargoDocUtil.syncJobSftToDoc(job, hblDoc, (this.view.action === 'add' || this.view.action === 'copy'))
        }
      }
    }
    // console.log('hblDoc----------------', hblDoc)
    // 同步MBL相关信息
    const mblDoc = await new SeaExportJob(job).getCargoDocByDocType(CargoDocConsts.MBL, true)
    if (mblDoc) {
      const oldMark = mblDoc.mark
      const oldCargoEnglishName = mblDoc.cargoEnglishName
      if (!mblDoc.uuid || !mblDoc.mark || ([1, 2].indexOf(seaCargoMark) > -1 && (!mblDoc._mergeHblDataTime || (mblDoc._markTime && mblDoc._markTime > mblDoc._mergeHblDataTime)) && job.mark !== oldJob.mark)) {
        if (isTp) {
          mblDoc.mark = JobUtils.splitStringByBrAndLength(job.mark, sEMarkMaxChars, 'r')
        } else {
          mblDoc.mark = job.mark
        }
      }
      if (!mblDoc.uuid || !mblDoc.cargoEnglishName || [1, 2].indexOf(seaCargoEnglishName) > -1 && (!mblDoc._mergeHblDataTime || (mblDoc._cargoEnglishNameTime && mblDoc._cargoEnglishNameTime > mblDoc._mergeHblDataTime)) && job.cargoEnglishName !== oldJob.cargoEnglishName) {
        if (isTp) {
          mblDoc.cargoEnglishName = JobUtils.splitStringByBrAndLength(job.cargoEnglishName, sEEnglishDescriptionOfGoodsMaxchars, 'r')
        } else {
          mblDoc.cargoEnglishName = job.cargoEnglishName
        }
      }
      // CARGO-9437 复制业务，能把提单页签的品名和唛头都复制下来
      // CARGO-19277 H5：复制的新业务，在基本页签修改数据，不会同步到HBL页签中
      const isCopyMbl = LocalStorageUtils.getConfiguration('COPY_MBL_' + job.lob)
      if (job.signMBL && this.view.isCopy && isCopyMbl) {
        if (!this.view.markChange) {
          if (isTp) {
            mblDoc.mark = JobUtils.splitStringByBrAndLength(oldMark, sEMarkMaxChars, 'r')
          } else {
            mblDoc.mark = oldMark
          }
        }
        if (!this.view.cargoEnglishNameChange) {
          if (isTp) {
            mblDoc.cargoEnglishName = JobUtils.splitStringByBrAndLength(oldCargoEnglishName, sEEnglishDescriptionOfGoodsMaxchars, 'r')
          } else {
            mblDoc.cargoEnglishName = oldCargoEnglishName
          }
        }
      }
      if ((!mblDoc.uuid || !mblDoc.cargoManifestName) && job.jobState !== -1) { mblDoc.cargoManifestName = job.cargoEnglishName }
      if (!mblDoc.uuid || !mblDoc.quantitySum || billOfLadingSynMode === 1 || billOfLadingSynMode === 2) {
        const packing = this.packingList.find(p => p.code === this.job.packing)
        const packingName = job.jobState !== -1 ? (packing ? packing.name : this.job.packing) : ''
        mblDoc.quantitySum = StrUtils.jsdx(job.quantityActual, packingName)
      }
      if (isInsidePacking === 1) {
        mblDoc.insidePacking = job.insidePacking
      }
      mblDoc.containerSum = ContainerUtil.getSeaeqNumberStr(job)
      if (!mblDoc.uuid) {
        await CargoDocUtil.initMBLProperties(mblDoc, job, this.view.action)
        if (job.mblOnly && job.jobState !== -1 && this.view.action !== 'copy') { // 订舱预审不同步收发通
          new SeaCargoDoc(mblDoc).copyBasicShipper(job)
          new SeaCargoDoc(mblDoc).copyBasicConsignee(job)
          new SeaCargoDoc(mblDoc).copyBasicNotify(job)
          if (syncCustomerShippingInfoBothBolAndBasicTab) {
            new SeaCargoDoc(mblDoc).copyBasicAlsoNotify(job, true, syncCustomerShippingInfoBothBolAndBasicTab)
          }
        }
        if (hblDoc) {
          await CargoDocUtil.initHBLProperties(hblDoc, job)
        }
        // 不是复制的情况下，或者复制并且没有勾选MBL的时候，再把目的港代理维护的海外地址导入的MBL的收货人信息栏位
        if (this.view.action !== 'copy' || (this.view.isCopy && !isCopyMbl)) {
          await CargoDocUtil.checkOverseaAgentProperties(job)
        }
        if (isTp) {
          JobUtils.disposeScnLinebreaks(mblDoc, 'shipperLine', sEShipperConsigneNotifyMaxchars, 'n')
          JobUtils.disposeScnLinebreaks(mblDoc, 'consigneeLine', sEShipperConsigneNotifyMaxchars, 'n')
          JobUtils.disposeScnLinebreaks(mblDoc, 'notifyLine', sEShipperConsigneNotifyMaxchars, 'n')
        }
      } else {
        if (job.mblOnly && job.jobState !== -1) {
          CargoDocUtil.syncJobSftToDoc(job, mblDoc, (this.view.action === 'add' || this.view.action === 'copy'))
        }
      }
      if (this.view.isEdit && job.insideQuantity >= 0) {
        mblDoc.insideQuantity = job.insideQuantity
      }
      if (!StrUtils.isEmpty(job.packing)) {
        if (billOfLadingSynMode === 1 || billOfLadingSynMode === 2) {
          mblDoc.packing = job.packing
          const packing = this.packingList.find(p => p.code === this.job.packing)
          const packingName = packing ? packing.name : this.job.packing
          mblDoc.packingName = packingName
        }
      }
      if (!job.uuid) {
        let packingName = ''
        if (billOfLadingSynMode === 1 || billOfLadingSynMode === 2) {
          const packing = this.packingList.find(p => p.code === this.job.packing)
          packingName = packing ? packing.name : this.job.packing
          if (!mblDoc.packingName) {
            mblDoc.packingName = packingName
          }
        }
        if (job.quantityActual > 0) {
          mblDoc.quantitySum = StrUtils.jsdx(job.quantityActual, packingName)
        } else {
          mblDoc.quantitySum = StrUtils.jsdx(job.quantityContract, packingName)
        }
        if (!mblDoc.freightTermHBL && job.freightTerm) {
          mblDoc.freightTermHBL = job.freightTerm
        }
      }
      if (this.view.markChange) { // 切换页签以后，重新初始化
        this.view.markChange = false
      }
      if (this.view.cargoEnglishNameChange) { // 切换页签以后，重新初始化
        this.view.cargoEnglishNameChange = false
      }
    }
    if (job.quantityActual !== oldJob.quantityActual || job.weightActual !== oldJob.weightActual ||
        job.cubageActual !== oldJob.cubageActual || job.chargeWeight !== oldJob.chargeWeight) {
      if (hblDoc) {
        CargoDocUtil.changeJobSynToBillOfLading(job, hblDoc)
      }
      if (mblDoc) {
        CargoDocUtil.changeJobSynToBillOfLading(job, mblDoc)
      }
    }
    // console.log('mblDoc----------------', mblDoc)
    // 仓库
    await this.getWarehouseInfo()
    // //车队
    await this.getTruckingInfo()
    // 默认AMS
    // if (job.ams) {
    //   await CargoDocUtil.addAMS(job)
    // }
    // 已经拼箱的业务支持货物数量直接更改
    // CARGO-7908
    const expression = parseInt(this.config.get('ContainerUpdateJobQCW'))
    if (expression === 3 && this.view.isTabContainerInfo && this.view.isEdit && !this.view.slaveCustomsDeclarationEnable) {
      ContainerUtil.refContainerUsageQwc(job, 0, this.view.btnSave)
    }
    this.view.isTabContainerInfo = false
    this.view.btnSave = true
    // 同步报关行
    await JobUtils.synCustomsBroker(job, job.customsBroker)
  }
  /**
   * 根据打印模板更新SOP状态错误时回调函数
   */
  updateTrackingForDocumentTypeHandler(evt) {
    // job.reloadTrackingInfo2(function (e: ResultEvent) { }, faultHandler)
  }
  loadForBookingResultHandler() {
    this.loadWarehouseCmp()
    this.loadTrucking2()
    this.loadWarehouseInDetails()
    this.checkCargoDocState()
    this.loadBackUpWarehouseCmp()
    // view.callLater(surchargeTermsTxtChanged)
  }
  loadPushHistoryLogsHandler(evt = null) {
    AutoContaninerFactory.getInstance().job = this.job
    const fields = [
      {
        fieldName: this.view.$t('SeaExport.ActualQuantity'),
        key: 'quantityActual'
      }, {
        fieldName: this.view.$t('CargoMsg.Cargo_ActualWeight'),
        key: 'weightActual'
      }, {
        fieldName: this.view.$t('SeaExport.ActualVolume'),
        key: 'cubageActual'
      }
    ]
    fields.forEach(item => {
      ensureExecuteSuccess(() => this.view.$refs[item.key]).then(() => {
        const el = this.view.$refs[item.key].$el
        const className = 'input-blue'
        if (DataPushCompareUtils.comparePushData(item.fieldName, String(this.view.form[item.key]), this.job[item.key])) {
          if (!el.classList.contains(className)) {
            el.classList.add(className)
          }
        } else {
          if (el.classList.contains(className)) {
            el.classList.remove(className)
          }
        }
      })
    })
    // view.txtQuantityActual.setStyle('color', DataPushCompareUtils.comparePushData(this.view.$t('SeaExport.ActualQuantity'), String(view.txtQuantityActual.value), job.key) ? '#0000FF' : '#000000')
    // view.txtWeightActual.setStyle('color', DataPushCompareUtils.comparePushData(this.view.$t('CargoMsg.Cargo_ActualWeight'), String(view.txtWeightActual.value), job.key) ? '#0000FF' : '#000000')
    // view.txtCubageActual.setStyle('color', DataPushCompareUtils.comparePushData(this.view.$t('SeaExport.ActualVolume'), String(view.txtCubageActual.value), job.key) ? '#0000FF' : '#000000')
  }
  /**
   * MBL勾选
   */
  async isMBLChange() {
    if (this.job.signMBL) {
      const job = new SeaExportJob(this.job)
      const mbl = await job.getCargoDocByDocType(CargoDocConsts.MBL, true)
      await CargoDocUtil.initMBLProperties2(mbl, this.job)
      if (job.mblOnly) {
        new SeaCargoDoc(mbl).copyBasicConsignee(job)
        new SeaCargoDoc(mbl).copyBasicNotify(job)
        new SeaCargoDoc(mbl).copyBasicShipper(job)
      }
      await CargoDocUtil.copyInfoForDoc(this.job, mbl)
      await CargoDocUtil.checkOverseaAgentProperties(job)
    }
  }
  /**
   * HBL勾选
   */
  async isHBLChange() {
    if (this.job.signHBL) {
      const job = new SeaExportJob(this.job)
      const hbl = new SeaCargoDoc(await job.getCargoDocByDocType(CargoDocConsts.HBL, true))
      await CargoDocUtil.initHBLProperties(hbl, this.job)
      job.copySCNotifyToDoc(hbl)
      await CargoDocUtil.copyInfoForDoc(this.job, hbl)
      await CargoDocUtil.checkOverseaAgentProperties(job)
    }
  }
  /**
   * 委托单位选择（从写委托单位选择，去掉当前与分公司校验）
   */
  async customerIdChangeNew(event) {
    const job = this.job
    job.editCftMode = false
    const company = this.companyList.find(p => p.cmpIdx === job.customerId)
    if (company) {
      // CARGO-1986 淳宏：合伙伙伴中同时勾选指定货和自拦货时，新增业务时揽货类型，无法选择
      await this.loadCustomerDetail(event)// 联系人或者揽货类型
      this.showCustomerDetail()// 客户级别
      this.loadCustomerPortDestinationAgents()
      this.loadCompanyUser()// 销售
      if (company.mustInputScn) {
        job.editCftMode = true
      }
    } else {
      job.customerId = 0
      if (job.cargoSource !== CargoSource.NC_CARGO_SOURCE.code) {
        this.view.txtSalesOffice = ''
        job.salesOffice = 0
        job.sales = 0 // 销售
        job.dc = 0 // 单证
        job.csr = 0 // 客服
      }
      this.getTxtSalesPrompt()
    }
  }
  /**
   * 整拼类型选择
   */
  async containerLoadTypeChange(containerLoadType, options = {}) {
    const preserveSeaEQ = Boolean(options && options.preserveSeaEQ)
    const job = this.job
    if (containerLoadType === ContainerLoadType.BB_CARGO_TYPE.code) {
      this.job.bookingTerm = BookingTerm.NS_BOOKING_TYPE.code
    } else if (containerLoadType === 'FCL' || containerLoadType === ContainerLoadType.BC_CARGO_TYPE_FCL.code) {
      this.job.vgm = true
    }
    this.warehouseNoeditableCl()
    this.seaEqDateCl(preserveSeaEQ).then(r => {})
    if (!preserveSeaEQ && (containerLoadType === ContainerLoadType.LCL_CARGO_TYPE.code || containerLoadType === ContainerLoadType.BULK_CARGO_TYPE.code ||
        containerLoadType === ContainerLoadType.BC_CARGO_TYPE.code)) {
      if (this.view.$refs.bookingSeaEqDataGrid) this.view.$refs.bookingSeaEqDataGrid.clear()
    }
    // 整拼类型不为散杂货，但是散杂货信息有值时清空
    if (containerLoadType !== ContainerLoadType.BULK_CARGO_TYPE.code && this.view.cargoBulkDetailList && this.view.cargoBulkDetailList.length > 0) {
      this.view.cargoBulkDetailList = []
    }
    // 整拼类型不为散杂货，但是散杂货信息有值时清空
    if (!preserveSeaEQ && containerLoadType === ContainerLoadType.BULK_CARGO_TYPE.code && this.view.seaEqList && this.view.seaEqList.length > 0) {
      // this.view.seaEqList = []
      // this.job.containers = []
      // this.job.containerUsages = []
      if (this.view.$refs.bookingSeaEqDataGrid) this.view.$refs.bookingSeaEqDataGrid.clear()
    }
    if (!job.freightTermHBL) {
      this.changeDefaultHBLPayment()
    }
    this.selectDefaultLocalService()
    this.selectDefaultCutomJobType()
    this.selectFreightTermByBulkCargo()
    if (containerLoadType !== ContainerLoadType.BULK_CARGO_TYPE.code && this.view.cargoBulkDetailList.length > 0) {
      job.insideQuantitySize = 0
    }
    // 判断客户是否有维护默认的主单和分单运输条款
    const shippingTermList = await getSpecificBasicData(basicCacheKeys.basic_data_ShippingTerm)
    if (shippingTermList && shippingTermList.length > 0) {
      for (const shippingTerm of shippingTermList) {
        let isFind = false
        const shippingTermOperationTypes = shippingTerm.shippingTermOperationTypes
        if (shippingTermOperationTypes && shippingTermOperationTypes.length > 0) {
          for (const item of shippingTermOperationTypes) {
            if (item.containerLoadType === containerLoadType && item.mbl && item.lob === 'SE') {
              isFind = true
              break
            }
          }
        }
        if (isFind) {
          job.freightTerm = shippingTerm.code
          break
        }
      }
      for (const shippingTerm of shippingTermList) {
        let isFind = false
        const shippingTermOperationTypes = shippingTerm.shippingTermOperationTypes
        if (shippingTermOperationTypes && shippingTermOperationTypes.length > 0) {
          for (const item of shippingTermOperationTypes) {
            if (item.containerLoadType === containerLoadType && !item.mbl && item.lob === 'SE') {
              isFind = true
              break
            }
          }
        }
        if (isFind) {
          job.freightTermHBL = shippingTerm.code
          break
        }
      }
    }
    JobUtils.matchUserPortConfig(this.view, this.job)
    JobUtils.matchRegionWarehouseMappingConfig(this.job, warehouseId => this.warehouseCmpChangeHandler({ value: warehouseId }), false, null, this.context.modifiedData)
    this.view.customJobTypeList = JobUtils.setCustomJobTypeList(this.job.lob, this.job.containerLoadType, this.job.fba)
    if (this.view.slaveCustomsDeclarationEnable) {
      // 切换整拼类型 为 委托拼箱时，将 关单信息 全部绑定到 第一个装箱信息里
      if (containerLoadType === ContainerLoadType.BB_CARGO_TYPE.code) {
        // PortDataCompareUtils.initContainerPoItemsMultiSoNoMode(this.job.containerUsages, this.job.poItems, this.job.uuid)
        if (this.job.containerUsages && this.job.containerUsages.length > 0 && this.job.poItems && this.job.poItems.length > 0) {
          // 清除 整箱产生的脏数据
          this.job.containerUsages.forEach(p => {
            p.poItems = []
          })
          this.job.containerUsages[0].poItems = this.job.poItems
          // 【关单信息】页签需要将这些poItems排查掉，否则创建重复
          this.job.poItems.forEach(p => {
            p.existInUsagedFlag = true
          })
          // 刷新装箱信息
          if (this.view.$refs.customsDeclaration) {
            ContainerUtil.calcContainerUsageQWC(this.job.containerUsages[0], this.job)
          }
        }
      } else if (containerLoadType !== ContainerLoadType.FCL_CARGO_TYPE.code) {
        // 非【委托拼箱、整箱】将排除标志清空
        if (this.job.poItems && this.job.poItems.length > 0) {
          this.job.poItems.forEach(p => {
            p.existInUsagedFlag = false
            p.containerUsageKey = null
          })
        }
      }
    }
  }
  /**
   * ETD 选择控制
   */
  ETDChange(oldValue) {
    if (this.view.readonly) return
    if (this.syncSignDateBl === 0) {
      for (const cargoDoc of this.job.seaCargoDoc) {
        const allow = (cargoDoc.docType === CargoDocConsts.MBL || cargoDoc.docType === CargoDocConsts.MBL2 ||
            cargoDoc.docType === CargoDocConsts.HBL || cargoDoc.docType === CargoDocConsts.HBL2 ||
            cargoDoc.docType === CargoDocConsts.HAWB2) && cargoDoc.state < 2 && (!cargoDoc.signDateBL ||
            (oldValue && dateCompare(cargoDoc.signDateBL, oldValue) === 0))
        if (allow) {
          cargoDoc.signDateBL = this.job.etd
        }
      }
    }
    // CARGO-25511 小票截单日期同步主票的信息【主票新增小票无需同步【masterFlag=false,lclMasterUuid有值，确认是小票】】
    const isSlave = !this.job.masterFlag && this.job.lclMasterUuid
    if (this.job.etd && !isSlave) {
      // 截单日期默认天数
      const fileCutoffDay = parseInt(this.config.get('SEFileCutoffDetaultDay'))
      if (fileCutoffDay > 0 && this.job.etd) {
        const fileCutoff = DateUtils.getFourDaysAgoWithoutHoliday(this.job.etd, fileCutoffDay)
        fileCutoff.setHours(12, 0)
        this.job.fileCutoff = DateUtils.formatStandardDateTime(fileCutoff)
      }
    }
  }
  /**
   * 提单发货地修改
   */
  async cargoDocChangeHandler() {
    const job = this.job
    const amsDoc = await new SeaExportJob(job).getCargoDocByDocType(CargoDocConsts.AMS, false)
    if (amsDoc && amsDoc.state > 0) {
      await SeaCargoDoc.copyInfoFromJobPort(job, amsDoc)
    }
  }
  /**
   * 提单发货地代码
   */
  async changeDispatchingPlaceCode(event) {
    const job = this.job
    job.dispatchingPlaceCode = event.code
    this.changeDispatchingPlace(event.englishName, job.dispatchingPlaceCode)
  }
  /**
   * 提单发货地
   */
  async changeDispatchingPlace(dispatchingPlace, dispatchingPlaceCode) {
    const job = this.job
    if (dispatchingPlace) {
      job.dispatchingPlace = dispatchingPlace
    }
    const cargoDocs = await new SeaExportJob(job).getSeaCargoDoc()
    if (cargoDocs && cargoDocs.length > 0) {
      for (const item of cargoDocs) {
        if (item.state > 1 || item.releaseState === ReleaseState.ONSINGLERELEASE.code) continue
        // MBL/MBL拆单/MBL并单/HBL/HBL拆单/HBL并单都需要修改
        if ((item.docType === CargoDocConsts.HBL) ||
            item.docType === CargoDocConsts.HBL2 ||
            item.docType === CargoDocConsts.MBL ||
            item.docType === CargoDocConsts.MBL2) {
          item.dispatchingPlace = job.dispatchingPlace
          item.dispatchingPlaceCode = job.dispatchingPlaceCode
        }
      }
    }
  }
  /**
   * 提单起运港
   */
  async changeLoadingPort(event) {
    const job = this.job
    const hbl = await new SeaExportJob(job).getMainHbl()
    const seaPorts = await getSpecificBasicData(basicCacheKeys.basic_data_Seaport)
    const ports = seaPorts.filter(p => p.code === job.loadingPortCode)
    if (hbl) {
      if (hbl.state > 1) return
      if (job.loadingPortCode && job.loadingPortCode.length > 0) {
        if (ports && ports.length > 0) {
          hbl.loadingPort = ports[0].englishName
          hbl.loadingPortCode = job.loadingPortCode
        }
      }
    }
    const mbl = await new SeaExportJob(job).getMainMbl()
    if (mbl) {
      if (mbl.state > 1) return
      if (job.loadingPortCode && job.loadingPortCode.length > 0) {
        if (ports && ports.length > 0) {
          mbl.loadingPort = ports[0].englishName
          mbl.loadingPortCode = job.loadingPortCode
        }
      }
    }
    // CARGO-16702 基本页签修改起运港目的港等信息，HBL拆单需要同步
    const cargoDocs = await new SeaExportJob(job).getSeaCargoDoc()
    if (cargoDocs && cargoDocs.length > 0) {
      for (const item of cargoDocs) {
        if (item.state > 1 || item.releaseState === ReleaseState.ONSINGLERELEASE.code) continue
        if (((job.typeHBL === BillType.SPLIT_BILL_TYPE.code || job.typeHBL === BillType.MERGE_BILL_TYPE.code) && item.docType && item.docType === CargoDocConsts.HBL2) ||
            ((job.typeMBL === BillType.SPLIT_BILL_TYPE.code || job.typeMBL === BillType.MERGE_BILL_TYPE.code) && item.docType && item.docType === CargoDocConsts.MBL2)) {
          if (job.loadingPortCode && job.loadingPortCode.length > 0 && ports && ports.length > 0) {
            item.loadingPort = ports[0].englishName
            item.loadingPortCode = job.loadingPortCode
          }
        }
      }
    }
  }
  /**
   * 提单最终目的地
   */
  async changeDestinationPlace(event) {
    const job = this.job
    const hbl = await new SeaExportJob(job).getMainHbl()
    if (hbl) {
      if (hbl.state > 1) return
      if (hbl.docType !== CargoDocConsts.MBL && hbl.docType !== CargoDocConsts.MBL2) {
        hbl.destinationPlace = job.destinationPlace
      }
    }
    const mbl = await new SeaExportJob(job).getMainMbl()
    if (mbl) {
      if (mbl.state > 1) return
      mbl.destinationPlace = job.destinationPlace
    }
    // CARGO-16702 基本页签修改起运港目的港等信息，HBL拆单需要同步
    const cargoDocs = await new SeaExportJob(job).getSeaCargoDoc()
    if (cargoDocs && cargoDocs.length > 0) {
      for (const item of cargoDocs) {
        if (item.state > 1 || item.releaseState === ReleaseState.ONSINGLERELEASE.code) continue
        if (((job.typeHBL === BillType.SPLIT_BILL_TYPE.code || job.typeHBL === BillType.MERGE_BILL_TYPE.code) && item.docType && item.docType === CargoDocConsts.HBL2) ||
            ((job.typeMBL === BillType.SPLIT_BILL_TYPE.code || job.typeMBL === BillType.MERGE_BILL_TYPE.code) && item.docType && item.docType === CargoDocConsts.MBL2)) {
          item.destinationPlace = job.destinationPlace
        }
      }
    }
  }
  /**
   * 提单卸货港
   */
  async changeDischargingPort() {
    const job = this.job
    const seaPorts = await getSpecificBasicData(basicCacheKeys.basic_data_Seaport)
    const hbl = await new SeaExportJob(job).getMainHbl()
    let portEnglishName = ''
    if (job.dischargingPortCode && job.dischargingPortCode.length > 0) {
      const port = seaPorts.find(p => p.code === job.dischargingPortCode)
      if (port) {
        portEnglishName = port.englishName
      }
    }
    if (hbl) {
      if (hbl.state > 1) return
      if (job.dischargingPortCode) {
        hbl.dischargingPortCode = job.dischargingPortCode
        hbl.dischargingPort = portEnglishName
        if (job.dischargingPortCode === job.destinationPortCode) {
          hbl.destinationPort = portEnglishName
          hbl.destinationPortCode = job.destinationPortCode
        }
      }
    }
    const mdoc = await new SeaExportJob(job).getMainMbl()
    if (mdoc) {
      if (mdoc.state > 1) return
      if (job.dischargingPortCode) {
        mdoc.dischargingPortCode = job.dischargingPortCode
        mdoc.dischargingPort = portEnglishName
        mdoc.dischargingPortCode = job.dischargingPortCode
        if (job.dischargingPortCode === job.destinationPortCode) {
          mdoc.destinationPort = portEnglishName
          mdoc.destinationPortCode = job.destinationPortCode
        }
      }
    }
    // CARGO-16702 基本页签修改起运港目的港等信息，HBL拆单需要同步
    const cargoDocs = await new SeaExportJob(job).getSeaCargoDoc()
    if (cargoDocs && cargoDocs.length > 0) {
      for (const item of cargoDocs) {
        if (item.state > 1 || item.releaseState === ReleaseState.ONSINGLERELEASE.code) continue
        if (((job.typeHBL === BillType.SPLIT_BILL_TYPE.code || job.typeHBL === BillType.MERGE_BILL_TYPE.code) && item.docType && item.docType === CargoDocConsts.HBL2) ||
            ((job.typeMBL === BillType.SPLIT_BILL_TYPE.code || job.typeMBL === BillType.MERGE_BILL_TYPE.code) && item.docType && item.docType === CargoDocConsts.MBL2)) {
          if (job.dischargingPortCode) {
            item.dischargingPortCode = job.dischargingPortCode
            item.dischargingPort = portEnglishName
            item.dischargingPortCode = job.dischargingPortCode
            if (job.dischargingPortCode === job.destinationPortCode) {
              item.destinationPort = portEnglishName
              item.destinationPortCode = job.destinationPortCode
            }
          }
        }
      }
    }
  }
  /**
   * 更新通过目的港更新hbl号
   */
  updateHBLNoByPort(hbl, oldPortCode, newPortCode) {
    // if (hblNoConfig != null && hblNoConfig.indexOf('pod') > -1
    //   && oldPortCode && newPortCode && oldPortCode.length > 2 && newPortCode.length > 2
    //   && hbl && hbl.hblNbr2 && hbl.hblNbr2 != '') {
    //   hbl.hblNbr2 = hbl.hblNbr2.replace(oldPortCode.substring(2), newPortCode.substring(2))
    // }
  }
  /**
   * 提单交货地
   */
  async changeDestinationPort(event) {
    const job = this.job
    if (job.destinationPortCode && job.destinationPortCode.length > 0) {
      const seaPorts = await getSpecificBasicData(basicCacheKeys.basic_data_Seaport)
      const ports = seaPorts.filter(p => p.code === job.destinationPortCode)
      if (ports && ports.length > 0) {
        job.placeOfDeliveryRegion = ports[0].region
        const hbl = await new SeaExportJob(job).getMainHbl()
        if (hbl) {
          if (hbl.state > 1) return
          hbl.destinationPort = ports[0].englishName
          hbl.destinationPortCode = job.destinationPortCode
        }
        const mbl = await new SeaExportJob(job).getMainMbl()
        if (mbl) {
          if (mbl.state > 1) return
          mbl.destinationPort = ports[0].englishName
          mbl.destinationPortCode = job.destinationPortCode
        }
        // CARGO-16702 基本页签修改起运港目的港等信息，HBL拆单需要同步
        const cargoDocs = await new SeaExportJob(job).getSeaCargoDoc()
        if (cargoDocs && cargoDocs.length > 0) {
          for (const item of cargoDocs) {
            if (item.state > 1 || item.releaseState === ReleaseState.ONSINGLERELEASE.code) continue
            if (item.docType === CargoDocConsts.HBL2 || item.docType === CargoDocConsts.MBL2) {
              item.destinationPort = ports[0].englishName
              item.destinationPortCode = job.destinationPortCode
            }
          }
        }
      }
    }
  }
  /**
   * 卸货港选择
   */
  async dischargingPortCodeChange(value, carrierId, allowPopup = true) {
    const job = this.job
    this.isClearDestinationAgent = true
    this.loadOverseaAgentPort().then(r => {})
    if (this.sEUseDischargingPort5Code && value) {
      this.refreshPortCode(value, carrierId)
    }
    if (job.dischargingPortCode !== value) {
      this.dischargingPortIsDirty = true
      job.overseaAgentPort = null
      if (job.uuid) {
        const hbl = new SeaExportJob(job).getMainHbl(false)
        this.updateHBLNoByPort(hbl, job.dischargingPortCode, value)
      }
      job.dischargingPortCode = value
      // const oldDestinationPortCode = job.destinationPortCode
      let isDestinationPortChanged = false
      // 只有当交货地没有值时，才将卸货港赋值给交货地
      if (!job.destinationPortCode) {
        job.destinationPortCode = job.dischargingPortCode
        isDestinationPortChanged = true
      }
      let port = null
      if (job.destinationPortCode) {
        const seaPorts = await getSpecificBasicData(basicCacheKeys.basic_data_Seaport)
        port = seaPorts.find(p => p.code === job.destinationPortCode)
      }
      job.placeOfDeliveryRegion = port ? port.region : ''
      // 只有当交货地被改变时，才将值赋值给最终目的地
      if (port && isDestinationPortChanged && parseInt(this.config.get('FinalDestinationChange')) === 1) {
        this.job.destinationPlace = port.englishName
        // 最终目的地变更以后，需要同步给HBL以及MBL
        await this.changeDestinationPlace()
      }
    } else {
      this.dischargingPortIsDirty = false
    }
    await this.portChange()
    await this.setPlannerChange()
    this.loadCustomerPortDestinationAgents(allowPopup).then(r => {})
    await JobUtils.matchUserPortConfig(this.view, job)
    await JobUtils.matchRegionWarehouseMappingConfig(job, warehouseId => this.warehouseCmpChangeHandler({ value: warehouseId }), false, null, this.context.modifiedData)
    await JobUtils.loadingShipDate(job)
    await this.loadWarehouseRegion(true)
    this.updateSecondVesselInfo()
  }
  // 修改卸货港，查询卸货港维护的操作人员
  loadUserPort(code) {
    if (!code || !this.useUserPort) {
      return
    }
    getUserPortByCode({ code }).then(res => {
      if (res.data.length > 0) {
        const userPorts = res.data
        // 拥有操作权限的人
        const users = this.view.$refs.op.options
        let defaultUser = null
        // 根据自定义业务类型和业务类型，人员去查询
        const portList1 = [] // 存放业务类型”和“业务模式不为空的数据
        const portList2 = []
        for (const port of userPorts) {
          if (port.lob || port.operateType) {
            portList1.push(port)
          } else {
            portList2.push(port)
          }
        }
        if (portList1.length > 0) {
          for (const port of portList1) { // 满足两种条件的都维护的
            let isFound = false
            if (port.lob === 'SE' && port.operateType && port.operateType.indexOf(this.job.containerLoadType) >= 0) {
              for (const user of users) {
                if (port.userId === user.userId) {
                  isFound = true
                  defaultUser = user
                  break
                }
              }
            }
            if (isFound) {
              break
            }
          }
          if (!defaultUser) { // 维护业务类型是海出，没有维护操作模式
            for (const port of portList1) {
              let isFound = false
              for (const user of users) {
                if (port.lob === 'SE' && !port.operateType) {
                  if (port.userId === user.userId) {
                    isFound = true
                    defaultUser = user
                    break
                  }
                }
              }
              if (isFound) {
                break
              }
            }
          }
          if (!defaultUser) { // 没有维护业务类型,维护操作模式
            for (const port of portList1) {
              let isFound = false
              if (!port.lob && port.operateType && port.operateType.indexOf(this.job.containerLoadType) >= 0) {
                for (const user of users) {
                  if (port.userId === user.userId) {
                    isFound = true
                    defaultUser = user
                    break
                  }
                }
              }
              if (isFound) {
                break
              }
            }
          }
        } else {
          if (portList2.length > 0) {
            for (const item of portList2) {
              const option = users.find(p => p.userId === item.userId)
              if (option) {
                defaultUser = option
                break
              }
            }
          }
        }
        if (defaultUser) {
          this.job.op = defaultUser.userId
          new User(defaultUser).getDefaultDepartment('role', 'op', this.job.opOffice).then(dep => {
            this.job.opDepartment = dep ? dep.departmentId : 0
          })
        }
      }
    })
  }
  /**
   * 交货地选择
   */
  async destinationPortCodeChange(data) {
    if (this.job.destinationPortCode !== data.value) {
      this.job.destinationPortCode = data.value
      await this.portChange(false)
      await this.setPlannerChange()
    }
    // 开启配置项后交货地变更不会带到最终目的地1开启 0关闭(默认)
    if (parseInt(this.config.get('FinalDestinationChange')) === 1) {
      this.job.destinationPlace = data.englishName
      // 最终目的地变更以后，需要同步给HBL以及MBL
      await this.changeDestinationPlace()
    }
  }
  /**
   * 修改船公司
   */
  async carrierChangeHandler(value, carrierId, scacList, carrierScacEdit) {
    const job = this.job
    await JobUtils.changeCarrierId(this.view, job, carrierId)
    // this.carrierIdIsDirty = true
    if (!job.masterFlag && this.sEUseDischargingPort5Code) {
      this.refreshPortCode(value, carrierId)
    }
    await this.refreshBookingAgentAutoComplete()
    JobUtils.matchUserPortConfig(this.view, job)
    JobUtils.matchRegionWarehouseMappingConfig(this.job, warehouseId => this.warehouseCmpChangeHandler({ value: warehouseId }), false, null, this.context.modifiedData)
    await JobUtils.queryCarrierCodeHandler(job)
    await JobUtils.loadingShipDate(this.view.form)
    if (job.carrierId) {
      const company = await Company.getCompanyById(job.carrierId)
      if (company && company.mscSupplement && company.mscSupplementType === SystemConstants.MSC_SUPPLEMENT_TYPE_1.code) {
        this.view.$emit('showMscSupplement', true)
      } else {
        this.view.$emit('showMscSupplement', false)
      }
    } else {
      this.view.$emit('showMscSupplement', false)
    }
    // 根据船公司带出对应的scac
    job.carrierScac = await JobUtils.getCarrierScac(job.carrierId, scacList, carrierScacEdit)
  }
  /**
   * 船公司要与订舱代理进行关联
   */
  async refreshBookingAgentAutoComplete() {
    const job = this.job
    if (!this.isJoinCarrierBookingAgent || job.containerLoadType === 'BB') return
    const company = await Company.getCompanyById(job.carrierId)
    if (company) {
      this.view.bookingAgentDataProviderChange = true
      company.bookingAgentList = ''
      await new Company(company).getBookingAgentList(true, false)
      const dataArray = []
      for (const bookingAgentCarrier of company.bookingAgentList) {
        dataArray.push(bookingAgentCarrier.bookingAgent)
      }
      // 去重
      this.bookingAgentArray = dataArray.filter((item, index, self) =>
        index === self.findIndex(t => t.uuid === item.uuid)
      )
    }
    job.bookingAgent = 0
  }

  /**
   * 订舱代理选择
   */
  bookingAgentChangeHandler(event) {
    const job = this.job
    if (job.bookingAgent && parseInt(job.bookingAgent) > 0) {
      job.preBookingAgent = job.bookingAgent
    }
    if (!event.value) {
      job.bookingAgent = 0
      return
    }
    // 这个验证必须在 job.bookingAgent = event.value 赋值之前，否则此验证无意义
    SEUtils.refreshChargeAccountId(job, 'bookingAgent', this.view.$t('SeaExport.BookingAgent'), this.view.context.modifiedData) // 这里返回true 说明修改了费用结算对象以及开票抬头，需要将费用参与保存
    job.bookingAgent = event.value
    if (!job.bookingAgent) return
    this.carrierAgentSyncLoading().then(r => {})
    this.bookingAgentChangeCl()
    this.view.context.reloadCharge = true
    const i = this.view.wtCompanyList.findIndex(p => p.companyName.trim() === event.chineseName.trim() && !p.nowHave)
    if (i > -1) {
      const message = `<div style="text-align:center">${this.view.$t('queryJob.bookingAgent')}<span style="font-weigh:bold;font-size:14px"><b>@` + event.chineseName + `</b></span>${this.view.$t('SeaExport.ItServiceProviderOfHouse')}</div>` +
          `<div style="text-align:center">${this.view.$t('SeaExport.YouHisPartnerAndService')}</div>`
      this.view.$confirm(message, this.view.$t('FileHistory.Tips'), {
        confirmButtonText: this.view.$t('common.btn.ok'),
        cancelButtonText: this.view.$t('common.btn.cancel'),
        dangerouslyUseHTMLString: true,
        showClose: false
      }).then(() => {
        const examineData = {}
        examineData.pushBranchCode = $store.getters.currentOffice.code
        examineData.nowCheckAll = false
        examineData.companyList = [
          this.view.wtCompanyList[i]
        ]
        wTSendHandler(examineData).then(res => {
          if (res.data) {
            const url = this.wtPageUrl + '#/customerEnterpriseApply?key=' + res.data + '&sessionId=' + getToken()
            console.log('openUrl:', url)
            window.open(url)
          }
        }).finally(() => {})
      })
    }
  }
  /**
   * 是否同步船代
   */
  async carrierAgentSyncLoading() {
    if (this.job.bookingAgent > 0) {
      const company = await Company.getCompanyById(this.job.bookingAgent)
      if (company && company.seaCmpAgent) {
        this.job.carrierAgentId = this.job.bookingAgent
      }
    }
  }
  /**
   * 揽货类型选择
   */
  async cargoSourceChange(event) {
    const job = this.job
    this.loadDestinationAgentDetaiHandler().then(r => {})
    if (job.cargoSource === CargoSource.NC_CARGO_SOURCE.code) {
      job.sales = 0
      job.salesOffice = 0
      job.salesDepartment = 0
      this.view.txtSalesOffice = ''
      this.view.salesList = null
      job.paymentTermHBL = 'CC'
      this.loadOverseaAgentDetailOwner(job.designationAgent).then(r => {})
      // HBL放单，当揽货类型为指定时，默认勾选公司自出单
      const hblDoc = await new SeaExportJob(job).getMainHbl()
      if (hblDoc) {
        hblDoc.customerSelfRelease = 2
      }
      // CARGO-32120 业务的货物类型选择为【指定货】时，合作伙伴对应的服务人员功能没有限制销售的显示
      this.loadCompanyUser()// 销售
      this.job.incoTerm = ColumnUtils.getIncoTermIsFobOrCif('FOB')
    } else {
      job.paymentTermHBL = 'PP'
      job.designationAgent = 0
      job.agentLevel = ''
      await this.customerIdChangeNew(event)
      this.loadCompanyUser()
      this.job.incoTerm = ColumnUtils.getIncoTermIsFobOrCif('CIF')
    }
    const hblPaymentTerm = this.context.paymentTermList.find(p => p.code === job.paymentTermHBL)
    if (hblPaymentTerm) {
      this.paymentSelectHblChange(hblPaymentTerm.code, hblPaymentTerm.name)
    }
    if (this.lclslaveEnabled) {
      job.paymentTermMBL = job.paymentTermHBL
      await this.paymentTermMBL_Change(job.paymentTermMBL)
    }
    await this.loadCustomerPortDestinationAgents()
    await CargoDocUtil.changeHBLAgentParty(job)
    if (job.cargoSource === CargoSource.NC_CARGO_SOURCE.code) { // 如果是指定货
      await this.loadOverseaAgentUserByLob(job.designationAgent) // 根据指定货确定海外客服
    } else {
      await this.loadOverseaAgentUserByLob(job.destinationAgent)// 还是根据目的港代理确定海外客服
    }
    this.checkNewJobCreditInfo()
    JobUtils.matchUserPortConfig(this.view, this.job)
  }
  /**
   * 校验新增业务的信控
   * @param job
   * @returns {Promise<void>}
   */
  async checkNewJobCreditInfo() {
    const job = this.job
    if (this.view.creditOpen && StrUtils.isEmpty(job.uuid)) {
      // 新增业务时，需要判断是否可以新增该业务 CARGO-9472 超信控的合作伙伴不能新增业务
      const checkResult = this.checkNewJobCreditInfoFunc(job)
      this.view.processingPromiseList.push(checkResult)
      try {
        await checkResult
      } finally {
        const index = this.view.processingPromiseList.indexOf(checkResult)
        if (index > -1) {
          this.view.processingPromiseList.splice(index, 1)
        }
      }
    }
  }
  /**
   * 校验新增业务的信控
   * @param job
   * @returns {Promise<void>}
   */
  async checkNewJobCreditInfoFunc(job) {
    const params = JobUtils.getCreditCheckJob(job)
    const res = await canCreateByCreditInfoDetail(params)
    if (res.data > 0) {
      const msg = {
        dangerouslyUseHTMLString: true,
        message: await JobUtils.checkDateAndAmountExceeded(res.data),
        type: 'warning',
        duration: 5000
      }
      this.view.$message.warning(msg)
      if (job.cargoSource === CargoSource.NC_CARGO_SOURCE.code) {
        this.view.showWarningImageA = false
        job.designationAgent = 0
      } else {
        this.view.showWarningImageB = false
        job.customerId = 0
      }
    }
  }
  /**
   * 加载海外客服信息
   */
  loadOverseaOpChanged() {
    this.getOverseaAgentUserByConfig()
  }
  /**
   * 加载海外客服
   */
  // private var _cmpId: int = 0
  async loadOverseaAgentChanged() {
    if (this.view.isHC) {
      return
    }
    const job = this.job
    let cmpIdx = 0
    if (job.cargoSource === CargoSource.NC_CARGO_SOURCE.code) {
      cmpIdx = job.designationAgent // 根据指定货确定海外客服
    } else {
      cmpIdx = job.destinationAgent // 还是根据目的港代理确定海外客服
    }
    const cmp = this.companyList.find(p => p.cmpIdx === cmpIdx)
    if (cmp) {
      const agent = await new Company(cmp).getOverseaAgentDetail()
      if (agent) {
        const overseaAgentUsers = await new OverseaAgent(agent).getOverseaAgentUserList()
        // 海外客服
        const overseaAgentUsersList = []
        if (overseaAgentUsers && overseaAgentUsers.length > 0) {
          for (const u of overseaAgentUsers) {
            if (u.lob === this.job.lob || !u.lob || u.lob === 'ALL') {
              const user = this.userList.find(p => p.userId === u.userId)
              if (user && user.active) {
                if (u.roleType === CargoOfRoleType.OVERSEAOP_TYPE.code) { // 海外客服
                  overseaAgentUsersList.push(user)
                }
              }
            }
          }
        }
        // 海外客服
        this.view.overseaAgentUsersList = overseaAgentUsersList
      } else {
        await this.getOverseaAgentUserByConfig()
      }
    }
    // if (job.cargoSource == CargoSource.NC_CARGO_SOURCE.code)//如果是指定货
    // {
    //   _cmpId = job.designationAgent
    // } else {
    //   _cmpId = job.destinationAgent
    // }
    // if (_cmpId > 0) {
    //   var company: Company = Company.getCompanyById(_cmpId)
    //   if (company) {
    //     if (company.needLoadOverseaAgentDetail()) {
    //       company.loadOverseaAgentDetail2(loadDestinationAgentDetai2Handler, view.faultHandler)
    //     }
    //     else {
    //       loadDestinationAgentDetai2Handler()
    //     }
    //   }
    //   else {
    //     job.overseaOp = view.txtOverseaOp.selectedId = 0
    //     job.overseaOpDepartment = 0
    //     view.txtOverseaOp.userData = null
    //     view.txtOverseaOp.validateNow()
    //   }
    // }
  }
  loadDestinationAgentDetai2Handler(evt = null) {
    // var company: Company = Company.getCompanyById(_cmpId)
    // if (company) {
    //   var agent: OverseaAgent = company.overseaAgentDetail
    //   if (agent) {
    //     if (agent.needLoadOverseaAgentUser()) {
    //       agent.loadOverseaAgentUser2(loadOverseaAgentUser2Handler, view.faultHandler)
    //     }
    //     else {
    //       loadOverseaAgentUser2Handler()
    //     }
    //   }
    // }
  }
  loadOverseaAgentUser2Handler(e = null) {
  }
  /**
   * 按业务指定海外客服
   */
  async loadOverseaAgentUserByLob(cmpIdx) {
    if (this.view.isHC) {
      return
    }
    const job = this.job
    const cmp = this.companyList.find(p => p.cmpIdx === cmpIdx)
    if (cmp) {
      const overseaAgentDetail = await new Company(cmp).getOverseaAgentDetail()
      this.loadDestinationAgentDetaiHandler(overseaAgentDetail)
    } else {
      this.view.overseaAgentUsersList = []
      await this.getOverseaAgentUserByConfig()
      // CARGO-32467 切换揽货类型，目的港代理，指定货代理时若不存在对应代理公司不赋值到海外客服
      job.overseaOp = 0
      job.overseaOpDepartment = 0
      // const firstOption = this.view.overseaAgentUsersList[0]
      // job.overseaOp = firstOption ? firstOption.userId : 0
      // job.overseaOpDepartment = 0
      // if (firstOption) {
      //   const dep = await new User(firstOption).getDefaultDepartment('role', 'overseaOp')
      //   if (dep) {
      //     job.overseaOpDepartment = dep.departmentId
      //   }
      // }
    }
  }
  async loadDestinationAgentDetaiHandler(agent) {
    if (this.view.isHC) {
      return
    }
    if (!agent) {
      const job = this.job
      const cmpIdx = job.cargoSource === CargoSource.NC_CARGO_SOURCE.code ? job.designationAgent : job.destinationAgent
      const company = this.companyList.find(p => p.cmpIdx === cmpIdx)
      if (company) {
        agent = await new Company(company).getOverseaAgentDetail()
      }
    }
    if (agent) {
      const overseaAgentUserList = await new OverseaAgent(agent).getOverseaAgentUserList()
      await this.loadOverseaAgentUserHandler(overseaAgentUserList)
    } else {
      await this.getOverseaAgentUserByConfig()
    }
  }
  async loadOverseaAgentUserHandler(overseaAgentUsers) {
    // 海外客服
    const overseaAgentUsersList = []
    let overseaAgentUserDefaultId = 0
    if (overseaAgentUsers && overseaAgentUsers.length > 0) {
      for (const u of overseaAgentUsers) {
        if (u.lob === this.job.lob || !u.lob || u.lob === 'ALL') {
          const user = this.userList.find(p => p.userId === u.userId)
          if (user && user.active) {
            if (u.roleType === CargoOfRoleType.OVERSEAOP_TYPE.code) { // 海外客服
              if (u.defaultUser) {
                overseaAgentUserDefaultId = u.userId
              }
              overseaAgentUsersList.push(user)
            }
          }
        }
      }
    }
    // 海外客服
    this.view.overseaAgentUsersList = overseaAgentUsersList
    // 海外客服默认值
    if (overseaAgentUsersList.length > 0) {
      let overseaOp = 0
      if (overseaAgentUserDefaultId > 0) {
        overseaOp = overseaAgentUserDefaultId
      } else {
        overseaOp = overseaAgentUsersList[0].userId
      }

      let newUser = null
      if (overseaOp > 0) {
        newUser = this.userList.find(p => p.userId === overseaOp)
      }

      if (newUser && overseaOp !== this.job.overseaOp) {
        // 复制时判断
        if (this.view.isCopy) {
          const overseaUser = this.userList.find(p => p.userId === this.job.overseaOp)
          const oldOverseaUser = !overseaUser ? '' : !overseaUser.chineseName ? overseaUser.englishName : overseaUser.chineseName// 原业务 海外客服
          const newOverseaUser = !newUser ? '' : !newUser.chineseName ? newUser.englishName : newUser.chineseName// 新 海外客服
          if (overseaUser && this.isActiveOverSeaOp() && overseaAgentUsersList.find(p => p.userId === overseaUser.userId)) {
            overseaOp = this.job.overseaOp
          } else {
            let msg = this.view.$t('SeaExport.OverseaCustomerUpdate')
            msg = msg.replace('{0}', oldOverseaUser)
            msg = msg.replace('{1}', newOverseaUser)
            this.view.$confirm(msg, this.view.$t('Message.Prompt'), {
              confirmButtonText: this.view.$t('common.btn.ok'),
              cancelButtonText: this.view.$t('common.btn.cancel'),
              closeOnClickModal: false,
              type: 'warning'
            }).then(() => {
              this.job.overseaOp = overseaOp
            }).catch(() => {
              this.job.overseaOp = 0
            }).finally(() => {
              this.overseaOpChangeHandler()
            })
          }
        } else {
          this.job.overseaOp = overseaOp
          this.overseaOpChangeHandler()
        }
      }
    } else {
      this.job.overseaOp = 0
      this.job.overseaOpDepartment = 0
      await this.getOverseaAgentUserByConfig()
    }
  }
  async getOverseaAgentUserByConfig() {
    if (this.view.isHC) {
      return
    }
    const overseaAgentUsersConfig = parseInt(this.config.get('overseaAgentUsersConfig'))
    if (overseaAgentUsersConfig === 1) {
      this.view.overseaAgentUsersList = await this.view.$refs.overseaOp.getUsersByPrivilegeDetail(`role-overseaOp--${null}-${true}`, 'role', 'overseaOp', '', null, true)
    }
  }
  /**
   * 目的港代理选择
   */
  async txtDestinationAgentChangeHandler(data) {
    const job = this.job
    this.view.sopImageC = false
    this.view.showWarningImageC = false
    if (!data || !data.value) {
      job.destinationAgent = 0
      this.getOverseaAgentUserByConfig()
      return
    }
    // 是否同步到指定货代理
    const syncDesignationAgent = (this.refSelDesignationAgent || job.designationAgent === 0) && data.designationAgent
    // 是否指定货
    const isNc = job.cargoSource === CargoSource.NC_CARGO_SOURCE.code
    if (this.view.creditOpen && data.value > 0) {
      this.checkCreditByCompany(data.value, syncDesignationAgent && isNc ? 4 : 3)
    } else {
      if (data && this.view.sopConfigOpen) {
        this.view.sopImageC = data.ifOpenSop
        if (syncDesignationAgent && isNc) {
          this.view.sopImageA = data.ifOpenSop
        }
      }
    }
    job.destinationAgent = data.value
    if (job.cargoSource === CargoSource.SC_CARGO_SOURCE.code) { // 自揽货， 清空海外客服，根据目的港代理带出对应维护的海外客服
      if (!this.view.isHC) {
        this.view.overseaAgentUsersList = []
        this.job.overseaOp = 0
        this.job.overseaOpDepartment = 0
        this.loadOverseaAgentUserByLob(job.destinationAgent).then(r => {
        })
      }
    } else { // 指定货
      // 当前refSelDesignationAgent参数开启或者指定代理为空的时候,并且选择的合作伙伴类型是指定货代理时， 把目的港代理同步到指定货代理栏位
      if (syncDesignationAgent) {
        job.designationAgent = data.cmpIdx
        await this.checkNewJobCreditInfo()
        this.loadOverseaAgentUserByLob(job.designationAgent)
        this.loadOverseaAgentDetail()
      }
    }
    CargoDocUtil.checkOverseaAgentProperties(job)
    JobUtils.matchUserPortConfig(this.view, job)
  }
  /**
   * 指定货代理选择
   */
  designationAgentChangeHandler(data) {
    const job = this.job
    job.designationAgent = data.value || 0
    this.view.sopImageA = false
    this.view.showWarningImageA = false
    if (this.view.creditOpen && data.value > 0) {
      this.checkCreditByCompany(data.value, 2)
      this.checkNewJobCreditInfo()
    } else {
      const company = this.companyList.find(p => p.cmpIdx === job.designationAgent)
      if (this.view.sopConfigOpen && company) {
        // 判断该合作伙伴是否开启SOP
        this.view.sopImageA = company.ifOpenSop
      }
    }
    if (job.designationAgent > 0) {
      CargoDocUtil.changeHBLAgentParty(job).then(r => {})
      this.loadOverseaAgentDetail()
      if (job.cargoSource === CargoSource.NC_CARGO_SOURCE.code) {
        this.loadOverseaAgentUserByLob(job.designationAgent)// 根据指定货确定海外客服
      }
    } else {
      if (job.cargoSource === CargoSource.NC_CARGO_SOURCE.code) {
        if (!this.view.isHC) {
          job.overseaOp = 0
          job.overseaOpDepartment = 0
          this.view.overseaAgentUsersList = []
        }
      }
    }
  }
  /**
   * 本地服务选择
   */
  loadingTermChange(fieldName) {
    const job = this.job
    if (fieldName === 'warehousing') {
      if (!job.warehousing) {
        job.warehouseCmp = 0
        if (!job.uuid && this.view.isCopy) { // 复制的时候,取消勾选，要清空
          job.warehouseInfo = []
          job.warehouseName = ''
          if (this.context && this.context.modifiedData && this.context.modifiedData.warehouseInfo) {
            this.context.modifiedData.warehouseInfo = []
          }
        } else {
          if (job.warehouseInfo && job.warehouseInfo.length > 0) {
            for (const item of job.warehouseInfo) {
              if (item.uuid) {
                item.jobUuid = ''
                this.addWarehouseToModifiedSet(item)
              } else {
                this.removeWarehouseFromModifiedSet(item)
              }
            }
          }
        }
      }
    } else if (fieldName === 'landTransportation') {
      if (!job.landTransportation) {
        job.carryingCmp = 0
        if (!job.uuid && this.view.isCopy) { // 复制的时候,取消勾选，要清空
          job.trucking = []
        } else {
          // 取消勾选客户门点/提货，清空客户门点页签信息
          if (job.trucking && job.trucking.length > 0) {
            for (const item of job.trucking) {
              if (item.uuid) {
                item.jobUuid = ''
                this.addTruckingToModifiedSet(item)
              } else {
                this.removeTruckingFromModifiedSet(item)
              }
            }
          }
        }
      }
    }
    this.warehouseNoeditableCl()
  }
  /**
   * 自动配货(外部接口)
   */
  async autoAllocateExternalHandler() {
    if (!this.job.uuid) {
      throw new ErrorTip('亲，请先保存业务，再进行自动配货操作。')
    }
    this.context.loading = true
    try {
      await WarehouseIn.externalAutoAllocate(this.job.uuid, this.job.warehouseNo)
      await this.externalAllocateResultHandler()
    } finally {
      this.context.loading = false
    }
  }
  /**
   * 配货结果返回
   */
  async externalAllocateResultHandler() {
    this.job.warehouseIn = ''
    const data = await new SeaExportJob(this.job).getWarehouseIn()
    this.reloadWarehouseInResultHandler(data)
  }
  reloadWarehouseInResultHandler(warehouseIn) {
    if (warehouseIn && warehouseIn.length > 0) {
      this.view.$message.success(this.view.$t('Message.DistributedSuccessfully'))
    } else {
      this.view.$message.error(this.view.$t('SeaExport.DistributionFailed'))
    }
  }
  /**
   * 刷新进仓编号
   */
  async clickWarehouseNoHandler() {
    const hbl = []
    const list = await new SeaExportJob(this.job).getSeaCargoDoc()
    if (list) {
      for (const doc of list) {
        if (doc.docType === CargoDocConsts.HBL2) {
          if (!hbl.includes(doc.warehouseNo)) {
            hbl.push(doc.warehouseNo)
          }
        }
      }
    }
    hbl.sort()
    this.job.warehouseNo = hbl.join(',')
  }
  /**
   * 检查业务参考号是否存在
   */
  async customerRefNoFocusOutHandler(event) {
    const job = this.job
    if (!StrUtils.isEmpty(job.customerRefNo)) {
      job.customerRefNo = job.customerRefNo.trim()
      const checkJobFields = {}
      checkJobFields.customerRefNo = job.customerRefNo
      const fieldExistResult = await SeaExportJob.checkJobFieldExist(this.view.$store.getters.currentOfficeId, job.lob, checkJobFields, job.uuid)
      if (fieldExistResult.customerRefNo) {
        this.view.customerRefNoTip = this.view.$t('Message.BusinessReferenceNoReduplicated')
      } else {
        this.view.customerRefNoTip = ''
      }
    }
  }
  checkJobFiledExistHandler(evt = null) {
    // if (evt && evt.result as Boolean) {
    //   view.txtCustomerRefNo.toolTip = resourceManager.getString('Message', 'BusinessReferenceNoReduplicated')
    //   view.txtCustomerRefNo.setStyle('color', 'red')
    // }
    // else {
    //   view.txtCustomerRefNo.toolTip = ''
    //   view.txtCustomerRefNo.setStyle('color', '0x000000')
    // }
  }

  /**
   * 报关行
   */
  customsBrokerChangeHandler(data) {
    const job = this.job
    // 这个验证必须在 job.customsBroker = data.value 赋值之前，否则此验证无意义
    SEUtils.refreshChargeAccountId(job, 'customsBroker', this.view.$t('SeaExport.CustomsBroker'), this.view.context.modifiedData) // 这里返回true 说明修改了费用结算对象以及开票抬头，需要将费用参与保存
    job.customsBroker = data.value
    this.view.context.reloadCharge = true
  }

  /**
   * 运输公司
   */
  async carryingCmpChangeHandler(data) {
    const job = this.job
    // 这个验证必须在 job.carryingCmp = data.value 赋值之前，否则此验证无意义
    SEUtils.refreshChargeAccountId(job, 'carryingCmp', this.view.$t('SeaExport.HaulageCompany'), this.view.context.modifiedData) // 这里返回true 说明修改了费用结算对象以及开票抬头，需要将费用参与保存
    job.carryingCmp = data.value
    this.view.context.reloadCharge = true
    if (job.trucking.length === 0) {
      const newData = new TruckingInfo().fillDefaultValue().getData()
      newData.loadingPortService = true
      newData.jobUuid = job.uuid
      job.trucking.push(newData)
    }
    const truckingInfo = job.trucking[0]
    truckingInfo.carryingCmp = job.carryingCmp
    if (!job.carryingCmp || job.carryingCmp === 0) {
      truckingInfo.driver = ''
      truckingInfo.driverTel = ''
    }
    if (String(cache.config.get('ToExoSystem')) === 'XYCW' && this.job.etd) {
      if (truckingInfo.carryingCmp) {
        truckingInfo.loadingDate = DateUtils.addDays2(this.job.etd, -3)
      } else {
        truckingInfo.loadingDate = ''
      }
    }
    this.addTruckingToModifiedSet(truckingInfo)
    await JobUtils.getDriverInformationByCarryingCap(truckingInfo, truckingInfo.carryingCmp)
    // 目的港派车
    if (job.dischargingTrucking.length > 0) {
      const dischargingTruckingInfo = job.dischargingTrucking.length[0]
      dischargingTruckingInfo.carryingCmp = job.carryingCmp
      if (!job.carryingCmp) {
        dischargingTruckingInfo.driver = ''
        dischargingTruckingInfo.driverTel = ''
      }
      this.context.modifiedData.dischargingTruckingInfo = job.dischargingTrucking
    }
  }
  // 添加truckingInfo到被修改的集合中
  addTruckingToModifiedSet(truckingInfo) {
    const modifiedData = this.context.modifiedData
    modifiedData.truckingInfo = modifiedData.truckingInfo || []
    if (!modifiedData.truckingInfo.includes(truckingInfo)) {
      modifiedData.truckingInfo.push(truckingInfo)
    }
  }
  // 将truckingInfo从被修改的集合中移除
  removeTruckingFromModifiedSet(truckingInfo) {
    const modifiedData = this.context.modifiedData
    if (modifiedData.truckingInfo && modifiedData.truckingInfo.includes(truckingInfo)) {
      const index = modifiedData.truckingInfo.indexOf(truckingInfo)
      if (index > -1) {
        modifiedData.truckingInfo.splice(index, 1)
      }
    }
  }
  preWarehousingChangeHandler() {
    const job = this.job
    const warehouse = job.warehouseInfo[0]
    if (warehouse) {
      warehouse.arriveDate = this.view.fbaJob.preWarehousingTime
      this.addWarehouseToModifiedSet(warehouse)
    }
  }
  /**
   * 仓库
   */
  async warehouseCmpChangeHandler(data) {
    if (this.view.isFba) {
      this.view.fbaJob.domesticWarehouse = data.value || 0
    }
    const job = this.job
    job.warehouseCmp = data.value || 0
    job.warehouseRecord = job.warehouseCmp
    if (job.warehouseInfo.length === 0) {
      const newData = new WarehouseInfo().fillDefaultValue().getData()
      newData.jobUuid = job.uuid
      job.warehouseInfo.push(newData)
    }
    this.view.warehouseNameList = []
    if (job.warehouseCmp > 0) {
      const companyCache = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', job.warehouseCmp)
      if (companyCache) {
        getWarehouseDetail(companyCache.uuid).then(res => {
          if (res.data.length > 0) {
            this.view.warehouseNameList = res.data
          }
        })
      }
    }
    // 通过此方法加载 warehouseInfo 的联系电话地址等
    await this.getWarehouseInfo()
    const warehouse = job.warehouseInfo[0]
    warehouse.warehouseCmp = job.warehouseCmp
    if (warehouse.warehouseCmp && warehouse.warehouseCmp > 0) warehouse.deleted = false
    job.warehouseName = warehouse.warehouseName
    this.addWarehouseToModifiedSet(warehouse)
  }
  // 添加warehouseInfo到被修改的集合中
  addWarehouseToModifiedSet(warehouse) {
    const modifiedData = this.context.modifiedData
    modifiedData.warehouseInfo = modifiedData.warehouseInfo || []
    if (!modifiedData.warehouseInfo.includes(warehouse)) {
      modifiedData.warehouseInfo.push(warehouse)
    }
  }
  // 将warehouseInfo从被修改的集合中移除
  removeWarehouseFromModifiedSet(warehouse) {
    const modifiedData = this.context.modifiedData
    if (modifiedData.warehouseInfo && modifiedData.warehouseInfo.includes(warehouse)) {
      const index = modifiedData.warehouseInfo.indexOf(warehouse)
      if (index > -1) {
        modifiedData.warehouseInfo.splice(index, 1)
      }
    }
  }
  /**
   * 分单运输条款
   */
  async freightTermHBLChange() {
    const job = this.job
    const cargoDocs = await new SeaExportJob(job).getCargoDoc()
    const hbl2CargoDocs = []
    if (cargoDocs && cargoDocs.length > 0) {
      for (const cargoDoc of cargoDocs) {
        if (cargoDoc.docType === CargoDocConsts.HBL) {
          cargoDoc.freightTermHBL = job.freightTermHBL
        } else if (cargoDoc.docType === CargoDocConsts.HBL2) {
          hbl2CargoDocs.push(cargoDoc)
        }
      }
      if (hbl2CargoDocs.length > 0) {
        const hbl2CargoDoc = hbl2CargoDocs[0]
        hbl2CargoDoc.freightTermHBL = job.freightTermHBL
      }
    }
  }

  /**
   * 修改货物信息
   */
  async cargoCodeChange(data) {
    const job = this.job
    job.cargoCode = data
    if (data === null || data === '') {
      job.cargoCode = data
      job.cargoName = ''
    } else {
      const cargoInformation = getObjectByCache(basicCacheKeys.basic_data_CargoInformation, 'code', data)
      if (cargoInformation) {
        job.cargoCode = cargoInformation.code
        job.cargoName = cargoInformation.englishName
      }
    }
  }
  /**
   * 主单运输条款
   */
  async paymentTermMBLChange() {
    this.paymentPlaceBLShowChange().then(r => {})
    await this.portChange()
    await this.setPlannerChange()
  }
  /**
   * 主单运费方式
   */
  async paymentTermMBL_Change(value) {
    this.job.paymentTermMBL = value
    await this.paymentPlaceBLShowChange()
    await this.portChange()
  }
  async paymentPlaceBLShowChange() {
    if (!this.job.paymentTermMBL) return
    this.isShowAcPaymentPlaceBL = false
    const paymentTermMblName = this.context.paymentTermList.find(p => p.code === this.job.paymentTermMBL)
    const isContainerElseWhere = paymentTermMblName && !StrUtils.isEmpty(paymentTermMblName.name) && paymentTermMblName.name.toUpperCase().indexOf('ELSEWHERE') >= 0
    if (isContainerElseWhere) {
      this.isShowAcPaymentPlaceBL = true
      const mbl = await new SeaExportJob(this.job).getCargoDocByDocType(CargoDocConsts.MBL, true)
      this.view.mblDoc.paymentPlaceBL = mbl.paymentPlaceBL
    }
  }
  /**
   * 主单付款地点
   */
  fieldChangeHandler(event) {
    // switch (event.currentTarget) {
    //   case view.txtPaymentPlaceBL:
    //     mblDoc.paymentPlaceBL = view.txtPaymentPlaceBL.text
    //     var mbl2: SeaCargoDoc = job.getCargoDoc(CargoDocConsts.MBL2, false)
    //     if (mbl2 != null) {
    //       mbl2.paymentPlaceBL = mblDoc.paymentPlaceBL
    //     }
    //     break
    //   default: break
    // }
  }
  /**
   * 分单运输条款
   */
  async paymentSelectHblChange(paymentCode) {
    this.job.paymentTermHBL = paymentCode || ''
    await this.portChange()
    await this.setPlannerChange()
  }
  /**
   * 订舱性质
   */
  bookingTermChange(value) {
    // job.bookingTerm = value
    this.warehouseNoeditableCl()
  }
  /**
   * 双击打开备注窗
   */
  // private var _field: *
  // private var _editWindow: TextAreaPopup = null
  onDblClick(title, field, content, isUpperCase = false) {
    // if (_editWindow == null) {
    //   _editWindow = new TextAreaPopup()
    // }
    // _editWindow.content = content
    // _editWindow.isEditing = isEditing
    // _editWindow.isUpperCase = isUpperCase
    // _editWindow.removeEventListener(CloseEvent.CLOSE, textInputSubmitHandler)
    // _editWindow.addEventListener(CloseEvent.CLOSE, textAreaSubmitHandler)
    // PopUpUtils.addPopUp(_editWindow, view, true)
    // _editWindow.title = title
    // this._field = field
  }
  textAreaSubmitHandler(event) {
    // this._field.text = _editWindow.content
  }
  textInputSubmitHandler(event) {
    // var s: String = ''
    // var r: Array = _editWindow.content.split('\r')
    // var defaultLength: int = 7
    // if (r.length < defaultLength) {
    //   var d: int = defaultLength - r.length
    //   for (var j: int = 0 j < d j++) {
    //     r.push('')
    //   }
    // }
    // for (var i: int = 1 i <= r.length i++) {
    //   var text: String = r.length >= i ? r[i - 1] : ''
    //   if (i < defaultLength) {
    //     view[_field + '' + i].text = text
    //   }
    //   else {
    //     if (s.length > 0)
    //       s += '\r'
    //     s += text
    //   }
    // }
    // CargoDocUtil.refreshFieldLine7Value(_field, job, s)
  }
  /**
   * 发货人选择
   */
  async shipperChange(data) {
    const form = this.job
    form.shipperId = data.value
    const sycSCN = await parseInt(this.config.get('synchronousShipperCodeAndConsigneeCodeAndNotifyCode')) === 1
    if (form.shipperId) {
      // 将收发通代码同步至提单页签收发通代码(不考虑拆并单)
      const company = new Company(data)
      const manifestAddress = await company.getManifestAddress()
      if (manifestAddress) {
        form.shipperLine1 = manifestAddress.addressLine1
        form.shipperLine2 = manifestAddress.addressLine2
        form.shipperLine3 = manifestAddress.addressLine3
        form.shipperLine4 = manifestAddress.addressLine4
        form.shipperLine5 = manifestAddress.addressLine5
        form.shipperLine6 = manifestAddress.addressLine6
        form.shipperLine7 = manifestAddress.addressLine7
      } else {
        form.shipperLine1 = ''
        form.shipperLine2 = ''
        form.shipperLine3 = ''
        form.shipperLine4 = ''
        form.shipperLine5 = ''
        form.shipperLine6 = ''
        form.shipperLine7 = ''
      }
      await JobUtils.synchronousShipperCodeAndConsigneeCodeAndNotifyCode(this.job, sycSCN, 'shipper', 0, manifestAddress)
    } else {
      await JobUtils.synchronousShipperCodeAndConsigneeCodeAndNotifyCode(this.job, sycSCN, 'shipper', 0, null)
    }
    const syncCustomerShippingInfoBothBolAndBasicTab = parseInt(this.config.get('SyncCustomerShippingInfoBothBolAndBasicTab')) === 0 || parseInt(this.config.get('SyncCustomerShippingInfoBothBolAndBasicTab')) === 1 ||
        (parseInt(this.config.get('SyncCustomerShippingInfoBothBolAndBasicTab')) === 2 && (this.view.action === 'add' || this.view.action === 'copy'))
    if (syncCustomerShippingInfoBothBolAndBasicTab) {
      this.syncDocSft(true, false, false)
    }
  }
  /**
   * 收货人选择
   */
  async consigneeChange(data) {
    const form = this.job
    form.consigneeId = data.value
    const sycSCN = await parseInt(this.config.get('synchronousShipperCodeAndConsigneeCodeAndNotifyCode')) === 1
    // 将收发通代码同步至提单页签收发通代码(不考虑拆并单)
    if (form.consigneeId) {
      const company = new Company(data)
      const manifestAddress = await company.getManifestAddress()
      if (manifestAddress) {
        form.consigneeLine1 = manifestAddress.addressLine1
        form.consigneeLine2 = manifestAddress.addressLine2
        form.consigneeLine3 = manifestAddress.addressLine3
        form.consigneeLine4 = manifestAddress.addressLine4
        form.consigneeLine5 = manifestAddress.addressLine5
        form.consigneeLine6 = manifestAddress.addressLine6
        form.consigneeLine7 = manifestAddress.addressLine7
      } else {
        form.consigneeLine1 = ''
        form.consigneeLine2 = ''
        form.consigneeLine3 = ''
        form.consigneeLine4 = ''
        form.consigneeLine5 = ''
        form.consigneeLine6 = ''
        form.consigneeLine7 = ''
      }
      await JobUtils.synchronousShipperCodeAndConsigneeCodeAndNotifyCode(this.job, sycSCN, 'consignee', 0, manifestAddress)
    } else {
      await JobUtils.synchronousShipperCodeAndConsigneeCodeAndNotifyCode(this.job, sycSCN, 'consignee', 0, null)
    }
    JobUtils.matchUserPortConfig(this.view, this.job)
    const syncCustomerShippingInfoBothBolAndBasicTab = parseInt(this.config.get('SyncCustomerShippingInfoBothBolAndBasicTab')) === 0 || parseInt(this.config.get('SyncCustomerShippingInfoBothBolAndBasicTab')) === 1 ||
        (parseInt(this.config.get('SyncCustomerShippingInfoBothBolAndBasicTab')) === 2 && (this.view.action === 'add' || this.view.action === 'copy'))
    if (syncCustomerShippingInfoBothBolAndBasicTab) {
      this.syncDocSft(false, true, false)
    }
  }
  /**
   * 通知人选择
   */
  async notifyChange(data) {
    const form = this.job
    form.notifyId = data.value
    const sycSCN = await parseInt(this.config.get('synchronousShipperCodeAndConsigneeCodeAndNotifyCode')) === 1
    // 将收发通代码同步至提单页签收发通代码(不考虑拆并单)
    if (form.notifyId) {
      const company = new Company(data)
      const manifestAddress = await company.getManifestAddress()
      if (manifestAddress) {
        form.notifyLine1 = manifestAddress.addressLine1
        form.notifyLine2 = manifestAddress.addressLine2
        form.notifyLine3 = manifestAddress.addressLine3
        form.notifyLine4 = manifestAddress.addressLine4
        form.notifyLine5 = manifestAddress.addressLine5
        form.notifyLine6 = manifestAddress.addressLine6
        form.notifyLine7 = manifestAddress.addressLine7
      } else {
        form.notifyLine1 = ''
        form.notifyLine2 = ''
        form.notifyLine3 = ''
        form.notifyLine4 = ''
        form.notifyLine5 = ''
        form.notifyLine6 = ''
        form.notifyLine7 = ''
      }
      await JobUtils.synchronousShipperCodeAndConsigneeCodeAndNotifyCode(this.job, sycSCN, 'notify', 0, manifestAddress)
    } else {
      await JobUtils.synchronousShipperCodeAndConsigneeCodeAndNotifyCode(this.job, sycSCN, 'notify', 0, null)
    }
    const syncCustomerShippingInfoBothBolAndBasicTab = parseInt(this.config.get('SyncCustomerShippingInfoBothBolAndBasicTab')) === 0 || parseInt(this.config.get('SyncCustomerShippingInfoBothBolAndBasicTab')) === 1 ||
        (parseInt(this.config.get('SyncCustomerShippingInfoBothBolAndBasicTab')) === 2 && (this.view.action === 'add' || this.view.action === 'copy'))
    if (syncCustomerShippingInfoBothBolAndBasicTab) {
      this.syncDocSft(false, false, true)
    }
  }

  /**
   * 发货人-同步格式化订单
   */
  syncShipperLineHandler(evt) {
    // view.txtshipperLine1.text = evt.data.line1
    // view.txtshipperLine2.text = evt.data.line2
    // view.txtshipperLine3.text = evt.data.line3
    // view.txtshipperLine4.text = evt.data.line4
    // view.txtshipperLine5.text = evt.data.line5
    // view.txtshipperLine6.text = ''
    // view.txtshipperLine7.text = ''
  }
  /**
   * 收货人-同步格式化订单
   */
  syncConsigneeLineHandler(evt) {
    // view.txtconsigneeLine1.text = evt.data.line1
    // view.txtconsigneeLine2.text = evt.data.line2
    // view.txtconsigneeLine3.text = evt.data.line3
    // view.txtconsigneeLine4.text = evt.data.line4
    // view.txtconsigneeLine5.text = evt.data.line5
    // view.txtconsigneeLine6.text = ''
    // view.txtconsigneeLine7.text = ''
  }
  /**
   * 通知人-同步格式化订单
   */
  syncNotifyLineHandler(evt) {
    // view.txtnotifyLine1.text = evt.data.line1
    // view.txtnotifyLine2.text = evt.data.line2
    // view.txtnotifyLine3.text = evt.data.line3
    // view.txtnotifyLine4.text = evt.data.line4
    // view.txtnotifyLine5.text = evt.data.line5
    // view.txtnotifyLine6.text = ''
    // view.txtnotifyLine7.text = ''
  }
  /**
   * 是否直单
   */
  async isMblOnlyChange() {
    this.job.signHBL = this.job.mblOnly ? false : this.job.signHBL
    // 配置是否直单取消
    const job = this.job
    const cargoDocs = await new SeaExportJob(job).getCargoDoc()
    if (cargoDocs && cargoDocs.length > 0) {
      for (const cargoDoc of cargoDocs) {
        if (cargoDoc.docType === CargoDocConsts.HBL && !job.mblOnly) {
          cargoDoc.isMblOnly = true
          break
        }
      }
    }
    // this.syncDocSft(true, true, true)
  }
  /**
   * 箱型箱种输入验证
   * 不正确 return true
   */
  checkSeaEq(seaEq) {
    // if (ContainerUtil.checkSeaEq(job, seaEq)) {
    //   MessageDialog.info('已经存在一条相同箱型箱种的记录!')
    //   return
    // }
  }
  /**
   * 包装选择
   */
  async txtPackingChangeHandler(event = null) {
    const mbl = await new SeaExportJob(this.job).getCargoDocByDocType(CargoDocConsts.MBL, false)
    const hbl = await new SeaExportJob(this.job).getCargoDocByDocType(CargoDocConsts.HBL, false)
    const billOfLadingSynMode = Number(this.config.get('BillOfLadingSynMode'))
    if (mbl) {
      if (this.job.packing) {
        if (billOfLadingSynMode === 1 || billOfLadingSynMode === 2) {
          const packing = this.packingList.find(p => p.code === this.job.packing)
          const packingName = packing ? packing.name : ''
          mbl.packingName = packingName // 包装显示名
          mbl.packing = this.job.packing
        }
      }
      if (this.job.quantityContract > 0) {
        const packing = this.packingList.find(p => p.code === this.job.packing)
        mbl.quantitySum = StrUtils.jsdx(parseInt(this.job.quantityContract), packing ? packing.name : this.job.packing)
      }
    }
    // HBL增加包装显示名
    if (hbl) {
      if (this.job.packing) {
        if (billOfLadingSynMode === 1 || billOfLadingSynMode === 2) {
          const packing = this.packingList.find(p => p.code === this.job.packing)
          const packingName = packing ? packing.name : ''
          hbl.packingName = packingName // 包装显示名
          hbl.packing = this.job.packing
        }
      }
    }
    if (this.job.packing && (this.job.containerLoadType === ContainerLoadType.FCL_CARGO_TYPE.code || this.job.containerLoadType === ContainerLoadType.BB_CARGO_TYPE.code)) {
      await new SeaExportJob(this.job).getContainerUsages()
      if (this.job.containerUsages && this.job.containerUsages.length > 0) {
        for (const item of this.job.containerUsages) {
          item.packing = this.job.packing
          item.isDirty = true
        }
      }
    }
  }
  /**
   * 抄录英文品名和唛头
   */
  copyENameMarkHandler() {
    // if (prompt1TitleWindow == null) {
    //   prompt1TitleWindow = new TranscribeWindow()
    //   prompt1TitleWindow.addEventListener(CommonFormEvent.ENTER, enter4Handler)
    // }
    // prompt1TitleWindow.job = job
    // PopUpUtils.addPopUp(prompt1TitleWindow, view, true)
  }
  enter4Handler(event) {
    // if (event.data.hasOwnProperty('cargoEnglishName'))
    //   view.txtCargoEnglishName.text = event.data['cargoEnglishName']
    // if (event.data.hasOwnProperty('mark'))
    //   view.txtMark.text = event.data['mark']
    // if (event.data.hasOwnProperty('hsCode'))
    //   view.txtHscode.text = event.data['hsCode']
  }
  /**
   * 打开hscode检索框
   */
  btnHsCodeSearchClickHandler(code) {
    // if (hsCodeSearchWindow == null) {
    //   hsCodeSearchWindow = new HsCodeSearchWindow()
    // }
    // hsCodeSearchWindow.selectedCallBack = onSaveSucceed
    // hsCodeSearchWindow.title = resourceManager.getString('Message', 'SelectHsCode')
    // PopUpUtils.addPopUp(hsCodeSearchWindow, view, true)
  }
  onSaveSucceed(hsCode) {
    // view.txtHscode.text = hsCode.code
  }
  /**
   * 中文品名选择
   */
  searchCargoCnNameEvent(evt) {
    // if (hsCodeSearchWindow == null) {
    //   hsCodeSearchWindow = new HsCodeSearchWindow()
    // }
    // hsCodeSearchWindow.selectedCallBack = onSaveSucceed2
    // hsCodeSearchWindow.title = resourceManager.getString('Message', 'SelectCargoChineseName')
    // PopUpUtils.addPopUp(hsCodeSearchWindow, view, true)
  }
  onSaveSucceed2(hsCode) {
    // view.txtCargoChineseName.text = null == hsCode ? '' : hsCode.commodityName
    // view.txtHscode.text = null == hsCode ? '' : hsCode.code
  }
  getTxtSalesPrompt() {
    this.view.$nextTick(() => {
      if ((Number(this.config.get('IsSpecifiedSalesBusiness')) === 1) && (!this.view.$refs.sales.options || this.view.$refs.sales.options.length === 0) && this.job.customerId) {
        this.view.salesPrompt = this.view.$t('SeaExport.PleaseMaintainTheCorrespondingSalesInThePartner')
      } else {
        this.view.salesPrompt = ''
      }
    })
  }
  /**
   * 当选择销售人员的时候自动关联该销售所在分公司
   */
  async salesChangeHandler(data) {
    const job = this.job
    job.sales = data.value
    job.salesOffice = 0
    this.view.txtSalesOffice = ''
    job.salesOffice = 0
    job.salesDepartment = 0
    if (data.value) {
      if (data.defaultOfficeId) { // 用户设置了默认公司和部门就用默认的
        job.salesOffice = data.defaultOfficeId
        job.salesDepartment = data.defaultDepId
        const office = await Office.getOfficeById(job.salesOffice)
        this.view.txtSalesOffice = this.view.isZh ? office.chineseName : office.englishName
      } else {
        const offices = await User.getUserDepartmentOffices('role', 'sales', data.value)
        if (offices.length > 1) {
          for (const item of offices) {
            if (this.view.branchOfficeCheck || (!this.view.branchOfficeCheck && item.officeId === this.context.office.officeId)) {
              job.salesOffice = item.officeId
              job.salesDepartment = item.departmentId
              this.loadCompanyOffice()
              break
            }
          }
        } else {
          const user = new User(data)
          const department = await user.getDefaultDepartment('role', 'sales')
          job.salesDepartment = department ? department.departmentId : 0
          const office = department ? await Office.getOfficeByUuid(department.officeUuid) : null
          if (office) {
            job.salesOffice = office.officeId
            this.view.txtSalesOffice = this.view.isZh ? office.chineseName : office.englishName
          }
        }
      }
    }
    this.dipatchChangedSalesEvent(data.userId || 0)
  }
  /**
   * 销售部门修改后，调整分公司信息
   */
  departmentChargeHandler(event = null) {
    // if (view.txtSalesDepartment.department && view.txtSalesDepartment.department.office) {
    //   var officeId: int = view.txtSalesDepartment.department.office.officeId
    //   if (officeId != job.salesOffice) {
    //     view.txtSalesOffice.text = ''
    //     job.salesDepartment = view.txtSalesDepartment.departmentId
    //     job.salesOffice = officeId
    //     loadCompanyOffice()
    //   }
    // }
  }
  async loadCompanyOffice() {
    const job = this.job
    const office = await Office.getOfficeById(job.salesOffice)
    if (office) {
      this.view.txtSalesOffice = this.view.isZh ? office.chineseName : office.englishName
    } else {
      this.view.txtSalesOffice = ''
    }
  }
  /**
   * 操作分公司选择
   */
  opOfficeChangeHandler(event) {
    // todo 下拉框数据源已经实现了动态加载过程，所以下面的代码屏蔽掉即可
    // job.opOffice = view.ddlOpOffice.opOfficeId
    // view.txtOP.queryUser('role', 'op', null, view.ddlOpOffice.opOffice)
    // view.txtDc.queryUser('role', 'doc', null, view.ddlOpOffice.opOffice)
    // if (isEntrustOrder || job.salesOffice == 1) {
    //   view.txtCSR.queryUser('role', 'csr', null, view.ddlOpOffice.opOffice)
    //   //				view.txtOverseaOp.queryUser('role','overseaOp',null,view.ddlOpOffice.opOffice)	// 海外代理
    // }
    JobUtils.opOfficeChange({ view: this.view, job: this.job, warehouseCallback: warehouseId => this.warehouseCmpChangeHandler({ value: warehouseId }), modifiedData: this.context.modifiedData })
  }
  /**
   * 操作改变
   */
  txtOPChangeHandler(user) {
    const job = this.job
    if (user.defaultDepId > 0) {
      job.opDepartment = user.defaultDepId
    } else {
      if (job.opOffice > 0) {
        new User(user).getUserDefaultDepartmentByOffice('role', 'op', job.opOffice).then(dep => {
          job.opDepartment = dep ? dep.departmentId : 0
        })
      } else {
        new User(user).getDefaultDepartment('role', 'op', job.opOffice).then(dep => {
          job.opDepartment = dep ? dep.departmentId : 0
        })
      }
    }
  }
  /**
   * 客服改变
   */
  async csrChangeHandler(data) {
    const job = this.job
    job.csr = data.value
    job.csrDepartment = 0
    job.csrOffice = 0
    if (data.value) {
      const offices = await User.getUserDepartmentOffices('role', 'csr', data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            const office = await Office.getOfficeById(item.officeId)
            job.csrOffice = office ? office.officeId : 0
            job.csrDepartment = item.departmentId
            break
          }
        }
      } else {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'csr')
        if (dep) {
          job.csrDepartment = dep.departmentId
          const office = await Office.getOfficeByUuid(dep.officeUuid)
          job.csrOffice = office ? office.officeId : 0
        }
      }
    }
  }
  /**
   * 海外客服改变
   */
  async overseaOpChangeHandler(data) {
    if (!data) {
      data = this.userList.find(p => p.userId === this.job.overseaOp)
    }
    this.job.overseaOpDepartment = 0
    if (data) {
      const offices = await User.getUserDepartmentOffices('role', 'overseaOp', this.job.overseaOp)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            this.job.overseaOpDepartment = item.departmentId
            break
          }
        }
      } else {
        const dep = await new User(data).getDefaultDepartment('role', 'overseaOp')
        this.job.overseaOpDepartment = dep ? dep.departmentId : 0
      }
    }
  }
  async dcChangeHandler(data) {
    const job = this.job
    job.dc = data.value
    job.dcDepartment = 0
    job.dcOffice = 0
    if (data.value) {
      const offices = await User.getUserDepartmentOffices('role', 'doc', data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            const office = await Office.getOfficeById(item.officeId)
            job.dcOffice = office ? office.officeId : 0
            job.dcDepartment = item.departmentId
            break
          }
        }
      } else {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'doc')
        job.dcDepartment = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        job.dcOffice = office ? office.officeId : 0
      }
    } else {
      job.dc = 0
      job.dcDepartment = 0
      job.dcOffice = 0
    }
  }
  /**
   * 航线改变
   */
  async txtPlannerChangeHandler(data) {
    const job = this.job
    if (data.value) {
      const offices = await User.getUserDepartmentOffices('role', 'seaLine', data.value)
      if (offices && offices.length > 1) {
        // 多公司仅当命中当前分公司才回填；否则不臆测，由用户手动选航线部门（保存时 Rule 1 校验必填）
        const item = offices.find(o => o.officeId === this.context.office.officeId)
        if (item) {
          const office = await Office.getOfficeById(item.officeId)
          job.plannerOffice = office ? office.officeId : 0
          this.job.plannerDepartment = item.departmentId
        }
      } else {
        const user = await User.getUserById(data.value)
        if (user) {
          const dep = await new User(user).getDefaultDepartment('role', 'seaLine')
          job.plannerDepartment = dep ? dep.departmentId : 0
          const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
          job.plannerOffice = office ? office.officeId : 0
        }
      }
    } else {
      job.planner = 0
      job.plannerDepartment = 0
      job.plannerOffice = 0
    }
  }

  async prePortPlannerChangeHandler(data) {
    await JobUtils.prePortPlannerChangeHandler(data, this.job, this)
  }
  async lastMilePlannerChangeHandler(data) {
    await JobUtils.lastMilePlannerChangeHandler(data, this.job, this)
  }

  /**
   * 修改操作要求
   */
  operationContentDoubleClickHandler(event) {
    // SelectOperationReqUtil.popUpWindow(job, isEditing, view)
  }
  /**
   * 付费条款
   */
  txtSurchargeTermsDoubleClickHandler(event) {
    // if (selectSurchargeTermsWindow == null) {
    //   selectSurchargeTermsWindow = new SelectSurchargeTermsWindow()
    //   selectSurchargeTermsWindow.addEventListener('closeEvent', loadSurchargeTermsHandler)
    // }
    // PopUpUtils.addPopUp(selectSurchargeTermsWindow, view, true)
    // selectSurchargeTermsWindow.callLater(function () {
    //   selectSurchargeTermsWindow.job = null
    //   selectSurchargeTermsWindow.job = job
    //   selectSurchargeTermsWindow.isEditing = isEditing
    // })
  }
  /**
   *  附加费条款
   */
  loadSurchargeTermsHandler(e = null) {
    // var str: String = ''
    // for each(var s: SurchargeTerms in job.surchargeTerms)
    // {
    //   if (s.chargeItemId > 0) {
    //     var c: ChargeItem = ChargeItem.getChargeItemById(s.chargeItemId)
    //     if (c) {
    //       if (resourceManager.localeChain[0] == 'zh_CN') {
    //         str += c.zhName + '：' + s.terms + '\n'
    //       }
    //       else {
    //         str += c.enName + '：' + s.terms + '\n'
    //       }
    //     }
    //   }
    // }
    // view.txtSurchargeTerms.text = str
  }
  /**
   * 代码检索
   */
  codeSeach() {
    // addrPM.job = job
    // addrPM.selectedCallBack = addSelectCallBackHandler
    // addrPM.popUpAddressWindow()
  }
  /**
   * 更新收发通舱单地址
   */
  addSelectCallBackHandler(addr) { }
  /**
   * 编辑收发通
   */
  show3LinDetail(field, title) {
    // _field = field
    // if (_editWindow == null) {
    //   _editWindow = new TextAreaPopup()
    // }
    // var s: String = ''
    // for (var i: int = 1 i <= 6 i++) {
    //   if (s.length > 0) s += '\r'
    //   if (view[field + i].text != '')
    //     s += view[field + i].text
    // }
    // s += CargoDocUtil.getFieldLine7Value(_field, job)
    // _editWindow.title = title
    // _editWindow.content = s
    // _editWindow.isEditing = isEditing
    // _editWindow.validateFun = validate6Line
    // _editWindow.isUpperCase = true
    // _editWindow.removeEventListener(CloseEvent.CLOSE, textAreaSubmitHandler)
    // _editWindow.addEventListener(CloseEvent.CLOSE, textInputSubmitHandler)
    // PopUpUtils.addPopUp(_editWindow, view, true)
  }
  validate6Line(s) {
    return true
  }
  /**
   * 手动选择销售
   */
  dipatchChangedSalesEvent(sales) {
    // var salesEvent: CommonFormEvent = new CommonFormEvent('salesChanged')
    // salesEvent.data = sales
    // view.dispatchEvent(salesEvent)
  }
  viewOtherChanged() {
    // var paymentTermHBL: String = PaymentTerm.getPaymentTermNameByCode(job.paymentTermHBL)
    // if (!StrUtils.isEmpty(paymentTermHBL)) {
    //   view.txtPaymentTermHBL.selectedIndex = -1
    //   view.txtPaymentTermHBL.text = paymentTermHBL
    //   view.txtPaymentTermHBL.selectedItem = PaymentTerm.getPaymentTerm(job.paymentTermHBL)
    // }
    // else {
    //   view.txtPaymentTermHBL.text = job.paymentTermHBL
    // }
    // view.txtPaymentTermHBL.validateNow()
    // view.txtCustomerContact.selectedIndex = -1
    // view.txtCustomerContact.validateNow()
    // view.txtCustomerContact.text = job.customerContact
    // if (StrUtils.isEmpty(job.freightTerm) && job.containerLoadType == ContainerLoadType.BULK_CARGO_TYPE.code) {
    //   view.txtFreightTerm.selectedItem = null
    // }
    // if (StrUtils.isEmpty(job.freightTermHBL) && job.containerLoadType == ContainerLoadType.BULK_CARGO_TYPE.code) {
    //   view.txtFreightTermHBL.selectedItem = null
    // }
    // if (view.dfETA && job.ETD == null) {
    //   view.dfETD.setStyle('color', 0x999999)
    //   view.dfETD.setStyle('fontStyle', 'italic')
    // } else {
    //   view.dfETD.setStyle('color', 0x0B333C)
    //   view.dfETD.setStyle('fontStyle', 'normal')
    // }
    // job.sailingDay = job.ETD != null ? DateUtils.getDayString(job.ETD) : 'MON'
    // view.containerGrid.job = null
    // view.containerGrid.job = job
  }
  /**
   * 加载客户信息
   */
  async loadCustomerDetail(event) {
    const job = this.job
    const company = this.companyList.find(p => p.cmpIdx === job.customerId)
    if (company) {
      this.view.contactList = await Company.loadContact(company.uuid)
      this.onCustomerContactLoad()
      await this.onCustomerDetailLoad(event)
    }
  }
  onCustomerContactLoad() {
    let linkMan = ''
    if (this.view.contactList && this.view.contactList.length > 0) {
      var contact = this.getDefaultContact(this.view.contactList)
      if (contact) {
        linkMan = contact.contactPerson
      }
    }
    if (this.view.isEdit) {
      this.view.form.customerContact = linkMan
    }
  }
  /**
   * 获取默认联系人
   */
  getDefaultContact(ary) {
    let rs = null
    if (ary && ary.length > 0) {
      rs = ary[0]
      for (const contact of ary) {
        if (contact.defaultContact) {
          rs = contact
          break
        }
      }
    }
    return rs
  }
  async onCustomerDetailLoad(event, source) {
    const job = this.job
    const customer = this.companyList.find(p => p.cmpIdx === job.customerId)
    const customerDetail = await Company.loadCustomer(customer.uuid).then(list => list.length > 0 ? list[0] : null)
    const oldCargoSource = job.cargoSource
    let newCargoSource = ''
    if (customer && customerDetail) {
      if (event && event.fieldName === 'cargoSource') {
        if (job.cargoSource === CargoSource.NC_CARGO_SOURCE.code) {
          this.loadOverseaAgentDetailOwner(job.designationAgent) // 指定货取指定货代理
        } else if (job.cargoSource === CargoSource.SC_CARGO_SOURCE.code) {
          this.loadCustomerDetailSales(job.customerId) // 自揽货取客户
        }
      } else if (customerDetail.designated && customerDetail.seftCanvass) {
        if (Number(this.config.get('CustomerDefaultCargoSource')) === 0) {
          newCargoSource = CargoSource.SC_CARGO_SOURCE.code
          this.loadCustomerDetailSales(job.customerId) // 自揽货取客户
        } else {
          newCargoSource = CargoSource.NC_CARGO_SOURCE.code
          this.loadOverseaAgentDetailOwner(job.designationAgent) // 指定货取指定货代理
        }
      } else {
        if (customerDetail.designated) {
          newCargoSource = CargoSource.NC_CARGO_SOURCE.code
          this.loadOverseaAgentDetailOwner(job.designationAgent) // 指定货取指定货代理
        } else if (customerDetail.seftCanvass) {
          newCargoSource = CargoSource.SC_CARGO_SOURCE.code
          this.loadCustomerDetailSales(job.customerId) // 自揽货取客户
        }
      }
      if (newCargoSource === CargoSource.SC_CARGO_SOURCE.code) {
        job.agentLevel = ''
      }
      // CARGO-15204 输入委托单位后，揽货类型会从指定货变更为自揽货的错误
      if (source !== BRING_OUT_LOGIC_CALL_SOURCE_OCR.code && oldCargoSource !== newCargoSource && newCargoSource) {
        const msg = newCargoSource === CargoSource.SC_CARGO_SOURCE.code ? this.view.$t('CargoMsg.Cargo_CustomerSpace3') : this.view.$t('CargoMsg.Cargo_CustomerSpace2')
        await this.view.$confirm(this.view.$t('CargoMsg.Cargo_CargoSourceTip', [msg]), this.view.$t('common.tips.prompt'), {
          confirmButtonText: this.view.$t('common.btn.yes'),
          cancelButtonText: this.view.$t('common.btn.no'),
          closeOnClickModal: false,
          type: 'info'
        }).then(async() => {
          job.cargoSource = newCargoSource
          await this.checkNewJobCreditInfo()
          await this.loadCustomerPortDestinationAgents()
          if (job.cargoSource === CargoSource.NC_CARGO_SOURCE.code) {
            job.paymentTermHBL = 'CC'
            job.incoTerm = ColumnUtils.getIncoTermIsFobOrCif('FOB')
          } else {
            job.paymentTermHBL = 'PP'
            job.incoTerm = ColumnUtils.getIncoTermIsFobOrCif('CIF')
          }
        }).catch(() => {
        })
      }
    }
  }
  /**
   * 自揽货 -> 加载销售(如果合作伙伴服务人员有多个则不刷新)
   */
  async loadCustomerDetailSales(companyId) {
    if (!this.isSpecifiedSalesBusiness) {
      const company = this.companyList.find(p => p.cmpIdx === companyId)
      let customerDetail
      if (company) {
        customerDetail = await Company.loadCustomer(company.uuid).then(list => list.length > 0 ? list[0] : null)
      }
      if (customerDetail) {
        const salseTemp = customerDetail.sales
        const user = this.userList.find(p => p.userId === salseTemp)
        if (user && user.active) {
          this.salesChangeHandler({ ...user, value: salseTemp })
        }
      } else {
        this.salesChangeHandler({ value: 0 })
      }
    }
  }
  /**
   * 加载销售信息
   */
  loadSalesDptOffceChanged() {
    // if (job.sales > 0) {
    //   view.txtSales.selectedId = job.sales
    //   //				view.callLater(salesChangeHandler)
    // }
  }
  /**
   * 提单是否被锁定
   */
  async checkCargoDocState() {
    const job = this.job
    this.billChargeFlag = false
    await new SeaExportJob(this.job).getCargoDoc()
    if (job.cargoDoc && job.cargoDoc.length > 0) {
      for (const cargoDoc of job.cargoDoc) {
        if (cargoDoc.state === 2 && (cargoDoc.docType === CargoDocConsts.HBL || cargoDoc.docType === CargoDocConsts.HBL2)) {
          this.billChargeFlag = true
          break
        }
      }
    }
    await this.lockBookingTab()
    this.mblDoc = await new SeaExportJob(this.job).getCargoDocByDocType(CargoDocConsts.MBL, true)
  }
  /**
   *  附加费条款
   */
  surchargeTermsTxtChanged() {
    // var str: String = ''
    // for each(var s: SurchargeTerms in job.surchargeTerms)
    // {
    //   if (s.chargeItemId > 0) {
    //     var c: ChargeItem = ChargeItem.getChargeItemById(s.chargeItemId)
    //     if (c) {
    //       if (resourceManager.localeChain[0] == 'zh_CN') {
    //         str += c.zhName + '：' + s.terms + '\n'
    //       }
    //       else {
    //         str += c.enName + '：' + s.terms + '\n'
    //       }
    //     }
    //   }
    // }
    // view.txtSurchargeTerms.text = str
  }
  /**
   * 合作伙伴对应多销售
   */
  loadCompanyMultiSales() {
    if (this.isSpecifiedSalesBusiness) {
      const company = this.companyList.find(p => p.cmpIdx === this.job.customerId)
      if (company) {
        Company.getCompanyUsers(company.uuid).then(data => {
          this.loadCompanyUser2Handler(data)
        })
      }
    }
  }
  /**
   * 合作伙伴对应多销售
   */
  async loadCompanyUser2Handler(companyUsers = null) {
    const job = this.job
    // 销售
    const salesList = []
    // 如果开启分公司过滤参数，查出来所有分公司
    let officeSaleList
    if (this.salesOfficeCheck) {
      officeSaleList = await User.getUsersByPrivilegeDetail('role', 'sales', '', this.view.$store.getters.currentOfficeId)
    }
    officeSaleList = officeSaleList || []
    if (companyUsers && companyUsers.length > 0) {
      for (const u of companyUsers) {
        const userValid = job.fba ? u.lob === SystemConstants.FBA_SE.code : u.lob === job.lob
        if (!u.lob || userValid || u.lob === 'ALL') {
          const user = this.userList.find(p => p.userId === u.userId)
          if (user && user.active) {
            if (u.roleType === CargoOfRoleType.SALES_TYPE.code) { // 销售
              if (this.salesOfficeCheck) {
                for (const obj of officeSaleList) {
                  if (user.userId === obj.userId) {
                    salesList.push(user)
                  }
                }
              } else {
                salesList.push(user)
              }
            }
          }
        }
      }
    }
    if (job.cargoSource !== CargoSource.NC_CARGO_SOURCE.code) {
      this.view.salesList = salesList
      this.getTxtSalesPrompt()
    }
  }
  /**
   * 按业务指定销售
   * @param type 类型：1、委托单位改变 2、其他
   */
  loadCompanyUser(type = 2, source) {
    if (this.isSpecifiedSalesBusiness) {
      const company = this.companyList.find(p => p.cmpIdx === this.job.customerId)
      if (company) {
        Company.getCompanyUsers(company.uuid).then(data => {
          this.loadCompanyUserHandler(data, 2, source)
        })
      }
    }
  }
  /**
   * 按业务指定销售业务处理
   * @param companyUsers
   * @param type 类型：1、委托单位改变 2、其他
   */
  async loadCompanyUserHandler(companyUsers, type = 2, source) {
    const job = this.job
    // 销售
    const salesList = []
    let salesDefaultId = 0
    // 客服
    const csrList = []
    let csrDefaultId = 0
    let matchCargoSourceCsrId = 0
    // 单证
    const dcList = []
    let dcDefaultId = 0
    let matchCargoSourceDcId = 0
    // 揽货销售
    const cargoSalesList = []
    let cargoSalesId = 0
    // 操作
    const opList = []
    let opDefaultId = 0
    // 海外客服
    const overseaOpList = []
    let overseaOpDefaultId = 0
    // 自定义岗位1
    const userDefinedRoleId1List = []
    let userDefinedRoleId1 = 0
    let matchCargoSourceUserDefinedRoleId1Id = 0
    // 自定义岗位2
    const userDefinedRoleId2List = []
    let userDefinedRoleId2 = 0
    let matchCargoSourceUserDefinedRoleId2Id = 0
    // 自定义岗位3
    const userDefinedRoleId3List = []
    let userDefinedRoleId3 = 0
    let matchCargoSourceUserDefinedRoleId3Id = 0
    // 自定义岗位4
    const userDefinedRoleId4List = []
    let userDefinedRoleId4 = 0
    let matchCargoSourceUserDefinedRoleId4Id = 0
    // 自定义岗位5
    const userDefinedRoleId5List = []
    let userDefinedRoleId5 = 0
    let matchCargoSourceUserDefinedRoleId5Id = 0
    // 自定义岗位6
    const userDefinedRoleId6List = []
    let userDefinedRoleId6 = 0
    let matchCargoSourceUserDefinedRoleId6Id = 0
    // 自定义岗位7
    const userDefinedRoleId7List = []
    let userDefinedRoleId7 = 0
    let matchCargoSourceUserDefinedRoleId7Id = 0
    // 如果开启分公司过滤参数，查出来所有分公司
    let officeSaleList
    if (this.salesOfficeCheck) {
      officeSaleList = await User.getUsersByPrivilegeDetail('role', 'sales', '', this.view.$store.getters.currentOfficeId)
    }
    officeSaleList = officeSaleList || []
    if (companyUsers && companyUsers.length > 0) {
      for (const u of companyUsers) {
        const userValid = job.fba ? u.lob === SystemConstants.FBA_SE.code : u.lob === job.lob
        if (!u.lob || userValid || u.lob === 'ALL') {
          const user = this.userList.find(p => p.userId === u.userId)
          if (user && user.active) {
            if (u.roleType === CargoOfRoleType.SALES_TYPE.code) { // 销售
              if (this.salesOfficeCheck) {
                for (const obj of officeSaleList) {
                  if (user.userId === obj.userId) {
                    if (u.defaultUser) {
                      salesDefaultId = u.userId
                    }
                    salesList.push(user)
                  }
                }
              } else {
                if (u.defaultUser) {
                  salesDefaultId = u.userId
                }
                salesList.push(user)
              }
            } else if (u.roleType === CargoOfRoleType.CSR_TYPE.code) { // 客服
              if (u.defaultUser) {
                csrDefaultId = u.userId
              }
              if (matchCargoSourceCsrId === 0 && job.cargoSource && u.cargoSource === job.cargoSource) {
                matchCargoSourceCsrId = u.userId
              }
              // 揽货类型没有 或者与当前业务相同的才能出现在下拉框 或默认值里面。
              if (!u.cargoSource || (u.cargoSource === job.cargoSource)) {
                csrList.push(user)
              }
            } else if (u.roleType === CargoOfRoleType.DOC_TYPE.code) { // 单证
              if (u.defaultUser) {
                dcDefaultId = u.userId
              }
              if (matchCargoSourceDcId === 0 && job.cargoSource && u.cargoSource === job.cargoSource) {
                matchCargoSourceDcId = u.userId
              }
              // 揽货类型没有 或者与当前业务相同的才能出现在下拉框 或默认值里面。
              if (!u.cargoSource || (u.cargoSource === job.cargoSource)) {
                dcList.push(user)
              }
            } else if (u.roleType === CargoOfRoleType.SALES_OF_GOODS.code) { // 揽货销售
              if (u.defaultUser) {
                cargoSalesId = u.userId
              }
              cargoSalesList.push(user)
            } else if (u.roleType === CargoOfRoleType.OP_TYPE.code) { // 操作
              if (u.defaultUser) {
                opDefaultId = u.userId
              }
              opList.push(user)
            } else if (u.roleType === CargoOfRoleType.OVERSEAOP_TYPE.code) { // 海外客服
              if (u.defaultUser) {
                overseaOpDefaultId = u.userId
              }
              overseaOpList.push(user)
            } else if (u.roleType === CargoOfRoleType.USER_DEFINED_ROLE1.code) { // 自定义岗位1
              if (u.defaultUser) {
                userDefinedRoleId1 = u.userId
              }
              if (matchCargoSourceUserDefinedRoleId1Id === 0 && job.cargoSource && u.cargoSource === job.cargoSource) {
                matchCargoSourceUserDefinedRoleId1Id = u.userId
              }
              // 揽货类型没有 或者与当前业务相同的才能出现在下拉框 或默认值里面。
              if (!u.cargoSource || (u.cargoSource === job.cargoSource)) {
                userDefinedRoleId1List.push(user)
              }
            } else if (u.roleType === CargoOfRoleType.USER_DEFINED_ROLE2.code) { // 自定义岗位2
              if (u.defaultUser) {
                userDefinedRoleId2 = u.userId
              }
              if (matchCargoSourceUserDefinedRoleId2Id === 0 && job.cargoSource && u.cargoSource === job.cargoSource) {
                matchCargoSourceUserDefinedRoleId2Id = u.userId
              }
              // 揽货类型没有 或者与当前业务相同的才能出现在下拉框 或默认值里面。
              if (!u.cargoSource || (u.cargoSource === job.cargoSource)) {
                userDefinedRoleId2List.push(user)
              }
            } else if (u.roleType === CargoOfRoleType.USER_DEFINED_ROLE3.code) { // 自定义岗位3
              if (u.defaultUser) {
                userDefinedRoleId3 = u.userId
              }
              if (matchCargoSourceUserDefinedRoleId3Id === 0 && job.cargoSource && u.cargoSource === job.cargoSource) {
                matchCargoSourceUserDefinedRoleId3Id = u.userId
              }
              // 揽货类型没有 或者与当前业务相同的才能出现在下拉框 或默认值里面。
              if (!u.cargoSource || (u.cargoSource === job.cargoSource)) {
                userDefinedRoleId3List.push(user)
              }
            } else if (u.roleType === CargoOfRoleType.USER_DEFINED_ROLE4.code) { // 自定义岗位4
              if (u.defaultUser) {
                userDefinedRoleId4 = u.userId
              }
              if (matchCargoSourceUserDefinedRoleId4Id === 0 && job.cargoSource && u.cargoSource === job.cargoSource) {
                matchCargoSourceUserDefinedRoleId4Id = u.userId
              }
              // 揽货类型没有 或者与当前业务相同的才能出现在下拉框 或默认值里面。
              if (!u.cargoSource || (u.cargoSource === job.cargoSource)) {
                userDefinedRoleId4List.push(user)
              }
            } else if (u.roleType === CargoOfRoleType.USER_DEFINED_ROLE5.code) { // 自定义岗位5
              if (u.defaultUser) {
                userDefinedRoleId5 = u.userId
              }
              if (matchCargoSourceUserDefinedRoleId5Id === 0 && job.cargoSource && u.cargoSource === job.cargoSource) {
                matchCargoSourceUserDefinedRoleId5Id = u.userId
              }
              // 揽货类型没有 或者与当前业务相同的才能出现在下拉框 或默认值里面。
              if (!u.cargoSource || (u.cargoSource === job.cargoSource)) {
                userDefinedRoleId5List.push(user)
              }
            } else if (u.roleType === CargoOfRoleType.USER_DEFINED_ROLE6.code) { // 自定义岗位6
              if (u.defaultUser) {
                userDefinedRoleId6 = u.userId
              }
              if (matchCargoSourceUserDefinedRoleId6Id === 0 && job.cargoSource && u.cargoSource === job.cargoSource) {
                matchCargoSourceUserDefinedRoleId6Id = u.userId
              }
              // 揽货类型没有 或者与当前业务相同的才能出现在下拉框 或默认值里面。
              if (!u.cargoSource || (u.cargoSource === job.cargoSource)) {
                userDefinedRoleId6List.push(user)
              }
            } else if (u.roleType === CargoOfRoleType.USER_DEFINED_ROLE7.code) { // 自定义岗位7
              if (u.defaultUser) {
                userDefinedRoleId7 = u.userId
              }
              if (matchCargoSourceUserDefinedRoleId7Id === 0 && job.cargoSource && u.cargoSource === job.cargoSource) {
                matchCargoSourceUserDefinedRoleId7Id = u.userId
              }
              // 揽货类型没有 或者与当前业务相同的才能出现在下拉框 或默认值里面。
              if (!u.cargoSource || (u.cargoSource === job.cargoSource)) {
                userDefinedRoleId7List.push(user)
              }
            }
          }
        }
      }
    }
    // 销售
    // this.view.salesList = salesList
    if (source === BRING_OUT_LOGIC_CALL_SOURCE_OCR.code) {
      this.view.jobViewInfoMap.get(job.index).salesList = salesList
      const copiedMap = new Map()
      this.view.jobViewInfoMap.forEach((value, key) => {
        copiedMap.set(key, value)
      })
      this.view.jobViewInfoMap = copiedMap
    } else {
      this.view.salesList = salesList
      this.getTxtSalesPrompt()
    }
    if (salesList.length > 0) {
      if (salesDefaultId > 0) {
        job.sales = salesDefaultId
      } else {
        job.sales = salesList[0].userId
      }
      this.view.$nextTick(() => {
        const user = this.userList.find(p => p.userId === job.sales)
        this.salesChangeHandler({ ...user, value: user.userId })
      })
    } else {
      // job.sales = 0
      // job.salesDepartment = 0
      // this.view.txtSalesOffice = ''
    }
    // 客服
    if (csrList.length > 0) {
      if (matchCargoSourceCsrId > 0) {
        job.csr = matchCargoSourceCsrId
      } else if (csrDefaultId > 0) {
        job.csr = csrDefaultId
      } else {
        job.csr = csrList[0].userId
      }
      this.view.$nextTick(() => {
        const user = this.userList.find(p => p.userId === job.csr)
        this.csrChangeHandler({ ...user, value: user.userId })
      })
    } else {
      // job.csr = 0
      // job.csrDepartment = 0
    }
    // 单证
    if (dcList.length > 0) {
      if (matchCargoSourceDcId > 0) {
        job.dc = matchCargoSourceDcId
      } else if (dcDefaultId > 0) {
        job.dc = dcDefaultId
      } else {
        job.dc = dcList[0].userId
      }
      this.view.$nextTick(() => {
        const user = this.userList.find(p => p.userId === job.dc)
        this.dcChangeHandler({ ...user, value: user.userId })
      })
    } else {
      if (!job.uuid && job.lclMaster) {
        await this.view.$confirm(this.view.$t('SeaExport.salveNoDcToKeepMaster'), this.view.$t('common.tips.prompt'), {
          confirmButtonText: this.view.$t('Message.Yes'),
          cancelButtonText: this.view.$t('Message.No'),
          closeOnClickModal: false,
          type: 'info'
        }).then(() => {
          job.dc = job.lclMaster.dc
          this.view.$nextTick(() => {
            const user = this.userList.find(p => p.userId === job.dc)
            this.dcChangeHandler({ ...user, value: user.userId })
          })
        }).catch(() => {
          // job.dc = 0
          // job.dcDepartment = 0
        })
      } else {
        // job.dc = 0
        // job.dcDepartment = 0
      }
    }
    // 揽货销售
    if (cargoSalesList.length > 0) {
      if (cargoSalesId > 0) {
        job.cargoSalesId = cargoSalesId
      } else {
        job.cargoSalesId = cargoSalesList[0].userId
      }
      this.view.$nextTick(() => {
        const user = this.userList.find(p => p.userId === job.cargoSalesId)
        this.cargoSalesChargeHandler({ ...user, value: user.userId })
      })
    } else {
      // job.cargoSalesId = 0
      // job.cargoSalesOffice = 0
      // job.cargoSalesDepartment = 0
    }
    if (this.view.isHC) {
      // 操作
      if (opList.length > 0) {
        if (opDefaultId > 0) {
          job.op = opDefaultId
        } else {
          job.op = opList[0].userId
        }

        const user = await User.getUserById(job.op)
        this.view.$nextTick(() => {
          this.txtOPChangeHandler({ ...user, value: user.userId })
        })
      } else {
        // job.op = 0
        // job.opDepartment = 0
      }
      // 海外客服
      if (overseaOpList.length > 0) {
        if (overseaOpDefaultId > 0) {
          job.overseaOp = overseaOpDefaultId
        } else {
          job.overseaOp = overseaOpList[0].userId
        }

        const user = await User.getUserById(job.overseaOp)
        this.view.$nextTick(() => {
          this.overseaOpChangeHandler({ ...user, value: user.userId })
        })
      } else {
        // job.overseaOp = 0
        // job.overseaOpDepartment = 0
      }
    }
    // 自定义岗位1
    if (userDefinedRoleId1List.length > 0) {
      if (matchCargoSourceUserDefinedRoleId1Id > 0) {
        job.userDefinedRoleId1 = matchCargoSourceUserDefinedRoleId1Id
      } else if (userDefinedRoleId1 > 0) {
        job.userDefinedRoleId1 = userDefinedRoleId1
      } else {
        job.userDefinedRoleId1 = userDefinedRoleId1List[0].userId
      }
      this.view.$nextTick(() => {
        const user = this.userList.find(p => p.userId === job.userDefinedRoleId1)
        this.userDefinedRoleId1Handler({ ...user, value: user.userId })
      })
    } else {
      // job.userDefinedRoleId1 = 0
      // job.userDefinedRoleDept1 = 0
      // job.userDefinedRoleOffice1 = 0
    }
    // 自定义岗位2
    if (userDefinedRoleId2List.length > 0) {
      if (matchCargoSourceUserDefinedRoleId2Id > 0) {
        job.userDefinedRoleId2 = matchCargoSourceUserDefinedRoleId2Id
      } else if (userDefinedRoleId2 > 0) {
        job.userDefinedRoleId2 = userDefinedRoleId2
      } else {
        job.userDefinedRoleId2 = userDefinedRoleId2List[0].userId
      }
      this.view.$nextTick(() => {
        const user = this.userList.find(p => p.userId === job.userDefinedRoleId2)
        this.userDefinedRoleId2Handler({ ...user, value: user.userId })
      })
    } else {
      // job.userDefinedRoleId2 = 0
      // job.userDefinedRoleDept2 = 0
      // job.userDefinedRoleOffice2 = 0
    }
    // 自定义岗位3
    if (userDefinedRoleId3List.length > 0) {
      if (matchCargoSourceUserDefinedRoleId3Id > 0) {
        job.userDefinedRoleId3 = matchCargoSourceUserDefinedRoleId3Id
      } else if (userDefinedRoleId3 > 0) {
        job.userDefinedRoleId3 = userDefinedRoleId3
      } else {
        job.userDefinedRoleId3 = userDefinedRoleId3List[0].userId
      }
      this.view.$nextTick(() => {
        const user = this.userList.find(p => p.userId === job.userDefinedRoleId3)
        this.userDefinedRoleId3Handler({ ...user, value: user.userId })
      })
    } else {
      // job.userDefinedRoleId3 = 0
      // job.userDefinedRoleDept3 = 0
      // job.userDefinedRoleOffice3 = 0
    }
    // 自定义岗位4
    if (userDefinedRoleId4List.length > 0) {
      if (matchCargoSourceUserDefinedRoleId4Id > 0) {
        job.userDefinedRoleId4 = matchCargoSourceUserDefinedRoleId4Id
      } else if (userDefinedRoleId4 > 0) {
        job.userDefinedRoleId4 = userDefinedRoleId4
      } else {
        job.userDefinedRoleId4 = userDefinedRoleId4List[0].userId
      }
      this.view.$nextTick(() => {
        const user = this.userList.find(p => p.userId === job.userDefinedRoleId4)
        this.userDefinedRoleId4Handler({ ...user, value: user.userId })
      })
    } else {
      // job.userDefinedRoleId4 = 0
      // job.userDefinedRoleDept4 = 0
      // job.userDefinedRoleOffice4 = 0
    }
    // 自定义岗位5
    if (userDefinedRoleId5List.length > 0) {
      if (matchCargoSourceUserDefinedRoleId5Id > 0) {
        job.userDefinedRoleId5 = matchCargoSourceUserDefinedRoleId5Id
      } else if (userDefinedRoleId5 > 0) {
        job.userDefinedRoleId5 = userDefinedRoleId5
      } else {
        job.userDefinedRoleId5 = userDefinedRoleId5List[0].userId
      }
      this.view.$nextTick(() => {
        const user = this.userList.find(p => p.userId === job.userDefinedRoleId5)
        this.userDefinedRoleId5Handler({ ...user, value: user.userId })
      })
    } else {
      // job.userDefinedRoleId5 = 0
      // job.userDefinedRoleDept5 = 0
      // job.userDefinedRoleOffice5 = 0
    }
    // 自定义岗位6
    if (userDefinedRoleId6List.length > 0) {
      if (matchCargoSourceUserDefinedRoleId6Id > 0) {
        job.userDefinedRoleId6 = matchCargoSourceUserDefinedRoleId6Id
      } else if (userDefinedRoleId6 > 0) {
        job.userDefinedRoleId6 = userDefinedRoleId6
      } else {
        job.userDefinedRoleId6 = userDefinedRoleId6List[0].userId
      }
      this.view.$nextTick(() => {
        const user = this.userList.find(p => p.userId === job.userDefinedRoleId6)
        this.userDefinedRoleId6Handler({ ...user, value: user.userId })
      })
    } else {
      // job.userDefinedRoleId6 = 0
      // job.userDefinedRoleDept6 = 0
      // job.userDefinedRoleOffice6 = 0
    }
    // 自定义岗位7
    if (userDefinedRoleId7List.length > 0) {
      if (matchCargoSourceUserDefinedRoleId7Id > 0) {
        job.userDefinedRoleId7 = matchCargoSourceUserDefinedRoleId7Id
      } else if (userDefinedRoleId7 > 0) {
        job.userDefinedRoleId7 = userDefinedRoleId7
      } else {
        job.userDefinedRoleId7 = userDefinedRoleId7List[0].userId
      }
      this.view.$nextTick(() => {
        const user = this.userList.find(p => p.userId === job.userDefinedRoleId7)
        this.userDefinedRoleId7Handler({ ...user, value: user.userId })
      })
    } else {
      // job.userDefinedRoleId7 = 0
      // job.userDefinedRoleDept7 = 0
      // job.userDefinedRoleOffice7 = 0
    }
  }
  /**
   * 加载job仓库信息
   */
  loadWarehouseCmp() {
    const job = this.job
    if (job.warehouseInfo != null && job.warehouseInfo.length > 0) {
      job.warehouseCmp = job.warehouseInfo[0].warehouseCmp
    } else if (!shouldPreserveCopiedWarehouseCmp(job, this.view.action)) {
      job.warehouseCmp = 0
    }
    job.warehouseRecord = job.warehouseCmp
  }
  /**
   * 加载job运输公司
   */
  loadTrucking2() {
    const job = this.job
    if (job.trucking && job.trucking.length > 0) {
      // 需要排序，因为业务调整更新的 TruckingId desc排序后的第一条，要及时反馈出来
      sortByMultiField(job.trucking, ['truckingId'], true)
      job.carryingCmp = job.trucking[0].carryingCmp
    } else if (!shouldPreserveCopiedCarryingCmp(job, this.view.action)) {
      job.carryingCmp = 0
    }
  }
  /**
   *  加载货物明细
   */
  loadWarehouseInDetails() {
    const job = this.job
    if (job.warehouseIn && job.warehouseIn.length > 0) {
      this.view.txtWhs = job.fba ? JobUtils.getFbaWarehouseInDetail(job, job.warehouseIn) : JobUtils.getWarehouseInDetail(job.warehouseIn)
    } else {
      this.view.txtWhs = ''
    }
  }
  /**
   * 刷新港口所对应的目的港和指定货代理
   */
  loadOverseaPortDestinationAgent() {
    // isClearDestinationAgent = false
    // loadOverseaAgentPort()
  }
  async loadOverseaAgentPort() {
    if (this.dischargingPortIsDirty && this.isJoinPortDestinationAgent) {
      this.view.overseaAgentDataProviderChange = true
      const job = this.job
      await new SeaExportJob(job).getOverseaAgentPort(job.lob, job.dischargingPortCode)
      const overseaAgentPortList = job.overseaAgentPort
      const array = []
      if (overseaAgentPortList && overseaAgentPortList.length > 0) {
        for (const overseaAgentPort of overseaAgentPortList) {
          if (overseaAgentPort.agent && overseaAgentPort.agent.company && array.indexOf(overseaAgentPort.agent.company) < 0) {
            array.push(overseaAgentPort.agent.company)
          }
        }
        if (this.isClearDestinationAgent) {
          job.destinationAgent = 0
          job.designationAgent = 0
        }
        // 指定货代理
        this.designationAgentArray = array
        // 目的港代理
        this.destinationAgentArray = array
        this.dischargingPortIsDirty = false
      }
    }
  }

  /**
   * 加载指定货代理
   */
  async loadOverseaAgentDetail() {
    const job = this.job
    if (job.designationAgent > 0) {
      const company = this.companyList.find(p => p.cmpIdx === job.designationAgent)
      if (company) {
        await this.loadOverSeaResultHandler()
      }
    }
  }
  /**
   * 指定货代理 销售处显示网管名字。
   */
  async loadOverSeaResultHandler(event = null) {
    if (this.job.designationAgent > 0) {
      await this.loadOverseaAgentDetailOwner(this.job.designationAgent)
    }
  }
  /**
   * 指定货 -> 加载网管
   */
  async loadOverseaAgentDetailOwner(companyId) {
    this.ownerCompanyId = companyId
    const company = this.companyList.find(p => p.cmpIdx === companyId)
    if (company) {
      const overseaAgentDetail = await new Company(company).getOverseaAgentDetail()
      await this.loadOverseaAgentDetailOwnerHandler(overseaAgentDetail)
    }
  }
  async loadOverseaAgentDetailOwnerHandler(overseaAgentDetail) {
    const data = { value: 0 }
    if (overseaAgentDetail) {
      // 添加指定货代理等级
      const overseaAgentGrade = OverseaAgentGrade.getOverseaAgentGradeByCode(overseaAgentDetail.grade)
      if (overseaAgentGrade) {
        this.job.agentLevel = overseaAgentGrade.chineseName
      }
      const user = this.userList.find(p => p.userId === overseaAgentDetail.owner)
      if (user) {
        if (this.view.salesOfficeCheck) {
          if (user.active) {
            Object.assign(data, user)
            data.value = overseaAgentDetail.owner
          }
        } else {
          Object.assign(data, user)
          data.value = overseaAgentDetail.owner
        }
      }
    }
    await this.salesChangeHandler(data)
  }
  /**
   * 加载客户类型
   */
  async showCustomerDetail() {
    const job = this.job
    const company = this.companyList.find(p => p.cmpIdx === job.customerId)
    if (company) {
      const customerDetail = await Company.loadCustomer(company.uuid).then(list => list.length > 0 ? list[0] : null)
      if (customerDetail) {
        this.lockInCargoSource(customerDetail)
      }
    }
  }
  /**
   * 是否锁定揽货类型
   */
  lockInCargoSource(customerDetail) {
    this.view.cargoSourceEnabled = this.view.isEdit
    if (!(customerDetail.designated && customerDetail.seftCanvass)) {
      if (customerDetail.designated || customerDetail.seftCanvass) {
        if (this.customerLockInCargoSource && this.view.isEdit) {
          this.view.cargoSourceEnabled = false
        }
      }
    }
  }
  async loadCustomerPortDestinationAgents(allowPopup = false, source) {
    if (this.job.cargoSource === CargoSource.NC_CARGO_SOURCE.code) {
      const company = this.companyList.find(p => p.cmpIdx === this.job.customerId)
      if (company) {
        const customerDetail = await Company.loadCustomer(company.uuid).then(list => list.length > 0 ? list[0] : null)
        this.loadCustomerDetail1Handler(customerDetail, allowPopup, source)
      }
    }
  }
  async loadCustomerDetail1Handler(customerDetail, allowPopup = false, source) {
    if (customerDetail) {
      const portDestinationAgents = await new Customer(customerDetail).getPortDestinationAgents()
      this.loadPortDestinationAgentsHandler(portDestinationAgents, allowPopup, source)
    }
  }
  loadPortDestinationAgentsHandler(portDestinationAgents, allowPopup = false, source) {
    if (portDestinationAgents) {
      const job = this.job
      // 判断是否只维护了一个指定货代理且目的港为空,如果仅维护一个，则所有的目的港指定货代理取值维护的指定货代理
      let isOnlyPortDestinationAgent = false
      let defaultPortDestinationAgent = null
      if (portDestinationAgents && portDestinationAgents.length === 1) {
        defaultPortDestinationAgent = portDestinationAgents[0]
        if (!defaultPortDestinationAgent.destinationPort) {
          isOnlyPortDestinationAgent = true
        }
      }
      // 判断当前业务的指定货代理是否为空
      if (!job.designationAgent || Number(job.designationAgent) === 0) {
        if (portDestinationAgents.length === 1) {
          if (isOnlyPortDestinationAgent) {
            if (defaultPortDestinationAgent.defaultAgent) {
              this.updatePortDestinationAgentInformation(defaultPortDestinationAgent)
            }
          } else {
            if (job.dischargingPortCode === defaultPortDestinationAgent.destinationPort && defaultPortDestinationAgent.defaultAgent) {
              this.updatePortDestinationAgentInformation(defaultPortDestinationAgent)
            }
          }
        } else {
          // 现根据卸货港去匹配，匹配不到取默认指定货代理
          let isFind = false
          if (portDestinationAgents && portDestinationAgents.length > 0) {
            for (const a of portDestinationAgents) {
              if (job.dischargingPortCode === a.destinationPort && a.defaultAgent) {
                isFind = true
                this.updatePortDestinationAgentInformation(a)
                break
              }
            }
            // 取默认的指定货代理
            if (!isFind) {
              for (const b of portDestinationAgents) {
                if (!b.destinationPort && b.defaultAgent) {
                  this.updatePortDestinationAgentInformation(b)
                  break
                }
              }
            }
          }
        }
      } else {
        // 业务中有指定货代理，判断目的港是否维护有默认的指定货代理(默认的指定货代理只有一个)
        let i = 0
        let isDefaultAgent = false
        let defaultAgent = null
        if (portDestinationAgents && portDestinationAgents.length > 0) {
          for (const a1 of portDestinationAgents) {
            if (job.dischargingPortCode === a1.destinationPort) {
              i++
              if (a1.defaultAgent) {
                defaultAgent = a1
                isDefaultAgent = true
              }
            }
          }
        }
        if (portDestinationAgents && portDestinationAgents.length >= 2) {
          for (const a2 of portDestinationAgents) {
            if (!a2.destinationPort) {
              isOnlyPortDestinationAgent = true
            }
          }
        }
        if (source !== BRING_OUT_LOGIC_CALL_SOURCE_OCR.code &&
            i === 0 && job.designationAgent && job.dischargingPortCode && !isOnlyPortDestinationAgent) {
          const callback = () => {
            job.designationAgent = 0
            this.loadOverseaAgentDetailOwner(0)
            this.view.txtSalesOffice = ''
            job.salesOffice = 0
            job.sales = 0
            job.salesDepartment = 0
            this.dipatchChangedSalesEvent(0)
          }
          // CARGO-15388 H5 更新委托单位后，指定货代理自动消失
          // if (allowPopup) {
          this.view.$confirm(this.view.$t('SeaExport.UnloadingPortNotMaintain'), this.view.$t('common.tips.prompt'), {
            confirmButtonText: this.view.$t('common.btn.ok'),
            cancelButtonText: this.view.$t('common.btn.cancel'),
            closeOnClickModal: false,
            type: 'warning'
          }).then(() => {
            callback()
          }).catch(() => { })
          // } else {
          //   callback()
          // }
        }

        if (job.dischargingPortCode) {
          if (isDefaultAgent) {
            if (job.designationAgent !== defaultAgent.destinationAgentId) {
              if (allowPopup) {
                this.view.$confirm(this.view.$t('SeaExport.PortMaintainedDesignatedFreightForwarder'), this.view.$t('common.tips.prompt'), {
                  confirmButtonText: this.view.$t('common.btn.ok'),
                  cancelButtonText: this.view.$t('common.btn.cancel'),
                  closeOnClickModal: false,
                  type: 'warning'
                }).then(() => {
                  this.updatePortDestinationAgentInformation(defaultAgent)
                }).catch(() => { })
              } else {
                this.updatePortDestinationAgentInformation(defaultAgent)
              }
            }
          } else {
            if (portDestinationAgents && portDestinationAgents.length > 0) {
              for (const c of portDestinationAgents) {
                if (!c.destinationPort && c.defaultAgent) {
                  this.updatePortDestinationAgentInformation(c)
                  break
                }
              }
            }
          }
        }
      }
    }
  }
  /**
   * 更新指定货代理以及销售栏位等信息
   */
  updatePortDestinationAgentInformation(agent) {
    const job = this.job
    job.designationAgent = agent.destinationAgentId
    CargoDocUtil.changeHBLAgentParty(job)
    // 指定货带网管
    this.loadOverseaAgentDetailOwner(job.designationAgent)
    // if (job.lclMasterUuid) {
    if (job.cargoSource === CargoSource.NC_CARGO_SOURCE.code) { // 如果是指定货
      this.loadOverseaAgentUserByLob(job.designationAgent)// 根据指定货确定海外客服
    } else {
      this.loadOverseaAgentUserByLob(job.destinationAgent)// 还是根据目的港代理确定海外客服
    }
    // }
  }
  /**
   * 如果进仓编号重复，页面红色字体显示
   */
  checkWarehouseNoExist() {
    // if (!job.isNewInstance() && !StrUtils.isEmpty(job.warehouseNo)) {
    //   SeaExportJob.checkJobFiledExist(StringUtil.trim(job.warehouseNo), job.lob, 'OMS_JOB', 'WAREHOUSE_NO', job.key,
    //     new mx.rpc.Responder(checkWarehouseNoExistHandler, view.faultHandler))
    // }
  }
  checkWarehouseNoExistHandler(evt) {
    // if (evt && evt.result as Boolean) {
    //   view.txtWarehouseNo.toolTip = resourceManager.getString('Message', 'RepeatedWarehouseNo')
    //   view.txtWarehouseNo.setStyle('color', 'red')
    // }
    // else {
    //   view.txtWarehouseNo.toolTip = ''
    //   view.txtWarehouseNo.setStyle('color', '0x000000')
    // }
  }
  /**
   * 关账后，基本页面里的销售公司、销售员、操作部门不允许修改
   */
  checkWithinClosingAccountDate() {
    ClosingAccount.isContainClosedCharge(this.context.office.officeId, this.job.jobNo).then(res => {
      this.isWithinCloseAccountDate = Boolean(res.data)
    })
  }
  /**
   * 是否跨tenant委托
   */
  checkIsCrossTenant() {
    const job = this.job
    if (job.customerId > 0) {
      const company = this.companyList.find(p => p.cmpIdx === job.customerId)
      if (company) {
        const relatedTenant = company.relateTenantId
        this.isCrossTenant = job.trustFromJob && relatedTenant > 0
      }
    }
  }
  /**
   * 根据整拼类型自动获取对应的自定义业务类型，如果有多个默认选中第一个
   */
  selectDefaultCutomJobType() {
    const options = this.cutomJobTypeList.filter(p => p.type === this.job.lob && p.containerLoadType === this.job.containerLoadType)
    if (options.length > 0) {
      this.job.customJobType = options[0].code
    }
  }
  /**
   * 箱型信息控制
   */
  async seaEqDateCl(preserveSeaEQ = false) {
    const job = this.job
    if (!job) return
    let eq = null
    await new SeaExportJob(this.job).getSeaEQ()
    if (job.containerLoadType === ContainerLoadType.BB_CARGO_TYPE.code) {
      if (job.seaEQ.length === 0 && !this.view.isXy) {
        eq = new SeaEQ().fillDefaultValue().getData()
        eq.eqType = 'GP'
        eq.eqSize = '20'
        eq.eqQuantity = 1
        eq.jobUuid = job.uuid
        job.seaEQ.push(eq)
        ContainerUtil.autoJustContainerUsages(job)
      }
      this.view.seaEqList = job.seaEQ
    } else if (!preserveSeaEQ && job.containerLoadType !== ContainerLoadType.FCL_CARGO_TYPE.code && job.containerLoadType !== ContainerLoadType.SPECIAL_CARGO_TYPE.code && job.containerLoadType !== ContainerLoadType.BC_CARGO_TYPE_FCL.code && job.seaEQ && job.seaEQ.length > 0) {
      // job.seaEQ = []
      if (this.view.$refs.bookingSeaEqDataGrid) this.view.$refs.bookingSeaEqDataGrid.clear()
    }
    if ((job.containerLoadType === ContainerLoadType.FCL_CARGO_TYPE.code || job.containerLoadType === ContainerLoadType.BC_CARGO_TYPE_FCL.code) && job.seaEQ && job.seaEQ.length > 0) {
      const seaEqs = job.seaEQ
      for (let j = seaEqs.length - 1; j >= 0; j--) {
        const seaEq = seaEqs[j]
        seaEq.sizeHeight = 0.0
        seaEq.sizeLength = 0.0
        seaEq.sizeWidth = 0.0
      }
    }
    if (job.containerLoadType !== ContainerLoadType.BULK_CARGO_TYPE.code && job.cargoBulkDetails && job.cargoBulkDetails.length > 0) {
      await new SeaExportJob(job).getCargoBulkDetail()
      const details = job.cargoBulkDetail
      for (let k = details.length - 1; k >= 0; k--) {
        const cd = details[k]
        cd.jobUuid = null
      }
      job.insideQuantitySize = 0.0
    }
  }
  /**
   * 客户特殊要求
   */
  getRequestSelectedKeys() {
    // return view.selectedSpecialRequest.getRequestSelectedKeys()
  }
  /**
   * 计费重量修改计算
   */
  async calculateChargeWeight() {
    try {
      let weight = this.chargeWeightCalculationMode === 1 ? parseFloat(this.job.weightContract) : parseFloat(this.job.weightActual)
      const cubage = this.chargeWeightCalculationMode === 1 ? parseFloat(this.job.cubageContract) : parseFloat(this.job.cubageActual)
      if (isNaN(weight) || isNaN(cubage)) return
      weight = weight / 1000
      if (cubage > weight) {
        weight = cubage
      }
      if (weight > 0 && weight < 1) {
        weight = 1.00
      }
      this.job.chargeWeight = parseFloat(weight.toFixed(3))
      this.syncChargeWeightToCharge()
      this.txtCubageActualFocusOutHandler(this.job.cubageActual)
      await this.changeSynBillOfLadingQWC()
    } catch (e) {
      // console.log('calculateChargeWeight error', e)
    }
  }
  async changeSynBillOfLadingQWC() {
    this.view.context.reloadCharge = true
    await CargoDocUtil.changeSynBillOfLadingQWC(this.job, this.job.quantityActual, this.job.weightActual, this.job.cubageActual)
  }
  // 委托件毛体 更改事件 @change 事件中的 委托的 件毛体赋值 在此之后 导致 装箱数据仍是上一次的值
  async jobContractQwcChange(type) {
    if (type === 1) {
      await SEUtils.changeQWCRule(() => {
        if (this.job.quantityActual !== this.job.quantityContract) {
          this.job.quantityActual = this.job.quantityContract
          this.syncQwcToPoItems(this.job.quantityActual || 0, null, null)
          if (!this.job.multipleDischargingPickups && this.job.dischargingTrucking && this.job.dischargingTrucking.length > 0) {
            this.job.dischargingTrucking[0].quantity = this.job.quantityActual || 0
            this.context.modifiedData.dischargingTruckingInfo = this.job.dischargingTrucking
          }
        }
      })
      await this.changeSynBillOfLadingQWC()
      await this.txtPackingChangeHandler()
      ContainerUtil.refreshContainerUsageContractQwc(this.job, 'quantityContract')
    } else if (type === 2) {
      await SEUtils.changeQWCRule(async() => {
        if (this.job.weightActual !== this.job.weightContract) {
          this.job.weightActual = this.job.weightContract
          this.syncQwcToPoItems(null, this.job.weightActual || 0, null)
          if (ChargeUtils.getChargeWeightValueType(true) === 0) {
            await this.refreshWeightCharge(this.job, this.job.weightActual)
          }
          if (!this.job.multipleDischargingPickups && this.job.dischargingTrucking && this.job.dischargingTrucking.length > 0) {
            this.job.dischargingTrucking[0].weight = this.job.weightActual || 0
            this.context.modifiedData.dischargingTruckingInfo = this.job.dischargingTrucking
          }
        }
      })
      if (!this.job.fba) {
        await this.calculateChargeWeight()
      }
      ContainerUtil.refreshContainerUsageContractQwc(this.job, 'weightContract')
    } else if (type === 3) {
      await SEUtils.changeQWCRule(async() => {
        if (this.job.cubageActual !== this.job.cubageContract) {
          this.job.cubageActual = this.job.cubageContract
          this.syncQwcToPoItems(null, null, this.job.cubageActual || 0)
          await this.refreshChargeByCubageActual(this.job, this.job.cubageActual)
          if (!this.job.multipleDischargingPickups && this.job.dischargingTrucking && this.job.dischargingTrucking.length > 0) {
            this.job.dischargingTrucking[0].cubage = this.job.cubageActual || 0
            this.context.modifiedData.dischargingTruckingInfo = this.job.dischargingTrucking
          }
        }
        this.job.chargeWeight = this.job.cubageContract
      })
      if (!this.job.fba) {
        await this.calculateChargeWeight()
      }
      ContainerUtil.refreshContainerUsageContractQwc(this.job, 'cubageContract')
    }

    this.refContainerUsageQwc(2, true)
  }
  async refreshWeightCharge(job, weight) {
    const charges = await ChargeUtils.weightChargesCanUpdate(job)
    if (charges.length > 0) {
      await this.view.$confirm(this.view.$t('Message.WeightChangeToRefreshCostBasedOnWeightPrice'), {
        confirmButtonText: this.view.$t('common.btn.ok'),
        cancelButtonText: this.view.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        for (const charge of charges) {
          charge.quantity = weight
          if (charge.unitPriceIncludeTax) {
            ChargeUtils.calculateTaxAmount(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
          } else {
            ChargeUtils.calculateTax(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
          }
        }
        this.view.context.modifiedData.charges = this.view.context.modifiedData.charges || []
        mergeArray(this.view.context.modifiedData.charges, charges)
        this.view.context.reloadCharge = true
      }).catch(() => {})
    }
    if (job.typeHBL !== BillType.MERGE_BILL_TYPE.code) {
      ChargeUtils.wgttWeightChargesCanUpdate(job, weight, this.view.context)
    }
  }
  async refreshCubageCharge(job, cubage) {
    const charges = await ChargeUtils.cubageChargesCanUpdate(job)
    if (charges.length > 0) {
      await this.view.$confirm(this.view.$t('Message.CubageChangeToRefreshCostBasedOnCubagePrice'), {
        confirmButtonText: this.view.$t('common.btn.ok'),
        cancelButtonText: this.view.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        for (const charge of charges) {
          charge.quantity = cubage
          if (charge.unitPriceIncludeTax) {
            ChargeUtils.calculateTaxAmount(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
          } else {
            ChargeUtils.calculateTax(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
          }
        }
        this.view.context.modifiedData.charges = this.view.context.modifiedData.charges || []
        mergeArray(this.view.context.modifiedData.charges, charges)
        this.view.context.reloadCharge = true
      }).catch(() => {})
    }
  }
  async refreshChargeByCubageActual(job, cubage) {
    const needTip = this.view.action === 'edit' && SEUtils.needTip(job, 'VOL') && !(String(cache.config.get('ToExoSystem')) === 'XYCW' && job.lob === 'SE' && BillType.MERGE_BILL_TYPE.code === job.typeHBL)
    if (needTip) { // 当实际体积发生改变时，同步更新费用中体积价
      await this.view.$confirm(this.view.$t('CargoMsg.Cargo_VolumeIsChanged'), this.view.$t('CargoMsg.Cargo_Tips'), {
        confirmButtonText: this.view.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.view.$t('CargoMsg.Cargo_Cancel'),
        type: 'warning'
      }).then(() => {
        ChargeUtils.caQuantityChangeHandler(job, this.view.context, cubage)
      }).catch(() => {})
    } else {
      if (ChargeUtils.getChargeWeightValueType(true) === 0) {
        await this.refreshCubageCharge(job, cubage)
      }
    }
  }
  refContainerUsageQwc(viewPager = 0, btnSave = true) {
    if (!this.view.slaveCustomsDeclarationEnable) {
      ContainerUtil.refContainerUsageQwc(this.job, viewPager, btnSave)
    }
  }
  syncQwcToPoItems(quantityActual = null, weightActual = null, cubageActual = null) {
    // 只有一个so时，双向同步
    if (this.view.slaveCustomsDeclarationEnable && this.job.poItems && this.job.poItems.length === 1) {
      if (quantityActual !== null) {
        this.job.poItems[0].oldQuantity = this.job.poItems[0].quantity
        this.job.poItems[0].quantity = quantityActual
      }
      if (weightActual !== null) {
        this.job.poItems[0].oldGrossWeight = this.job.poItems[0].grossWeight
        this.job.poItems[0].grossWeight = weightActual
      }
      if (cubageActual !== null) {
        this.job.poItems[0].oldCubage = this.job.poItems[0].cubageActual
        this.job.poItems[0].cubage = cubageActual
      }
      this.view.$refs.customsDeclaration.poItemChange(this.job.poItems[0])
      this.view.$refs.customsDeclaration.gridApi.refreshCells({ force: true })
      this.view.$refs.customsDeclaration.refTotal()
    }
  }
  // private var alertflag: Boolean = true
  clickHandler2Handler(event) {
    // if (event.detail == Alert.YES) {
    //   for each(var charge: Charge in job.charges)
    //   {
    //     // cargoCARGO-1457
    //     if (charge.confirmBill == null && charge.measure == ChargeMeasure.WGTX_CHARGE_MEASURE.code &&
    //       charge.invoice == null && charge.billing == null && charge.billPayment == null &&
    //       charge.verifiedAmount == 0 && !charge.isPaidOff) {
    //       charge.quantity = job.chargeWeight
    //       ChargeUtils.calculateTax(charge, charge.quantity * charge.unitRate, charge.taxRate, true)
    //     }
    //   }
    // }
    // alertflag = true
  }
  /**
   * 正本打印锁定业务页签
   */
  async lockBookingTab() {
    const job = this.job
    const hbl = await new SeaExportJob(job).getMainHbl()
    job.printHblZbLock = false
    const isLockTab = await parseInt(this.config.get('HBLPrintLockTab')) === 1
    if (hbl) {
      job.printHblZbLock = (hbl.state === 2 && isLockTab)
    }
    this.editingChanged()
  }
  /**
   * 拼箱小票，不允许编辑：目的港代理、船名、航次、订舱单位、船公司、主单运费条款、卸货港
   */
  lclslaveEnabledCl() {
    this.lclslaveEnabled = this.view.isEdit
    if (this.lclslaveEnabled && this.job && this.job.lclMasterUuid) {
      this.lclslaveEnabled = false
    }
  }
  /**
   * 散杂货时，主分单运输条款默认为空
   */
  selectFreightTermByBulkCargo() {
    const job = this.job
    if (!job.uuid && job.containerLoadType === ContainerLoadType.BULK_CARGO_TYPE.code) {
      job.freightTerm = ''
      job.freightTermHBL = ''
    } else {
      // CARGO-8139 海出【委托拼箱】基本页签增加“主单运输条款”默认为CFS-CFS qm
      if (job.containerLoadType === ContainerLoadType.BB_CARGO_TYPE.code) {
        if (!job.uuid || !job.freightTerm) {
          job.freightTerm = 'CFS-CFS'
        }
      }
      if (!job.freightTerm) {
        job.freightTerm = 'CY-CY'
      }
      if (!job.freightTermHBL) {
        job.freightTermHBL = 'CY-CY'
      }
    }
  }
  /**
   * editing changed
   */
  editingChanged() {
    // view.isEditing = view.isEditing && job && !job.printHblZbLock
    // isEditing = view.isEditing
    // super.editingChanged()
    // enabledOpInput()
    // lclslaveEnabledCl()
    // viewOtherChanged()
    // ETDEditChange()
  }
  ETDEditChange() {
    this.view.etdEnabled = this.view.isEdit
    if (this.job.actualUnBerthPlanDate) {
      const isChangeETD = (parseInt(this.config.get('isChangeETD')) === 1)
      if (isChangeETD) {
        this.view.etdEnabled = false
      }
    }
  }
  sopConfig() {
    this.view.sopImageA = false
    this.view.sopImageB = false
    this.view.sopImageC = false
    SopPushConfig.findByOfficeId(this.context.office.officeId).then(data => {
      this.configSuccessHandler(data.sopPushConfig)
    })
  }
  // 获取全部沃联之家服务商
  wTQueryPageHandler() {
    this.view.wtCompanyList = []
    if (this.wtOpenConfig && this.view.wtCreateCompany) {
      const filter = {
        pageNum: 1,
        pageSize: 10000,
        noQuery: true,
        branchId: this.context.office.officeId
      }
      wTQueryPageHandler(filter).then(res => {
        this.view.wtCompanyList = res.data.list
      }).catch((e) => {
        console.log('wTQueryPageHandler error', e)
      })
    }
  }
  configSuccessHandler(sop) {
    console.log('configSuccessHandler')
    if (sop) {
      this.view.sopConfigOpen = sop.ifAuto
      if (this.view.creditOpen) {
        this.checkCredit()
      } else if (this.view.sopConfigOpen) {
        const designationAgent = this.companyList.find(p => p.cmpIdx === this.job.designationAgent)
        this.view.sopImageA = designationAgent && designationAgent.ifOpenSop

        const customer = this.companyList.find(p => p.cmpIdx === this.job.customerId)
        this.view.sopImageB = customer && customer.ifOpenSop

        const destinationAgent = this.companyList.find(p => p.cmpIdx === this.job.destinationAgent)
        this.view.sopImageC = destinationAgent && destinationAgent.ifOpenSop
      }
    } else {
      this.checkCredit()
    }
  }
  sopChangeBookingAgentHandler() {
    if (this.view.isEdit) {
      return
    }
    const job = this.job
    if (!job.designationAgent) {
      this.view.$message.warning(this.view.$t('SeaExport.ChooseDesignatedAgent'))
      return
    }
    if (!job.uuid) {
      return
    }
    SopEmailReceiver.queryJobSopReceiver(job.uuid, job.designationAgent, 'DesignationAgent').then(data => {
      this.pageAResultHandler(data)
    })
  }
  sopChangeCustomerIdHandler() {
    if (this.view.isEdit) {
      return
    }
    const job = this.job
    if (!job.customerId) {
      this.view.$message.warning(this.view.$t('SeaExport.PleaseSelectTheEntrustingCompany'))
      return
    }
    if (!job.uuid) {
      return
    }
    SopEmailReceiver.queryJobSopReceiver(job.uuid, job.customerId, 'customer').then(data => {
      this.pageBResultHandler(data)
    })
  }
  sopChangeHandler() {
    if (this.view.isEdit) {
      return
    }
    const job = this.job
    if (!job.destinationAgent) {
      this.view.$message.warning(this.view.$t('SeaExport.PleaseSelectDestinationAgent'))
      return
    }
    if (!job.uuid) {
      return
    }
    SopEmailReceiver.queryJobSopReceiver(job.uuid, job.destinationAgent, 'DestinationAgent').then(data => {
      this.pageCResultHandler(data)
    })
  }
  pageAResultHandler(contactList) {
    this.pageResultHandler(contactList, this.job.designationAgent, 'DesignationAgent')
  }
  pageBResultHandler(contactList) {
    this.pageResultHandler(contactList, this.job.customerId, 'customer')
  }
  pageCResultHandler(contactList) {
    this.pageResultHandler(contactList, this.job.destinationAgent, 'DestinationAgent')
  }
  pageResultHandler(contactList, cmpIdx, agent) {
    this.view.sopDialog.cmpIdx = cmpIdx
    this.view.sopDialog.agent = agent
    this.view.sopDialog.contactList = contactList
    this.view.sopDialog.resultFunction = value => {
      this.saveSop(value, agent)
    }
    this.view.sopDialog.visible = true
  }
  saveSop(value, agent) {
    if (agent) {
      const job = this.job
      switch (agent) {
        case 'customer':
          job.ifPushSop = value
          break
        case 'DestinationAgent':
          job.ifPushSopM = value
          break
        case 'DesignationAgent':
          job.ifPushSopZ = value
          break
        case 'PortOfLoadingAgent':
          job.ifPushSopQ = value
          break
      }
    }
  }
  /**
   * type代表不同的角色 1:委托单位 2:指定货代理 3:目的港代理 4:指定货代理以及目的港代理
   */
  checkCreditByCompany(companyId, type) {
    const callback = credit => {
      let checkCredit = false
      const company = this.context.companyList.find(p => p.cmpIdx === companyId)
      if (credit) {
        let tip = ''
        if (credit.amountExceeded || credit.dateExceeded) {
          if (credit.amountExceeded) { tip += this.view.$t('CargoMsg.Cargo_Limit') }
          if (credit.dateExceeded) { tip += this.view.$t('CargoMsg.Cargo_AccountPeriod') }
          if (tip) {
            const toolTip = this.view.$t('CargoMsg.Cargo_Parter') + tip + this.view.$t('SeaExport.HasExceeded')
            if (type === 1) {
              this.view.showWarningImageB = true
              if (company && company.ifOpenSop && this.sopConfigOpen) {
                this.view.sopImageB = true
              }
              this.view.warningImageBTip = toolTip
            } else if (type === 2) {
              this.view.showWarningImageA = true
              this.view.warningImageATip = toolTip
            } else if (type === 3) {
              this.view.showWarningImageC = true
              this.view.warningImageCTip = toolTip
            } else if (type === 4) { // 目的港代理以及指定货代理一致时，都要有提示
              this.view.showWarningImageC = true
              this.view.warningImageCTip = toolTip
              this.view.showWarningImageA = true
              this.view.warningImageATip = toolTip
            }
            checkCredit = true
          }
        }
      }
      if (!credit || !checkCredit) {
        if (company && company.ifOpenSop && this.sopConfigOpen) {
          if (type === 1) {
            this.view.showWarningImageB = false
            this.view.sopImageB = true
          } else if (type === 2) {
            this.view.showWarningImageA = false
            this.view.sopImageA = true
          } else if (type === 3) {
            this.view.showWarningImageC = false
            this.view.sopImageC = true
          } else if (type === 4) { // 目的港代理以及指定货代理一致时，都要有提示
            this.view.showWarningImageC = false
            this.view.sopImageC = true
            this.view.showWarningImageA = false
            this.view.sopImageA = true
          }
        }
      }
    }
    CreditInfo.checkCreditInfo(companyId, CreditInfoUtil.getJobData(this.job)).then(res => {
      for (const item of res.data) {
        callback(item)
      }
    })
  }
  getCreditEDISetting() {
    const setting = this.config.get('creditBlockEDI')
    const a = setting.split(',')
    const r = {}
    for (const o of a) {
      let lock = false
      if (o.split('-')[1] === '1') {
        lock = true
      }
      r[o.split('-')[0]] = lock
    }
    return r
  }
  // 设置航线负责人
  async setPlannerChange() {
    if (this.view.isEdit) {
      const job = this.job
      console.log('job.planner=========', job.planner)
      const port = this.seaPortList.find(p => p.code === job.dischargingPortCode)
      if (port) {
        const region = this.regionList.find(p => p.code === port.region)
        if (region && region.plannerList) {
          const pList = region.plannerList.split(',')
          let p = 0
          let samePlanner = false
          for (const u of pList) {
            const t = u.split('-')
            if (t.length === 2 && (t[0] === 'SE' || t[0] === 'ALL')) {
              p = Number(t[1]) || 0
            } else {
              p = Number(t[0]) || 0
            }
            if (job.planner > 0 && Number(p) === Number(job.planner)) {
              samePlanner = true
              break
            }
          }
          // 复制的时候，如果复制出来的航线负责人和根据带出来的航线负责人一样，则不要重新带出航线负责人了
          if (!job.uuid && this.view.isCopy && job.planner > 0 && samePlanner) {
            p = job.planner
          }
          if (p > 0) {
            job.planner = p
          }
          if (job.planner) {
            await this.txtPlannerChangeHandler({ value: job.planner })
          }
        }
      }
    }
  }
  // 获取合约状态
  getContractStatus(company) {
    this.view.stampPictureView.businessDocuments = []
    if (!company) return
    Company.loadAgreementClientContract(company.uuid).then(async contracts => {
      if (contracts && contracts.length > 0) {
        const now = moment()
        const businessIds = []
        for (const item of contracts) {
          // 过滤出当前合作伙伴所有未到期的合同
          if (dateCompareYMD(item.endDate, now) >= 0) {
            businessIds.push(item.uuid)
          }
        }
        if (businessIds.length > 0) {
          findBusinessDocument({ businessIds: businessIds }).then(res => {
            const docs = res.data
            if (docs && docs.length > 0) {
              const useDocs = []
              for (const doc of docs) {
                if (!doc.fileCategory || doc.fileCategory !== 'STAMP') continue
                if (!doc.fileType || !SystemConstants.IMAGES.includes(doc.fileType.toUpperCase())) continue
                useDocs.push(doc)
              }
              this.view.stampPictureView.businessDocuments = useDocs
            }
          })
        }

        company.contractStatus = businessIds.length > 0 ? 2 : 1
        // if (contracts.find(p => dateCompare(p.endDate, now) > 0)) {
        //   company.contractStatus = 2 // 已签约
        // } else {
        //   company.contractStatus = 1 // 合约失效
        // }
      } else {
        company.contractStatus = 0 // 未签约
      }
      const contractState = this.view.contractStatuses[company.contractStatus]
      this.view.contractStatus = company.contractStatus
      this.view.contractStatusLabel = contractState ? contractState.label : ''
      this.view.customerTip = await JobUtils.getCustomerCreditTip(company.cmpIdx, CreditInfoUtil.getJobData(this.view.form))
    })
  }
  // 加载仓库航线关联信息,并初始化仓库下拉框数据
  async loadWarehouseRegion(updateWarehousing = false) {
    const job = this.job
    const openAssociatedRoute = parseInt(this.config.get('AssociatedRoute')) === 1
    if (!job.dischargingPortCode || !openAssociatedRoute) return
    const port = this.seaPortList.find(p => p.code === job.dischargingPortCode)
    if (port) {
      const region = this.regionList.find(p => p.code === port.region)
      if (region && region.warehouseRegions && region.warehouseRegions.length > 0) {
        if (region.warehouseRegions.length === 1) {
          const warehouse = this.companyList.find(p => p.uuid === region.warehouseRegions[0].companyUuid)
          if (warehouse) {
            if (updateWarehousing && job.warehousing) {
              this.warehouseCmpChangeHandler({ value: warehouse.cmpIdx })
            }
          }
        } else {
          if (updateWarehousing && job.warehousing) {
            let defaultWarehouseCompany = null
            const warehouseCompanyList = []
            for (const warehouseRegion of region.warehouseRegions) {
              const warehouseCompany = this.companyList.find(p => p.uuid === warehouseRegion.companyUuid)
              if (warehouseCompany) {
                if (warehouseCompanyList.findIndex(p => p.uuid === warehouseCompany.uuid) < 0) {
                  warehouseCompanyList.push(warehouseCompany)
                }
              }
            }
            if (warehouseCompanyList && warehouseCompanyList.length > 0) {
              for (const warehouseCompany of warehouseCompanyList) {
                await new Company(warehouseCompany).getWarehouseDetail()
                const defaultWarehouse = Company.defaultWarehouse(warehouseCompany)
                if (defaultWarehouse) {
                  defaultWarehouseCompany = warehouseCompany
                  break
                }
              }
              if (!job.warehouseCmp || job.warehouseCmp === 0) {
                if (defaultWarehouseCompany) {
                  await this.warehouseCmpChangeHandler({ value: defaultWarehouseCompany.cmpIdx })
                } else {
                  await this.warehouseCmpChangeHandler({ value: 0 })
                }
              }
            }
          }
        }
      }
    }
  }
  // 唛头修改事件
  async markChangeHandler(value) {
    this.view.showMarkOrCargoEnglishNameDialog = false
    this.job.mark = value
    await this.markBlurHandler()
  }
  // 唛头离开文本框事件
  async markBlurHandler() {
    const seaCargoMark = parseInt(this.config.get('seaCargoMark'))
    if (seaCargoMark !== 1 && seaCargoMark !== 2) return
    const job = this.job
    const oldMark = this.view.oldMark
    const isCopyMbl = LocalStorageUtils.getConfiguration('COPY_MBL_' + job.lob)
    const isCopyHbl = LocalStorageUtils.getConfiguration('COPY_HBL_' + job.lob)
    if (!this.view.showMarkOrCargoEnglishNameDialog && oldMark !== job.mark && this.view.isCopy &&
        ((job.signMBL && isCopyMbl) || (job.signHBL && isCopyHbl))) {
      await this.view.$confirm(this.view.$t('CargoMsg.Cargo_MarkOrCargoEnglishNameChangeTip', [this.view.$t('SeaExport.Marks')]), {
        confirmButtonText: this.view.$t('common.btn.ok'),
        cancelButtonText: this.view.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(async() => {
        this.view.markChange = true
        if (job.signMBL && isCopyMbl) {
          const mblDoc = await new SeaExportJob(job).getCargoDocByDocType(CargoDocConsts.MBL, true)
          if (mblDoc) {
            // 是否太平
            const isTp = String(cache.config.get('ToExoSystem')) === 'TP'
            if (isTp) {
              // 唛头最大字符数
              const sEMarkMaxChars = parseInt(this.config.get('SEMarkMaxChars'))
              mblDoc.mark = JobUtils.splitStringByBrAndLength(job.mark, sEMarkMaxChars, 'r')
            } else {
              mblDoc.mark = job.mark
            }
          }
        }
        if (job.signHBL && isCopyHbl) {
          const hblDoc = await new SeaExportJob(job).getCargoDocByDocType(CargoDocConsts.HBL, true)
          if (hblDoc && hblDoc.state !== 2) {
            hblDoc.mark = job.mark
          }
        }
      }).catch(() => {
      }).finally(() => {
      })
      this.view.oldMark = job.mark
    }
  }
  // 英文品名修改事件
  async cargoEnglishNameChangeHandler(value) {
    this.view.showMarkOrCargoEnglishNameDialog = false
    this.job.cargoEnglishName = value
    await this.cargoEnglishNameBlurHandler()
  }
  // 英文品名离开文本框事件
  async cargoEnglishNameBlurHandler() {
    const seaCargoEnglishName = parseInt(this.config.get('seaCargoEnglishName'))
    if (seaCargoEnglishName !== 1 && seaCargoEnglishName !== 2) return
    const job = this.job
    const oldCargoEnglishName = this.view.oldCargoEnglishName
    const isCopyMbl = LocalStorageUtils.getConfiguration('COPY_MBL_' + job.lob)
    const isCopyHbl = LocalStorageUtils.getConfiguration('COPY_HBL_' + job.lob)
    if (!this.view.showMarkOrCargoEnglishNameDialog && oldCargoEnglishName !== job.cargoEnglishName &&
        this.view.isCopy && ((job.signMBL && isCopyMbl) || (job.signHBL && isCopyHbl))) {
      await this.view.$confirm(this.view.$t('CargoMsg.Cargo_MarkOrCargoEnglishNameChangeTip', [this.view.$t('SeaExport.EnglishDescriptionOfGoods')]), {
        confirmButtonText: this.view.$t('common.btn.ok'),
        cancelButtonText: this.view.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(async() => {
        this.view.cargoEnglishNameChange = true
        if (job.signMBL && isCopyMbl) {
          const mblDoc = await new SeaExportJob(job).getCargoDocByDocType(CargoDocConsts.MBL, true)
          if (mblDoc) {
            // 是否太平
            const isTp = String(cache.config.get('ToExoSystem')) === 'TP'
            if (isTp) {
              // 英文品名最大字符数
              const sEEnglishDescriptionOfGoodsMaxchars = parseInt(this.config.get('SEEnglishDescriptionOfGoodsMaxchars'))
              mblDoc.cargoEnglishName = JobUtils.splitStringByBrAndLength(job.cargoEnglishName, sEEnglishDescriptionOfGoodsMaxchars, 'r')
            } else {
              mblDoc.cargoEnglishName = job.cargoEnglishName
            }
          }
        }
        if (job.signHBL && isCopyHbl) {
          const hblDoc = await new SeaExportJob(job).getCargoDocByDocType(CargoDocConsts.HBL, true)
          if (hblDoc && hblDoc.state !== 2) {
            hblDoc.cargoEnglishName = job.cargoEnglishName
          }
        }
      }).catch(() => {
      }).finally(() => {
      })
      this.view.oldCargoEnglishName = job.cargoEnglishName
    }
  }
  // 计费重量修改
  async chargeWeightChange() {
    this.syncChargeWeightToCharge()
    await this.changeSynBillOfLadingQWC()
  }
  // 计费重量变化，是否同步费用
  syncChargeWeightToCharge() {
    let chargeFlag = false
    for (const charge of this.job.charges) {
      if (!charge.confirmBillUuid && charge.measure === ChargeMeasure.WGTX_CHARGE_MEASURE.code &&
          !charge.invoiceUuid && !charge.billingUuid && !charge.billingPaymentUuid &&
          !charge.verifiedAmount && !charge.diffChargeUuid && charge.chargeSource !== CHARGE_SOURCE_SPLIT.code && !charge.paidOff && charge.chargeState === 0 && !charge.relatedMbl &&
          ((charge.receivable && this.job.receivableChargeLockedStatus === 0) || (!charge.receivable && this.job.payableChargeLockedStatus === 0)) &&
          !(String(cache.config.get('ToExoSystem')) === 'XYCW' && this.job.lob === 'SE' && BillType.MERGE_BILL_TYPE.code === this.job.typeHBL)) {
        chargeFlag = true
        break
      }
    }
    if (chargeFlag) {
      this.view.$confirm(this.view.$t('Message.TheChargedWeightHasBeenChangedThoseInvoicedAndBilledChargesWillNotBeUpdated'), {
        confirmButtonText: this.view.$t('common.btn.ok'),
        cancelButtonText: this.view.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        const charges = []
        for (const charge of this.job.charges) {
          if (!charge.confirmBillUuid && charge.measure === ChargeMeasure.WGTX_CHARGE_MEASURE.code &&
              !charge.invoiceUuid && !charge.billingUuid && !charge.billingPaymentUuid && !charge.diffChargeUuid && charge.chargeSource !== CHARGE_SOURCE_SPLIT.code &&
              !charge.verifiedAmount && !charge.paidOff && charge.chargeState === 0 &&
              ((charge.receivable && this.job.receivableChargeLockedStatus === 0) || (!charge.receivable && this.job.payableChargeLockedStatus === 0)) &&
              !(String(cache.config.get('ToExoSystem')) === 'XYCW' && this.job.lob === 'SE' && BillType.MERGE_BILL_TYPE.code === this.job.typeHBL)) {
            charge.quantity = this.job.chargeWeight
            if (charge.unitPriceIncludeTax) {
              ChargeUtils.calculateTaxAmount(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
            } else {
              ChargeUtils.calculateTax(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
            }
            charges.push(charge)
          }
        }
        if (charges && charges.length > 0) {
          this.context.modifiedData.charges = this.context.modifiedData.charges || []
          mergeArray(this.context.modifiedData.charges, charges)
        }
      }).catch(() => {
      }).finally(() => {
      })
    }
  }
  // 前置仓
  async backUpWarehouseCmpChangeHandler(data) {
    const job = this.job
    job.backUpWarehouseCmp = data.value || 0
    job.backUpWarehouseRecord = job.backUpWarehouseCmp
    if (!job.backUpWarehouseInfo || job.backUpWarehouseInfo.length === 0) {
      const newData = new BackUpWarehouseInfo().fillDefaultValue().getData()
      newData.jobUuid = job.uuid
      job.backUpWarehouseInfo = []
      job.backUpWarehouseInfo.push(newData)
    }
    await this.getBackUpWarehouseInfo()
    const warehouse = job.backUpWarehouseInfo[0]
    warehouse.warehouseCmp = job.backUpWarehouseCmp
    if (warehouse.warehouseCmp && warehouse.warehouseCmp > 0) warehouse.deleted = false
    this.addBackUpWarehouseToModifiedSet(warehouse)
  }
  addBackUpWarehouseToModifiedSet(warehouse) {
    const modifiedData = this.context.modifiedData
    if (modifiedData) {
      modifiedData.backUpWarehouseInfo = modifiedData.backUpWarehouseInfo || []
      if (!modifiedData.backUpWarehouseInfo.includes(warehouse)) {
        modifiedData.backUpWarehouseInfo.push(warehouse)
      }
    }
  }
  // 前置仓修改事件
  backUpWarehouseChange() {
    const job = this.job
    if (!job.backUpWarehouse) {
      job.backUpWarehouseCmp = 0
      if (job.backUpWarehouseInfo && job.backUpWarehouseInfo.length > 0) {
        for (const item of job.backUpWarehouseInfo) {
          if (item.uuid) {
            item.jobUuid = ''
            item.deleted = true
            this.addBackUpWarehouseToModifiedSet(item)
          } else {
            this.removeBuckUpWarehouseFromModifiedSet(item)
          }
        }
      }
    }
  }
  otherServiceChange() {
    const job = this.job
    if (!job.otherService) {
      job.otherRemark = ''
    }
  }
  // 将backUpWarehouseInfo从被修改的集合中移除
  removeBuckUpWarehouseFromModifiedSet(backUpWarehouseInfo) {
    const modifiedData = this.context.modifiedData
    if (modifiedData.backUpWarehouseInfo && modifiedData.backUpWarehouseInfo.includes(backUpWarehouseInfo)) {
      const index = modifiedData.backUpWarehouseInfo.indexOf(backUpWarehouseInfo)
      if (index > -1) {
        modifiedData.backUpWarehouseInfo.splice(index, 1)
      }
    }
  }
  //
  async loadBackUpWarehouseCompany() {
    this.view.backUpWarehouseCompanyList = []
    const companyList = []
    await getBackUpWarehouseCompany().then(res => {
      if (res.data && res.data.length > 0) {
        for (const company of res.data) {
          if (company.branchId === 1 || company.branchId === this.view.$store.getters.currentOfficeId) {
            companyList.push(company)
          }
        }
      }
    }).catch().finally()
    if (companyList.length > 0) {
      this.view.backUpWarehouseCompanyList = companyList
    }
  }
  /**
   * 加载job前置仓库信息
   */
  loadBackUpWarehouseCmp() {
    const job = this.job
    if (job.backUpWarehouseInfo != null && job.backUpWarehouseInfo.length > 0) {
      job.backUpWarehouseCmp = job.backUpWarehouseInfo[0].warehouseCmp
    } else {
      job.backUpWarehouseCmp = 0
    }
  }
  async virtualHblChange() {
    if (!this.job.virtualHBL) {
      let hasSubBill = false
      const cargoDocs = await new SeaExportJob(this.job).getSeaCargoDoc()
      if (cargoDocs && cargoDocs.length > 0) {
        for (const cargoDoc of cargoDocs) {
          if (cargoDoc.docType === CargoDocConsts.HAWB2 && !cargoDoc.deleted) {
            hasSubBill = true
            break
          }
        }
      }
      if (hasSubBill) {
        this.view.$message.warning(this.view.$t('SeaExport.CancelFormalHblTips'))
        this.job.virtualHBL = true
      }
    }
  }
  // 自定义岗位字段1
  async userDefinedRoleId1Handler(data) {
    const job = this.job
    job.userDefinedRoleId1 = data.value || 0
    job.userDefinedRoleDept1 = 0
    job.userDefinedRoleOffice1 = 0
    if (data.value) {
      const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole1', data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            this.job.userDefinedRoleDept1 = item.departmentId
            const office = await Office.getOfficeById(item.officeId)
            job.userDefinedRoleOffice1 = office ? office.officeId : 0
            break
          }
        }
      } else {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'userDefinedRole1')
        job.userDefinedRoleDept1 = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        job.userDefinedRoleOffice1 = office ? office.officeId : 0
      }
    }
  }
  // 自定义岗位字段2
  async userDefinedRoleId2Handler(data) {
    const job = this.job
    job.userDefinedRoleId2 = data.value || 0
    job.userDefinedRoleDept2 = 0
    job.userDefinedRoleOffice2 = 0
    if (data.value) {
      const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole2', data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            this.job.userDefinedRoleDept2 = item.departmentId
            const office = await Office.getOfficeById(item.officeId)
            job.userDefinedRoleOffice2 = office ? office.officeId : 0
            break
          }
        }
      } else {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'userDefinedRole2')
        job.userDefinedRoleDept2 = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        job.userDefinedRoleOffice2 = office ? office.officeId : 0
      }
    }
  }
  // 自定义岗位字段3
  async userDefinedRoleId3Handler(fieldData) {
    const value = fieldData.value
    // if (!$store.getters.enableFrontEndPlugin) {
    //   value = fieldData.value
    // }
    const job = this.job
    job.userDefinedRoleId3 = value || 0
    job.userDefinedRoleDept3 = 0
    job.userDefinedRoleOffice3 = 0
    if (value) {
      const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole3', value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            job.userDefinedRoleDept3 = item.departmentId
            const office = await Office.getOfficeById(item.officeId)
            job.userDefinedRoleOffice3 = office ? office.officeId : 0
            break
          }
        }
      } else {
        const user = new User(fieldData) // !$store.getters.enableFrontEndPlugin ? new User(fieldData) : new User({ value })
        const dep = await user.getDefaultDepartment('role', 'userDefinedRole3')
        job.userDefinedRoleDept3 = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        job.userDefinedRoleOffice3 = office ? office.officeId : 0
      }
    }
  }
  // 自定义岗位字段4
  async userDefinedRoleId4Handler(fieldData) {
    const value = fieldData.value
    // if (!$store.getters.enableFrontEndPlugin) {
    //   value = fieldData.value
    // }
    const job = this.job
    job.userDefinedRoleId4 = value || 0
    job.userDefinedRoleDept4 = 0
    job.userDefinedRoleOffice4 = 0
    if (value) {
      const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole4', value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            job.userDefinedRoleDept4 = item.departmentId
            const office = await Office.getOfficeById(item.officeId)
            job.userDefinedRoleOffice4 = office ? office.officeId : 0
            break
          }
        }
      } else {
        const user = new User(fieldData) // !$store.getters.enableFrontEndPlugin ? new User(fieldData) : new User({ value })
        const dep = await user.getDefaultDepartment('role', 'userDefinedRole4')
        job.userDefinedRoleDept4 = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        job.userDefinedRoleOffice4 = office ? office.officeId : 0
      }
    }
  }
  // 自定义岗位字段5
  async userDefinedRoleId5Handler(data) {
    const job = this.job
    job.userDefinedRoleId5 = data.value || 0
    job.userDefinedRoleDept5 = 0
    job.userDefinedRoleOffice5 = 0
    if (data.value) {
      const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole5', data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            this.job.userDefinedRoleDept5 = item.departmentId
            const office = await Office.getOfficeById(item.officeId)
            job.userDefinedRoleOffice5 = office ? office.officeId : 0
            break
          }
        }
      } else {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'userDefinedRole5')
        job.userDefinedRoleDept5 = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        job.userDefinedRoleOffice5 = office ? office.officeId : 0
      }
    }
  }
  // 自定义岗位字段6
  async userDefinedRoleId6Handler(data) {
    const job = this.job
    job.userDefinedRoleId6 = data.value || 0
    job.userDefinedRoleDept6 = 0
    job.userDefinedRoleOffice6 = 0
    if (data.value) {
      const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole6', data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            this.job.userDefinedRoleDept6 = item.departmentId
            const office = await Office.getOfficeById(item.officeId)
            job.userDefinedRoleOffice6 = office ? office.officeId : 0
            break
          }
        }
      } else {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'userDefinedRole6')
        job.userDefinedRoleDept6 = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        job.userDefinedRoleOffice6 = office ? office.officeId : 0
      }
    }
  }
  // 自定义岗位字段7
  async userDefinedRoleId7Handler(data) {
    const job = this.job
    job.userDefinedRoleId7 = data.value || 0
    job.userDefinedRoleDept7 = 0
    job.userDefinedRoleOffice7 = 0
    if (data.value) {
      const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole7', data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            this.job.userDefinedRoleDept7 = item.departmentId
            const office = await Office.getOfficeById(item.officeId)
            job.userDefinedRoleOffice7 = office ? office.officeId : 0
            break
          }
        }
      } else {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'userDefinedRole7')
        job.userDefinedRoleDept7 = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        job.userDefinedRoleOffice7 = office ? office.officeId : 0
      }
    }
  }
  // 起运港变更
  async loadingPortCodeChange(p) {
    this.view.loadingPortChanged = false
    if (this.job.usCustomsClearance && this.job.loadingPortCode && p.value && p.value !== this.job.loadingPortCode) {
      this.view.loadingPortChanged = true
      this.job.loadingPortCode = p.value
      if (!this.job.usCustomsClearanceList || this.job.usCustomsClearanceList.length === 0) {
        await new SeaExportJob(this.job).getUsCustomsClearanceList()
      }
      JobUtils.updateUsCustomsClearanceList(this.job)
    }
    super.loadingPortCodeChange(p)
    JobUtils.matchUserPortConfig(this.view, this.job)
    JobUtils.matchRegionWarehouseMappingConfig(this.job, warehouseId => this.warehouseCmpChangeHandler({ value: warehouseId }), false, null, this.context.modifiedData)
    JobUtils.loadingShipDate(this.job)
  }

  /**
   * CARGO-30747 空运出口，在基本页面收发通输入内容后，可以同步到HAWB页面
   * 同步提单收发通
   * 业务选择【直单】时：基本页签收发通 同步 到 MBL页签收发通
   * 业务不是直单时：基本页签收发通 同步到 HBL页签收发通
   * ※注意如果HBL锁定了，不同步数据
   * @returns {Promise<void>}
   */
  async syncDocSft(shipper = false, consignee = false, notify = false) {
    const job = this.job
    if (job.containerLoadType === 'BCF') return
    if (job.jobState === -1) {
      return
    }
    if (job.mblOnly) {
      // 勾选直单
      const mblDoc = await new Job(job).getCargoDocByDocType(CargoDocConsts.MBL, false)
      if (mblDoc) {
        if (shipper) new SeaCargoDoc(mblDoc).copyBasicShipper(job, true)
        if (consignee) new SeaCargoDoc(mblDoc).copyBasicConsignee(job, true)
        if (notify) new SeaCargoDoc(mblDoc).copyBasicNotify(job, true)
      }
    } else {
      // 不勾选直单
      if (job.signHBL) {
        const hblDoc = await new Job(job).getCargoDocByDocType(CargoDocConsts.HBL, false)
        if (hblDoc) {
          // 如果HBL锁定了，不同步数据
          const printHblZbLock = (hblDoc.state === 2 && Number(this.config.get('HBLPrintLockTab')) === 1)
          if (printHblZbLock) return
          if (shipper) new SeaCargoDoc(hblDoc).copyBasicShipper(job, true)
          if (consignee) new SeaCargoDoc(hblDoc).copyBasicConsignee(job, true)
          if (notify) new SeaCargoDoc(hblDoc).copyBasicNotify(job, true)
        }
      }
    }
  }
  // 验证是否存在相同进仓编号的业务
  checkWarehouseNo() {
    selectWarehouseNoExist({ warehouseNo: this.job.warehouseNo, lob: this.job.lob, jobUuid: this.job.uuid }).then(res => {
      if (res.data > 0) {
        this.view.warehouseNoRed = true
      } else {
        this.view.warehouseNoRed = false
      }
    })
  }
  // 修改二程信息
  updateSecondVesselInfo() {
    const job = this.job
    // 当勾选中转港的时候录入【中转港与卸货港值】才能同步到【海运二程信息中的起运港、目的港中】，如果没有勾选中转港那么就不需要同步。
    if (job.transfering && job.transferPortCode && job.dischargingPortCode) {
      const transferPort = getObjectByCache(basicCacheKeys.basic_data_Seaport, 'code', job.transferPortCode)
      if (transferPort) {
        job.secondPol = transferPort.englishName || ''
      }
      const dischargingPort = getObjectByCache(basicCacheKeys.basic_data_Seaport, 'code', job.dischargingPortCode)
      if (dischargingPort) {
        job.secondPod = dischargingPort.englishName || ''
      }
    }
  }

  async checkCustomerRefNo() {
    const count = await SeaExportJob.isExistCustomerRefNo(this.context.office.officeId, 'SE', this.job.customerRefNo, this.job.uuid)
    if (count > 0) {
      return true
    }
    return false
  }

  async cargoSalesChargeHandler(data) {
    const job = this.job
    job.cargoSalesId = data.value || 0
    job.cargoSalesDepartment = 0
    job.cargoSalesOffice = 0
    if (data.value) {
      const offices = await User.getUserDepartmentOffices('role', 'salesOfGoods', data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            const office = await Office.getOfficeById(item.officeId)
            job.cargoSalesOffice = office ? office.officeId : 0
            job.cargoSalesDepartment = item.departmentId
            break
          }
        }
      } else {
        const user = new User(data)
        const department = await user.getDefaultDepartment('role', 'salesOfGoods')
        if (department) {
          job.cargoSalesDepartment = department ? department.departmentId : 0
          const office = department ? await Office.getOfficeByUuid(department.officeUuid) : null
          job.cargoSalesOffice = office ? office.officeId : 0
        }
      }
    }
  }

  // HS CODE 修改事件
  async hsCodeChangeHandler(value) {
    const job = this.job
    job.hsCode = value
    const seHsCodeMode = this.config ? Number(this.config.get('SEHSCodeMode')) : 0
    console.log(`[HS_SYNC][BookingFCLPM] change job.hsCode="${job.hsCode || ''}" mode=${seHsCodeMode} signMBL=${!!job.signMBL} signHBL=${!!job.signHBL}`)
    if (job.signMBL) {
      const mblDoc = await new SeaExportJob(job).getCargoDocByDocType(CargoDocConsts.MBL, false)
      const shouldSyncMbl = mblDoc && shouldSyncDocHsCodeFromJob({ seHsCodeMode, currentDocHsCode: mblDoc.hsCode })
      console.log(`[HS_SYNC][BookingFCLPM] MBL current="${(mblDoc && mblDoc.hsCode) || ''}" shouldSync=${!!shouldSyncMbl}`)
      if (shouldSyncMbl) {
        mblDoc.hsCode = job.hsCode
        console.log(`[HS_SYNC][BookingFCLPM] MBL updated to "${mblDoc.hsCode || ''}"`)
      }
    }
    if (job.signHBL) {
      const hblDoc = await new SeaExportJob(job).getCargoDocByDocType(CargoDocConsts.HBL, false)
      const shouldSyncHbl = (
        hblDoc &&
        hblDoc.state !== 2 &&
        shouldSyncDocHsCodeFromJob({ seHsCodeMode, currentDocHsCode: hblDoc.hsCode })
      )
      console.log(`[HS_SYNC][BookingFCLPM] HBL current="${(hblDoc && hblDoc.hsCode) || ''}" state=${hblDoc ? hblDoc.state : ''} shouldSync=${!!shouldSyncHbl}`)
      if (
        shouldSyncHbl
      ) {
        hblDoc.hsCode = job.hsCode
        console.log(`[HS_SYNC][BookingFCLPM] HBL updated to "${hblDoc.hsCode || ''}"`)
      }
    }
  }

  // CARGO-41312 集翊达：人员岗位带出逻辑调整，托书识别的销售逻辑处理
  // 智能托书生成订单-委托单位带出销售和揽货销售
  async loadCompanyUserForSalesAndCargoSales() {
    if (!this.isSpecifiedSalesBusiness || !this.job.customerId) return
    const company = this.companyList.find(p => p.cmpIdx === this.job.customerId)
    if (!company) return
    const companyUsers = await Company.getCompanyUsers(company.uuid)
    if (!companyUsers || companyUsers.length <= 0) {
      return
    }
    const job = this.job
    // 销售
    const salesList = []
    let salesDefaultId = 0
    // 揽货销售
    const cargoSalesList = []
    let cargoSalesId = 0
    // 如果开启分公司过滤参数，查出来所有分公司
    let officeSaleList
    if (this.salesOfficeCheck) {
      officeSaleList = await User.getUsersByPrivilegeDetail('role', 'sales', '', this.view.$store.getters.currentOfficeId)
    }
    officeSaleList = officeSaleList || []
    if (companyUsers && companyUsers.length > 0) {
      for (const u of companyUsers) {
        const userValid = job.fba ? u.lob === SystemConstants.FBA_SE.code : u.lob === job.lob
        if (!u.lob || userValid || u.lob === 'ALL') {
          const user = this.userList.find(p => p.userId === u.userId)
          if (user && user.active) {
            if (u.roleType === CargoOfRoleType.SALES_TYPE.code) { // 销售
              if (this.salesOfficeCheck) {
                for (const obj of officeSaleList) {
                  if (user.userId === obj.userId) {
                    if (u.defaultUser) {
                      salesDefaultId = u.userId
                    }
                    salesList.push(user)
                  }
                }
              } else {
                if (u.defaultUser) {
                  salesDefaultId = u.userId
                }
                salesList.push(user)
              }
            } else if (u.roleType === CargoOfRoleType.SALES_OF_GOODS.code) { // 揽货销售
              if (u.defaultUser) {
                cargoSalesId = u.userId
              }
              cargoSalesList.push(user)
            }
          }
        }
      }
    }
    // 销售
    this.view.salesList = salesList
    this.getTxtSalesPrompt()
    if (salesList.length > 0) {
      if (salesDefaultId > 0) {
        job.sales = salesDefaultId
      } else {
        job.sales = salesList[0].userId
      }
      this.view.$nextTick(() => {
        const user = this.userList.find(p => p.userId === job.sales)
        this.salesChangeHandler({ ...user, value: user.userId })
      })
    } else {
      job.sales = 0
      job.salesDepartment = 0
      this.view.txtSalesOffice = ''
      job.salesOffice = 0
    }
    // 揽货销售
    if (cargoSalesList.length > 0) {
      if (cargoSalesId > 0) {
        job.cargoSalesId = cargoSalesId
      } else {
        job.cargoSalesId = cargoSalesList[0].userId
      }
      this.view.$nextTick(() => {
        const user = this.userList.find(p => p.userId === job.cargoSalesId)
        this.cargoSalesChargeHandler({ ...user, value: user.userId })
      })
    }
  }

  async customerIdChangeJobPropertiesHandler(cmpIdx, source) {
    this.job.customerContact = ''
    this.job.editCftMode = false
    if (this.job.customerId && parseInt(this.job.customerId) > 0) {
      this.job.preCustomerId = this.job.customerId
    }
    if (!cmpIdx) {
      this.job.customerId = 0
      if (this.job.cargoSource !== CargoSource.NC_CARGO_SOURCE.code) {
        this.job.sales = ''// 销售
        this.job.salesOffice = 0
        this.view.txtSalesOffice = ''
        // 如果开启分公司过滤参数，查出来所有分公司
        if (source === BRING_OUT_LOGIC_CALL_SOURCE_OCR.code) {
          this.view.jobViewInfoMap.get(this.job.index).salesList = await JobUtils.getOfficeSaleList()
          const copiedMap = new Map()
          this.view.jobViewInfoMap.forEach((value, key) => {
            copiedMap.set(key, value)
          })
          this.view.jobViewInfoMap = copiedMap
        } else {
          this.view.salesList = await JobUtils.getOfficeSaleList()
        }
      }
      return
    }
  }
}
